import React, {
  useCallback,
  useEffect,
  useMemo,
  useState,
} from "react";

const API_BASE =
  "https://panel.haymestasarim.com/api/is-agi";

const ALLOWED_LANGS = ["tr", "en", "de"];

/* =========================================================
   DİL METİNLERİ
========================================================= */

const TEXT = {
  tr: {
    title: "Üye İş Ağı ve CRM",
    subtitle:
      "Üyeleri, sektörleri, iş fırsatlarını ve kurumlar arası iş birliğini tek merkezden yönetin.",

    dashboard: "Genel Bakış",
    members: "Üyeler",
    network: "İş Ağı",
    jobs: "İş Talepleri",
    catalogs: "Sektör ve Hizmetler",
    settings: "Ayarlar",


myProfile: "Kendi İş Profilim",
businessIdentity: "KENDİ İŞ PROFİLİM",
profilePageDescription:
  "Kendi meslek, işletme ve hizmet profilinizi yönetin.",

optionalProfileTitle:
  "Bu alan isteğe bağlıdır",

optionalProfileText:
  "Dernek yöneticisi olarak üyeleri Üyeler sekmesinden yönetirsiniz. Bu formu yalnızca siz veya firmanız iş ağında görünmek, iş almak ya da teklif vermek istiyorsa doldurun.",

managerProfileControl:
  "Bu hesabın iş ağı onayını ve üyelik durumunu buradan yönetebilirsiniz.",

approveNetwork:
  "Onayla ve Ağa Ekle",

removeFromNetwork:
  "İş Ağından Çıkar",

reactivateNetwork:
  "Yeniden Aktif Et",

confirmRemoveFromNetwork:
  "Bu profili iş ağından çıkarmak istiyor musunuz? Kayıt silinmeyecek, yalnızca iş ağı görünürlüğü kapatılacaktır.",

actionReason:
  "İşlem nedenini yazın:",

networkStatusUpdated:
  "İş ağı durumu güncellendi.",

    refresh: "Yenile",
    loading: "Veriler yükleniyor…",
    retry: "Tekrar Dene",
    search: "Ara",
    clear: "Temizle",
    all: "Tümü",
    save: "Kaydet",
    update: "Güncelle",
    cancel: "Vazgeç",
    close: "Kapat",
    details: "Detay",
    edit: "Düzenle",
    deactivate: "Pasifleştir",

    approve: "Onayla",
    reject: "Reddet",
    suspend: "Askıya Al",

    active: "Aktif",
    passive: "Pasif",
    pending: "Beklemede",
    approved: "Onaylandı",
    rejected: "Reddedildi",
    suspended: "Askıda",
    frozen: "Dondurulmuş",
    left: "Ayrılmış",

    featured: "Öne Çıkan",
    verified: "Doğrulanmış",

    totalMembers: "Toplam Üye",
    activeMembers: "Aktif Üye",
    pendingMembers: "Onay Bekleyen",
    openJobs: "Açık İş Talebi",
    completedJobs: "Tamamlanan İş",
    pendingOffers: "Bekleyen Teklif",
    profileViews: "Profil Görüntüleme",
    profileCompletion:
      "Ortalama Profil Doluluğu",

    assistant: "Yönetici Asistanı",
    noSuggestion:
      "Şu anda önemli bir uyarı bulunmuyor.",

    upcomingBirthdays:
      "Yaklaşan Doğum Günleri",

    topMembers: "Öne Çıkan Üyeler",
    cityDistribution: "Şehir Dağılımı",
    sectorDistribution: "Sektör Dağılımı",

    noData: "Henüz kayıt bulunmuyor.",

    memberSearch:
      "Ad, firma, meslek, telefon veya e-posta ara",

    status: "Durum",
    membership: "Üyelik",
    city: "İl",
    district: "İlçe",
    sector: "Sektör",
    service: "Hizmet",
    company: "Firma",
    profession: "Meslek",
    phone: "Telefon",
    whatsapp: "WhatsApp",
    email: "E-posta",
    address: "Adres",
    about: "Hakkında",

    products:
      "Sunduğu Ürün ve Hizmetler",

    needs: "Aradığı Hizmetler",

    partnership:
      "İş Birliği Açıklaması",

    memberCode: "Üye Kodu",
    membershipNo: "Dernek Üyelik No",
    completion: "Profil Doluluğu",

    manageMember: "Üyeyi Yönet",

    rejectionReason:
      "Ret / Askı Nedeni",

    profileVisible: "Profil Görünür",

    platformVisible:
      "Türkiye Geneli Görünür",

    makeFeatured:
      "Öne Çıkan Üye",

    makeVerified:
      "Doğrulanmış Üye",

    memberUpdated:
      "Üye durumu güncellendi.",

    networkSearch:
      "Üye, firma, meslek, sektör veya hizmet ara",

    institutionNetwork: "Kurum İçi",
    platformNetwork: "Türkiye Geneli",

    favorite: "Favoriye Ekle",
    unfavorite: "Favoriden Çıkar",

    favoriteAdded:
      "Üye favorilere eklendi.",

    favoriteRemoved:
      "Üye favorilerden çıkarıldı.",

    ratings: "Değerlendirmeler",

    completedWork:
      "Tamamlanan İş",

    viewProfile: "Profili Gör",

    jobSearch:
      "İş başlığı, açıklama, firma veya hizmet ara",

    addJob: "Yeni İş Talebi",
    jobTitle: "İş Başlığı",
    description: "Açıklama",

    minBudget: "Minimum Bütçe",
    maxBudget: "Maksimum Bütçe",
    currency: "Para Birimi",

    offerDeadline:
      "Son Teklif Tarihi",

    startDate: "Başlangıç Tarihi",
    endDate: "Bitiş Tarihi",
    visibility: "Görünürlük",

    institutionOnly:
      "Sadece Kurum",

    wholePlatform:
      "Türkiye Geneli",

    phoneContact:
      "Telefonla İletişim",

    whatsappContact:
      "WhatsApp ile İletişim",

    inAppContact:
      "Uygulama İçi İletişim",

    createJob:
      "İş Talebini Yayınla",

    jobCreated:
      "İş talebi oluşturuldu.",

    jobUpdated:
      "İş talebi güncellendi.",

    jobCancelled:
      "İş talebi iptal edildi.",

    offers: "Teklifler",
    noOffer:
      "Henüz teklif bulunmuyor.",

    offerAmount: "Teklif Tutarı",
    estimatedDays: "Tahmini Gün",
    offerMessage: "Teklif Mesajı",

    accept: "Kabul Et",
    decline: "Reddet",
    review: "İncelemede",
    withdraw: "Geri Çek",

    completeJob: "İşi Tamamla",
    jobCompleted: "İş tamamlandı.",

    catalogInfo:
      "Ana sektörleri, alt sektörleri ve hizmetleri yönetin.",

    mainSectors: "Ana Sektörler",
    subSectors: "Alt Sektörler",
    services: "Hizmetler",

    addSector: "Sektör Ekle",
    addService: "Hizmet Ekle",

    sectorNameTr:
      "Türkçe Sektör Adı",

    sectorNameEn:
      "İngilizce Sektör Adı",

    sectorNameDe:
      "Almanca Sektör Adı",

    serviceNameTr:
      "Türkçe Hizmet Adı",

    serviceNameEn:
      "İngilizce Hizmet Adı",

    serviceNameDe:
      "Almanca Hizmet Adı",

    parentSector: "Üst Sektör",
    icon: "İkon",
    color: "Renk",
    order: "Sıra",

    catalogSaved:
      "Katalog kaydedildi.",

    catalogDisabled:
      "Kayıt pasifleştirildi.",

    settingsInfo:
      "Kurumun iş ağı görünürlüğünü ve kullanım yetkilerini yönetin.",

    internalNetworkActive:
      "Kurum İçi İş Ağı",

    crossInstitutionActive:
      "Kurumlar Arası İş Ağı",

    managerApprovalRequired:
      "Yönetici Onayı Zorunlu",

    autoPublishMember:
      "Üyeyi Otomatik Yayınla",

    phoneCanShow:
      "Telefon Gösterilebilir",

    whatsappCanShow:
      "WhatsApp Gösterilebilir",

    emailCanShow:
      "E-posta Gösterilebilir",

    jobsActive:
      "İş Talebi Aktif",

    offersActive:
      "Teklif Sistemi Aktif",

    referencesActive:
      "Değerlendirme Aktif",

    favoritesActive:
      "Favoriler Aktif",

    viewsActive:
      "Profil Görüntüleme Sayacı",

    assistantActive:
      "Yönetici Asistanı",

    defaultVisibility:
      "Varsayılan Profil Görünürlüğü",

    hidden: "Gizli",

    settingsSaved:
      "Ayarlar kaydedildi.",

    profileInfo:
      "Kendi üyelik ve firma profilinizi düzenleyin.",

    firstName: "Ad",
    lastName: "Soyad",
    birthDate: "Doğum Tarihi",
    titleField: "Unvan",
    companyTitle: "Firma Ünvanı",
    companyPhone: "Firma Telefonu",
    companyEmail: "Firma E-postası",
    website: "Web Sitesi",
    instagram: "Instagram",
    facebook: "Facebook",
    linkedin: "LinkedIn",
    youtube: "YouTube",

    profilePhoto:
      "Profil Fotoğrafı URL",

    coverPhoto:
      "Kapak Fotoğrafı URL",

    companyLogo:
      "Firma Logosu URL",

    freeCity: "Serbest İl Adı",
    freeDistrict: "Serbest İlçe Adı",

    keywords: "Anahtar Kelimeler",

    serviceArea:
      "Hizmet Bölgesi Açıklaması",

    nationwide:
      "Türkiye Geneli Hizmet",

    phoneVisible:
      "Telefonum Görünsün",

    whatsappVisible:
      "WhatsApp Görünsün",

    emailVisible:
      "E-postam Görünsün",

    addressVisible:
      "Adresim Görünsün",

    selectedSectors:
      "Seçili Sektörler",

    selectedServices:
      "Seçili Hizmetler",

    profileSaved:
      "Profil kaydedildi.",

    profileWaiting:
      "Profiliniz yönetici onayı bekliyor.",

    profileRequired:
      "Bu işlem için önce profilinizi tamamlayın.",

    requiredFields:
      "Zorunlu alanları doldurun.",

    confirmDeactivate:
      "Bu kaydı pasifleştirmek istediğinize emin misiniz?",

    confirmCancelJob:
      "Bu iş talebini iptal etmek istediğinize emin misiniz?",

    confirmCompleteJob:
      "Bu işi tamamlandı olarak işaretlemek istediğinize emin misiniz?",

    apiError:
      "İşlem sırasında bir hata oluştu.",

    unauthorized:
      "Bu bölüm için yönetici yetkisi gerekiyor.",

    previous: "Önceki",
    next: "Sonraki",
    page: "Sayfa",
    record: "kayıt",
    today: "Bugün",
  },

  en: {
    title: "Member Business Network & CRM",

    subtitle:
      "Manage members, sectors, business opportunities and inter-institution collaboration from one center.",

    dashboard: "Overview",
    members: "Members",
    network: "Business Network",
    jobs: "Job Requests",
    catalogs: "Sectors & Services",
    settings: "Settings",
myProfile: "My Business Profile",
businessIdentity: "MY BUSINESS PROFILE",
profilePageDescription:
  "Manage your personal, company and service profile.",

optionalProfileTitle:
  "This section is optional",

optionalProfileText:
  "As an association manager, you manage members from the Members section. Complete this form only when you or your company should appear in the business network, receive work or submit offers.",

managerProfileControl:
  "Manage this account's network approval and membership status here.",

approveNetwork:
  "Approve and Add to Network",

removeFromNetwork:
  "Remove from Network",

reactivateNetwork:
  "Reactivate",

confirmRemoveFromNetwork:
  "Remove this profile from the business network? The record will not be deleted; only its network visibility will be disabled.",

actionReason:
  "Enter the reason for this action:",

networkStatusUpdated:
  "Business network status updated.",

    refresh: "Refresh",
    loading: "Loading data…",
    retry: "Try Again",
    search: "Search",
    clear: "Clear",
    all: "All",
    save: "Save",
    update: "Update",
    cancel: "Cancel",
    close: "Close",
    details: "Details",
    edit: "Edit",
    deactivate: "Deactivate",

    approve: "Approve",
    reject: "Reject",
    suspend: "Suspend",

    active: "Active",
    passive: "Passive",
    pending: "Pending",
    approved: "Approved",
    rejected: "Rejected",
    suspended: "Suspended",
    frozen: "Frozen",
    left: "Left",

    featured: "Featured",
    verified: "Verified",

    totalMembers: "Total Members",
    activeMembers: "Active Members",
    pendingMembers: "Pending Approval",
    openJobs: "Open Job Requests",
    completedJobs: "Completed Jobs",
    pendingOffers: "Pending Offers",
    profileViews: "Profile Views",

    profileCompletion:
      "Average Profile Completion",

    assistant: "Manager Assistant",

    noSuggestion:
      "There are no important alerts right now.",

    upcomingBirthdays:
      "Upcoming Birthdays",

    topMembers: "Top Members",
    cityDistribution: "City Distribution",
    sectorDistribution:
      "Sector Distribution",

    noData: "No records yet.",

    memberSearch:
      "Search name, company, profession, phone or email",

    status: "Status",
    membership: "Membership",
    city: "City",
    district: "District",
    sector: "Sector",
    service: "Service",
    company: "Company",
    profession: "Profession",
    phone: "Phone",
    whatsapp: "WhatsApp",
    email: "Email",
    address: "Address",
    about: "About",

    products:
      "Products and Services",

    needs: "Requested Services",

    partnership:
      "Partnership Description",

    memberCode: "Member Code",

    membershipNo:
      "Association Membership No",

    completion:
      "Profile Completion",

    manageMember:
      "Manage Member",

    rejectionReason:
      "Rejection / Suspension Reason",

    profileVisible:
      "Profile Visible",

    platformVisible:
      "Visible Nationwide",

    makeFeatured:
      "Featured Member",

    makeVerified:
      "Verified Member",

    memberUpdated:
      "Member status updated.",

    networkSearch:
      "Search member, company, profession, sector or service",

    institutionNetwork:
      "Institution",

    platformNetwork:
      "Nationwide",

    favorite: "Add Favorite",
    unfavorite: "Remove Favorite",

    favoriteAdded:
      "Member added to favorites.",

    favoriteRemoved:
      "Member removed from favorites.",

    ratings: "Reviews",

    completedWork:
      "Completed Work",

    viewProfile:
      "View Profile",

    jobSearch:
      "Search job title, description, company or service",

    addJob: "New Job Request",
    jobTitle: "Job Title",
    description: "Description",

    minBudget: "Minimum Budget",
    maxBudget: "Maximum Budget",
    currency: "Currency",

    offerDeadline:
      "Offer Deadline",

    startDate: "Start Date",
    endDate: "End Date",
    visibility: "Visibility",

    institutionOnly:
      "Institution Only",

    wholePlatform:
      "Nationwide",

    phoneContact:
      "Phone Contact",

    whatsappContact:
      "WhatsApp Contact",

    inAppContact:
      "In-App Contact",

    createJob:
      "Publish Job Request",

    jobCreated:
      "Job request created.",

    jobUpdated:
      "Job request updated.",

    jobCancelled:
      "Job request cancelled.",

    offers: "Offers",
    noOffer: "No offers yet.",

    offerAmount: "Offer Amount",
    estimatedDays: "Estimated Days",
    offerMessage: "Offer Message",

    accept: "Accept",
    decline: "Decline",
    review: "In Review",
    withdraw: "Withdraw",

    completeJob: "Complete Job",
    jobCompleted: "Job completed.",

    catalogInfo:
      "Manage main sectors, sub-sectors and services.",

    mainSectors: "Main Sectors",
    subSectors: "Sub-Sectors",
    services: "Services",

    addSector: "Add Sector",
    addService: "Add Service",

    sectorNameTr:
      "Turkish Sector Name",

    sectorNameEn:
      "English Sector Name",

    sectorNameDe:
      "German Sector Name",

    serviceNameTr:
      "Turkish Service Name",

    serviceNameEn:
      "English Service Name",

    serviceNameDe:
      "German Service Name",

    parentSector: "Parent Sector",
    icon: "Icon",
    color: "Color",
    order: "Order",

    catalogSaved:
      "Catalog saved.",

    catalogDisabled:
      "Record deactivated.",

    settingsInfo:
      "Manage network visibility and permissions for your institution.",

    internalNetworkActive:
      "Internal Business Network",

    crossInstitutionActive:
      "Cross-Institution Network",

    managerApprovalRequired:
      "Manager Approval Required",

    autoPublishMember:
      "Auto-Publish Member",

    phoneCanShow:
      "Phone Can Be Displayed",

    whatsappCanShow:
      "WhatsApp Can Be Displayed",

    emailCanShow:
      "Email Can Be Displayed",

    jobsActive:
      "Job Requests Active",

    offersActive:
      "Offer System Active",

    referencesActive:
      "Reviews Active",

    favoritesActive:
      "Favorites Active",

    viewsActive:
      "Profile View Counter",

    assistantActive:
      "Manager Assistant",

    defaultVisibility:
      "Default Profile Visibility",

    hidden: "Hidden",

    settingsSaved:
      "Settings saved.",

    profileInfo:
      "Edit your membership and company profile.",

    firstName: "First Name",
    lastName: "Last Name",
    birthDate: "Birth Date",
    titleField: "Title",
    companyTitle: "Company Title",
    companyPhone: "Company Phone",
    companyEmail: "Company Email",
    website: "Website",
    instagram: "Instagram",
    facebook: "Facebook",
    linkedin: "LinkedIn",
    youtube: "YouTube",

    profilePhoto:
      "Profile Photo URL",

    coverPhoto:
      "Cover Photo URL",

    companyLogo:
      "Company Logo URL",

    freeCity:
      "Custom City Name",

    freeDistrict:
      "Custom District Name",

    keywords: "Keywords",

    serviceArea:
      "Service Area Description",

    nationwide:
      "Nationwide Service",

    phoneVisible:
      "Show My Phone",

    whatsappVisible:
      "Show WhatsApp",

    emailVisible:
      "Show My Email",

    addressVisible:
      "Show My Address",

    selectedSectors:
      "Selected Sectors",

    selectedServices:
      "Selected Services",

    profileSaved:
      "Profile saved.",

    profileWaiting:
      "Your profile is waiting for manager approval.",

    profileRequired:
      "Complete your profile first.",

    requiredFields:
      "Fill in required fields.",

    confirmDeactivate:
      "Are you sure you want to deactivate this record?",

    confirmCancelJob:
      "Are you sure you want to cancel this job request?",

    confirmCompleteJob:
      "Mark this job as completed?",

    apiError:
      "An error occurred during the operation.",

    unauthorized:
      "Manager permission is required for this section.",

    previous: "Previous",
    next: "Next",
    page: "Page",
    record: "records",
    today: "Today",
  },

  de: {
    title:
      "Mitglieder-Geschäftsnetzwerk & CRM",

    subtitle:
      "Verwalten Sie Mitglieder, Branchen, Geschäftschancen und institutionsübergreifende Zusammenarbeit zentral.",

    dashboard: "Übersicht",
    members: "Mitglieder",
    network: "Geschäftsnetzwerk",
    jobs: "Aufträge",
    catalogs: "Branchen & Leistungen",
    settings: "Einstellungen",
myProfile: "Mein Geschäftsprofil",
businessIdentity: "MEIN GESCHÄFTSPROFIL",
profilePageDescription:
  "Verwalten Sie Ihr persönliches Firmen- und Leistungsprofil.",

optionalProfileTitle:
  "Dieser Bereich ist freiwillig",

optionalProfileText:
  "Als Vereinsverantwortlicher verwalten Sie Mitglieder im Bereich Mitglieder. Füllen Sie dieses Formular nur aus, wenn Sie oder Ihre Firma im Geschäftsnetzwerk erscheinen, Aufträge erhalten oder Angebote abgeben möchten.",

managerProfileControl:
  "Verwalten Sie hier die Netzwerkfreigabe und den Mitgliedsstatus dieses Kontos.",

approveNetwork:
  "Freigeben und hinzufügen",

removeFromNetwork:
  "Aus Netzwerk entfernen",

reactivateNetwork:
  "Erneut aktivieren",

confirmRemoveFromNetwork:
  "Dieses Profil aus dem Geschäftsnetzwerk entfernen? Der Datensatz wird nicht gelöscht; nur die Sichtbarkeit im Netzwerk wird deaktiviert.",

actionReason:
  "Grund für diesen Vorgang eingeben:",

networkStatusUpdated:
  "Netzwerkstatus aktualisiert.",


    refresh: "Aktualisieren",
    loading: "Daten werden geladen…",
    retry: "Erneut versuchen",
    search: "Suchen",
    clear: "Leeren",
    all: "Alle",
    save: "Speichern",
    update: "Aktualisieren",
    cancel: "Abbrechen",
    close: "Schließen",
    details: "Details",
    edit: "Bearbeiten",
    deactivate: "Deaktivieren",

    approve: "Genehmigen",
    reject: "Ablehnen",
    suspend: "Sperren",

    active: "Aktiv",
    passive: "Passiv",
    pending: "Ausstehend",
    approved: "Genehmigt",
    rejected: "Abgelehnt",
    suspended: "Gesperrt",
    frozen: "Eingefroren",
    left: "Ausgetreten",

    featured: "Hervorgehoben",
    verified: "Verifiziert",

    totalMembers:
      "Mitglieder Gesamt",

    activeMembers:
      "Aktive Mitglieder",

    pendingMembers:
      "Wartende Freigaben",

    openJobs:
      "Offene Aufträge",

    completedJobs:
      "Abgeschlossene Aufträge",

    pendingOffers:
      "Offene Angebote",

    profileViews:
      "Profilaufrufe",

    profileCompletion:
      "Durchschnittliche Profilvollständigkeit",

    assistant:
      "Manager-Assistent",

    noSuggestion:
      "Zurzeit gibt es keine wichtigen Hinweise.",

    upcomingBirthdays:
      "Bevorstehende Geburtstage",

    topMembers:
      "Top-Mitglieder",

    cityDistribution:
      "Stadtverteilung",

    sectorDistribution:
      "Branchenverteilung",

    noData:
      "Noch keine Einträge.",

    memberSearch:
      "Name, Firma, Beruf, Telefon oder E-Mail suchen",

    status: "Status",
    membership: "Mitgliedschaft",
    city: "Stadt",
    district: "Bezirk",
    sector: "Branche",
    service: "Leistung",
    company: "Firma",
    profession: "Beruf",
    phone: "Telefon",
    whatsapp: "WhatsApp",
    email: "E-Mail",
    address: "Adresse",
    about: "Über",

    products:
      "Produkte und Leistungen",

    needs:
      "Gesuchte Leistungen",

    partnership:
      "Kooperationsbeschreibung",

    memberCode:
      "Mitgliedscode",

    membershipNo:
      "Vereinsmitgliedsnummer",

    completion:
      "Profilvollständigkeit",

    manageMember:
      "Mitglied verwalten",

    rejectionReason:
      "Ablehnungs- / Sperrgrund",

    profileVisible:
      "Profil sichtbar",

    platformVisible:
      "Landesweit sichtbar",

    makeFeatured:
      "Mitglied hervorheben",

    makeVerified:
      "Mitglied verifizieren",

    memberUpdated:
      "Mitgliedsstatus aktualisiert.",

    networkSearch:
      "Mitglied, Firma, Beruf, Branche oder Leistung suchen",

    institutionNetwork:
      "Institution",

    platformNetwork:
      "Landesweit",

    favorite:
      "Favorit hinzufügen",

    unfavorite:
      "Favorit entfernen",

    favoriteAdded:
      "Mitglied zu Favoriten hinzugefügt.",

    favoriteRemoved:
      "Mitglied aus Favoriten entfernt.",

    ratings:
      "Bewertungen",

    completedWork:
      "Abgeschlossene Arbeit",

    viewProfile:
      "Profil anzeigen",

    jobSearch:
      "Auftragstitel, Beschreibung, Firma oder Leistung suchen",

    addJob:
      "Neuer Auftrag",

    jobTitle:
      "Auftragstitel",

    description:
      "Beschreibung",

    minBudget:
      "Mindestbudget",

    maxBudget:
      "Höchstbudget",

    currency:
      "Währung",

    offerDeadline:
      "Angebotsfrist",

    startDate:
      "Startdatum",

    endDate:
      "Enddatum",

    visibility:
      "Sichtbarkeit",

    institutionOnly:
      "Nur Institution",

    wholePlatform:
      "Landesweit",

    phoneContact:
      "Telefonkontakt",

    whatsappContact:
      "WhatsApp-Kontakt",

    inAppContact:
      "In-App-Kontakt",

    createJob:
      "Auftrag veröffentlichen",

    jobCreated:
      "Auftrag erstellt.",

    jobUpdated:
      "Auftrag aktualisiert.",

    jobCancelled:
      "Auftrag storniert.",

    offers:
      "Angebote",

    noOffer:
      "Noch keine Angebote.",

    offerAmount:
      "Angebotssumme",

    estimatedDays:
      "Geschätzte Tage",

    offerMessage:
      "Angebotsnachricht",

    accept:
      "Annehmen",

    decline:
      "Ablehnen",

    review:
      "In Prüfung",

    withdraw:
      "Zurückziehen",

    completeJob:
      "Auftrag abschließen",

    jobCompleted:
      "Auftrag abgeschlossen.",

    catalogInfo:
      "Verwalten Sie Hauptbranchen, Unterbranchen und Leistungen.",

    mainSectors:
      "Hauptbranchen",

    subSectors:
      "Unterbranchen",

    services:
      "Leistungen",

    addSector:
      "Branche hinzufügen",

    addService:
      "Leistung hinzufügen",

    sectorNameTr:
      "Türkischer Branchenname",

    sectorNameEn:
      "Englischer Branchenname",

    sectorNameDe:
      "Deutscher Branchenname",

    serviceNameTr:
      "Türkischer Leistungsname",

    serviceNameEn:
      "Englischer Leistungsname",

    serviceNameDe:
      "Deutscher Leistungsname",

    parentSector:
      "Übergeordnete Branche",

    icon: "Symbol",
    color: "Farbe",
    order: "Reihenfolge",

    catalogSaved:
      "Katalog gespeichert.",

    catalogDisabled:
      "Eintrag deaktiviert.",

    settingsInfo:
      "Verwalten Sie Netzwerksichtbarkeit und Berechtigungen Ihrer Institution.",

    internalNetworkActive:
      "Internes Geschäftsnetzwerk",

    crossInstitutionActive:
      "Institutionsübergreifendes Netzwerk",

    managerApprovalRequired:
      "Managerfreigabe erforderlich",

    autoPublishMember:
      "Mitglied automatisch veröffentlichen",

    phoneCanShow:
      "Telefon darf angezeigt werden",

    whatsappCanShow:
      "WhatsApp darf angezeigt werden",

    emailCanShow:
      "E-Mail darf angezeigt werden",

    jobsActive:
      "Aufträge aktiv",

    offersActive:
      "Angebotssystem aktiv",

    referencesActive:
      "Bewertungen aktiv",

    favoritesActive:
      "Favoriten aktiv",

    viewsActive:
      "Profilaufruf-Zähler",

    assistantActive:
      "Manager-Assistent",

    defaultVisibility:
      "Standard-Profilsichtbarkeit",

    hidden:
      "Verborgen",

    settingsSaved:
      "Einstellungen gespeichert.",

    profileInfo:
      "Bearbeiten Sie Ihr Mitglieds- und Firmenprofil.",

    firstName: "Vorname",
    lastName: "Nachname",
    birthDate: "Geburtsdatum",
    titleField: "Titel",
    companyTitle: "Firmenbezeichnung",
    companyPhone: "Firmentelefon",
    companyEmail: "Firmen-E-Mail",
    website: "Webseite",
    instagram: "Instagram",
    facebook: "Facebook",
    linkedin: "LinkedIn",
    youtube: "YouTube",

    profilePhoto:
      "Profilfoto-URL",

    coverPhoto:
      "Titelbild-URL",

    companyLogo:
      "Firmenlogo-URL",

    freeCity:
      "Freier Stadtname",

    freeDistrict:
      "Freier Bezirksname",

    keywords:
      "Schlüsselwörter",

    serviceArea:
      "Beschreibung des Leistungsgebiets",

    nationwide:
      "Landesweiter Service",

    phoneVisible:
      "Telefon anzeigen",

    whatsappVisible:
      "WhatsApp anzeigen",

    emailVisible:
      "E-Mail anzeigen",

    addressVisible:
      "Adresse anzeigen",

    selectedSectors:
      "Ausgewählte Branchen",

    selectedServices:
      "Ausgewählte Leistungen",

    profileSaved:
      "Profil gespeichert.",

    profileWaiting:
      "Ihr Profil wartet auf die Managerfreigabe.",

    profileRequired:
      "Vervollständigen Sie zuerst Ihr Profil.",

    requiredFields:
      "Pflichtfelder ausfüllen.",

    confirmDeactivate:
      "Möchten Sie diesen Eintrag wirklich deaktivieren?",

    confirmCancelJob:
      "Möchten Sie diesen Auftrag wirklich stornieren?",

    confirmCompleteJob:
      "Diesen Auftrag als abgeschlossen markieren?",

    apiError:
      "Während des Vorgangs ist ein Fehler aufgetreten.",

    unauthorized:
      "Für diesen Bereich ist eine Managerberechtigung erforderlich.",

    previous: "Zurück",
    next: "Weiter",
    page: "Seite",
    record: "Einträge",
    today: "Heute",
  },
};

/* =========================================================
   BOŞ FORMLAR
========================================================= */

const EMPTY_PROFILE = {
  ad: "",
  soyad: "",
  uye_kodu: "",
  dernek_uyelik_no: "",

  telefon: "",
  whatsapp: "",
  email: "",
  dogum_tarihi: "",

  il_id: "",
  ilce_id: "",
  il_adi_serbest: "",
  ilce_adi_serbest: "",

  meslek: "",
  unvan: "",

  firma_adi: "",
  firma_unvani: "",
  firma_logosu: "",
  firma_telefonu: "",
  firma_email: "",
  firma_adresi: "",

  web_sitesi: "",
  instagram: "",
  facebook: "",
  linkedin: "",
  youtube: "",

  profil_fotografi: "",
  kapak_fotografi: "",

  hakkinda: "",
  hizmet_bolgesi_aciklama: "",
  sundugu_urunler: "",
  aradigi_hizmetler: "",
  is_ortakligi_aciklama: "",
  referans_aciklamasi: "",

  anahtar_kelimeler: "",

  turkiye_geneli: false,
  profil_gorunur: true,
  platformda_gorunur: false,

  telefon_gorunur: false,
  whatsapp_gorunur: true,
  email_gorunur: false,
  adres_gorunur: false,

  sektor_ids: [],
  hizmet_ids: [],
};

const EMPTY_JOB = {
  baslik: "",
  aciklama: "",

  sektor_id: "",
  hizmet_id: "",

  ozel_sektor_adi: "",
  ozel_hizmet_adi: "",

  il_id: "",
  ilce_id: "",
  il_adi_serbest: "",
  ilce_adi_serbest: "",

  butce_min: "",
  butce_max: "",
  para_birimi: "TRY",

  son_teklif_tarihi: "",
  is_baslangic_tarihi: "",
  is_bitis_tarihi: "",

  gorunurluk: "kurum",
  durum: "acik",

  telefonla_iletisim: false,
  whatsapp_iletisim: true,
  uygulama_ici_iletisim: true,
};

/* =========================================================
   YARDIMCI FONKSİYONLAR
========================================================= */

function getLanguage() {
  const raw =
    localStorage.getItem("panel_dili") ||
    localStorage.getItem("app_lang") ||
    localStorage.getItem("lang") ||
    "tr";

  const value = String(raw)
    .slice(0, 2)
    .toLowerCase();

  return ALLOWED_LANGS.includes(value)
    ? value
    : "tr";
}

function authHeaders() {
  const token =
    localStorage.getItem("token") || "";

  return {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };
}

async function apiRequest(
  path,
  language,
  options = {}
) {
  const separator =
    path.includes("?") ? "&" : "?";

  const response = await fetch(
    `${API_BASE}${path}${separator}lang=${language}`,
    {
      ...options,

      headers: {
        ...authHeaders(),
        ...(options.headers || {}),
      },
    }
  );

  const payload = await response
    .json()
    .catch(() => ({}));

  if (!response.ok) {
    throw new Error(
      payload.message ||
        payload.error ||
        `HTTP ${response.status}`
    );
  }

  return payload;
}

function qs(params) {
  const search =
    new URLSearchParams();

  Object.entries(params || {}).forEach(
    ([key, value]) => {
      if (
        value !== "" &&
        value !== null &&
        value !== undefined &&
        value !== "all"
      ) {
        search.set(key, value);
      }
    }
  );

  const output = search.toString();

  return output ? `?${output}` : "";
}

function dateText(
  value,
  language = "tr"
) {
  if (!value) {
    return "-";
  }

  const date = new Date(value);

  if (Number.isNaN(date.getTime())) {
    return String(value);
  }

  const locale =
    language === "tr"
      ? "tr-TR"
      : language === "de"
      ? "de-DE"
      : "en-GB";

  return date.toLocaleDateString(
    locale,
    {
      day: "2-digit",
      month: "short",
      year: "numeric",
    }
  );
}

function money(
  value,
  currency = "TRY",
  language = "tr"
) {
  const amount =
    Number(value || 0);

  const locale =
    language === "tr"
      ? "tr-TR"
      : language === "de"
      ? "de-DE"
      : "en-GB";

  try {
    return new Intl.NumberFormat(
      locale,
      {
        style: "currency",
        currency:
          currency || "TRY",
        maximumFractionDigits: 2,
      }
    ).format(amount);
  } catch {
    return `${amount.toLocaleString()} ${
      currency || ""
    }`;
  }
}

function initials(item = {}) {
  const value =
    `${item.ad || ""} ${
      item.soyad || ""
    }`.trim() ||
    item.firma_adi ||
    "M";

  return value
    .split(/\s+/)
    .slice(0, 2)
    .map((part) =>
      part.charAt(0).toUpperCase()
    )
    .join("");
}


function normalizeProfileStatus(status) {
  const value = String(
    status ?? ""
  )
    .trim()
    .toLowerCase();

  if (
    !value ||
    [
      "yok",
      "none",
      "null",
      "undefined",
    ].includes(value)
  ) {
    return "beklemede";
  }

  return value;
}

function statusLabel(status, tt) {
  const normalized =
    normalizeProfileStatus(status);

  const map = {
    beklemede: tt.pending,
    onaylandi: tt.approved,
    reddedildi: tt.rejected,
    askida: tt.suspended,

    aktif: tt.active,
    pasif: tt.passive,
    ayrilmis: tt.left,
    dondurulmus: tt.frozen,

    taslak: "Taslak",
    acik: tt.openJobs,
    teklif_secildi: tt.accept,
    tamamlandi: tt.completedJobs,
    iptal: tt.cancel,
    kapali: tt.close,

    inceleniyor: tt.review,
    kabul_edildi: tt.approved,
    geri_cekildi: tt.withdraw,
  };

  return (
    map[normalized] ||
    normalized ||
    tt.pending
  );
}

function statusClass(status) {
  const normalized =
    normalizeProfileStatus(status);

  if (
    [
      "onaylandi",
      "aktif",
      "tamamlandi",
      "kabul_edildi",
    ].includes(normalized)
  ) {
    return "success";
  }

  if (
    [
      "beklemede",
      "inceleniyor",
      "teklif_secildi",
      "acik",
    ].includes(normalized)
  ) {
    return "warning";
  }

  if (
    [
      "reddedildi",
      "iptal",
      "pasif",
      "ayrilmis",
    ].includes(normalized)
  ) {
    return "danger";
  }

  if (
    [
      "askida",
      "dondurulmus",
      "geri_cekildi",
    ].includes(normalized)
  ) {
    return "neutral";
  }

  return "info";
}


function toProfileForm(profile) {
  if (!profile) {
    return {
      ...EMPTY_PROFILE,
    };
  }

  return {
    ...EMPTY_PROFILE,
    ...profile,

    dogum_tarihi:
      profile.dogum_tarihi
        ? String(
            profile.dogum_tarihi
          ).slice(0, 10)
        : "",

    il_id:
      profile.il_id || "",

    ilce_id:
      profile.ilce_id || "",

    anahtar_kelimeler:
      Array.isArray(
        profile.anahtar_kelimeler
      )
        ? profile.anahtar_kelimeler.join(
            ", "
          )
        : profile.anahtar_kelimeler ||
          "",

    sektor_ids:
      (profile.sektorler || [])
        .map((item) =>
          Number(item.id)
        )
        .filter(Boolean),

    hizmet_ids:
      (profile.hizmetler || [])
        .map((item) =>
          Number(item.id)
        )
        .filter(Boolean),
  };
}

function toJobForm(job) {
  if (!job) {
    return {
      ...EMPTY_JOB,
    };
  }

  return {
    ...EMPTY_JOB,
    ...job,

    sektor_id:
      job.sektor_id || "",

    hizmet_id:
      job.hizmet_id || "",

    il_id:
      job.il_id || "",

    ilce_id:
      job.ilce_id || "",

    son_teklif_tarihi:
      job.son_teklif_tarihi
        ? String(
            job.son_teklif_tarihi
          ).slice(0, 10)
        : "",

    is_baslangic_tarihi:
      job.is_baslangic_tarihi
        ? String(
            job.is_baslangic_tarihi
          ).slice(0, 10)
        : "",

    is_bitis_tarihi:
      job.is_bitis_tarihi
        ? String(
            job.is_bitis_tarihi
          ).slice(0, 10)
        : "",
  };
}

/* =========================================================
   ORTAK KÜÇÜK BİLEŞENLER
========================================================= */

function Icon({ children }) {
  return (
    <span
      className="mia-icon"
      aria-hidden="true"
    >
      {children}
    </span>
  );
}

function Button({
  children,
  variant = "primary",
  size = "normal",
  className = "",
  ...props
}) {
  return (
    <button
      className={`mia-btn mia-btn-${variant} mia-btn-${size} ${className}`}
      {...props}
    >
      {children}
    </button>
  );
}

function Badge({
  value,
  children,
}) {
  return (
    <span
      className={`mia-badge mia-badge-${statusClass(
        value
      )}`}
    >
      {children || value}
    </span>
  );
}

function Card({
  children,
  className = "",
}) {
  return (
    <section
      className={`mia-card ${className}`}
    >
      {children}
    </section>
  );
}

function Field({
  label,
  required,
  hint,
  children,
  className = "",
}) {
  return (
    <label
      className={`mia-field ${className}`}
    >
      <span className="mia-label">
        {label}

        {required ? (
          <b> *</b>
        ) : null}
      </span>

      {children}

      {hint ? (
        <small>{hint}</small>
      ) : null}
    </label>
  );
}

function Toggle({
  checked,
  onChange,
  label,
  description,
}) {
  return (
    <label className="mia-toggle-row">
      <span>
        <strong>{label}</strong>

        {description ? (
          <small>
            {description}
          </small>
        ) : null}
      </span>

      <input
        type="checkbox"
        checked={Boolean(checked)}
        onChange={(event) =>
          onChange(
            event.target.checked
          )
        }
      />

      <span className="mia-switch" />
    </label>
  );
}

function Modal({
  open,
  title,
  subtitle,
  children,
  onClose,
  size = "large",
}) {
  useEffect(() => {
    if (!open) {
      return undefined;
    }

    const old =
      document.body.style.overflow;

    document.body.style.overflow =
      "hidden";

    const onKey = (event) => {
      if (event.key === "Escape") {
        onClose?.();
      }
    };

    window.addEventListener(
      "keydown",
      onKey
    );

    return () => {
      document.body.style.overflow =
        old;

      window.removeEventListener(
        "keydown",
        onKey
      );
    };
  }, [open, onClose]);

  if (!open) {
    return null;
  }

  return (
    <div
      className="mia-modal-backdrop"
      onMouseDown={(event) => {
        if (
          event.target ===
          event.currentTarget
        ) {
          onClose?.();
        }
      }}
    >
      <div
        className={`mia-modal mia-modal-${size}`}
        role="dialog"
        aria-modal="true"
      >
        <div className="mia-modal-head">
          <div>
            <h2>{title}</h2>

            {subtitle ? (
              <p>{subtitle}</p>
            ) : null}
          </div>

          <button
            className="mia-modal-close"
            onClick={onClose}
            aria-label="Close"
          >
            ×
          </button>
        </div>

        <div className="mia-modal-body">
          {children}
        </div>
      </div>
    </div>
  );
}

function Avatar({
  item,
  size = "normal",
}) {
  const image =
    item?.profil_fotografi ||
    item?.firma_logosu;

  if (image) {
    return (
      <img
        className={`mia-avatar mia-avatar-${size}`}
        src={image}
        alt={`${item?.ad || ""} ${
          item?.soyad || ""
        }`}
        onError={(event) => {
          event.currentTarget.style.display =
            "none";
        }}
      />
    );
  }

  return (
    <div
      className={`mia-avatar mia-avatar-${size} mia-avatar-fallback`}
    >
      {initials(item)}
    </div>
  );
}

function EmptyState({
  title,
  text,
  action,
}) {
  return (
    <div className="mia-empty">
      <div className="mia-empty-icon">
        ⌁
      </div>

      <h3>{title}</h3>

      {text ? <p>{text}</p> : null}

      {action}
    </div>
  );
}

function LoadingBlock() {
  return (
    <div className="mia-loading-grid">
      {[1, 2, 3, 4, 5, 6].map(
        (item) => (
          <div
            className="mia-skeleton"
            key={item}
          />
        )
      )}
    </div>
  );
}

function Pagination({
  page,
  limit,
  total,
  onChange,
  tt,
}) {
  const pages = Math.max(
    Math.ceil(
      Number(total || 0) /
        Number(limit || 1)
    ),
    1
  );

  if (pages <= 1) {
    return null;
  }

  return (
    <div className="mia-pagination">
      <Button
        variant="soft"
        size="small"
        disabled={page <= 1}
        onClick={() =>
          onChange(page - 1)
        }
      >
        ‹ {tt.previous}
      </Button>

      <span>
        {tt.page} <b>{page}</b> /{" "}
        {pages} · {total} {tt.record}
      </span>

      <Button
        variant="soft"
        size="small"
        disabled={page >= pages}
        onClick={() =>
          onChange(page + 1)
        }
      >
        {tt.next} ›
      </Button>
    </div>
  );
}

function StatCard({
  icon,
  label,
  value,
  tone = "blue",
  sub,
}) {
  return (
    <Card
      className={`mia-stat mia-stat-${tone}`}
    >
      <div className="mia-stat-icon">
        {icon}
      </div>

      <div>
        <span>{label}</span>

        <strong>
          {value ?? 0}
        </strong>

        {sub ? (
          <small>{sub}</small>
        ) : null}
      </div>
    </Card>
  );
}

function Info({
  label,
  value,
}) {
  return (
    <div className="mia-info">
      <span>{label}</span>

      <strong>
        {value || "-"}
      </strong>
    </div>
  );
}

/* =========================================================
   İŞ AĞI DURUM İŞLEMLERİ
========================================================= */

function NetworkStatusActions({
  tt,
  profile,
  onAction,
  saving,
}) {
  if (!profile?.id) {
    return null;
  }

  const approval =
    normalizeProfileStatus(
      profile.onay_durumu
    );

  const membership =
    profile.uyelik_durumu ||
    "aktif";

  const active =
    profile.aktif !== false;

  const isLive =
    approval === "onaylandi" &&
    membership === "aktif" &&
    active;

  const isWaiting =
    approval === "beklemede";

  const isRemoved =
    membership === "ayrilmis";

  return (
    <div className="mia-network-actions">
      {isWaiting ? (
        <Button
          type="button"
          onClick={() =>
            onAction("approve")
          }
          disabled={saving}
        >
          ✓ {tt.approveNetwork}
        </Button>
      ) : null}

      {!isWaiting && !isLive ? (
        <Button
          type="button"
          variant="soft"
          onClick={() =>
            onAction("reactivate")
          }
          disabled={saving}
        >
          ↻ {tt.reactivateNetwork}
        </Button>
      ) : null}

      {approval !== "reddedildi" &&
      !isRemoved ? (
        <Button
          type="button"
          variant="dangerSoft"
          onClick={() =>
            onAction("reject")
          }
          disabled={saving}
        >
          ✕ {tt.reject}
        </Button>
      ) : null}

      {approval !== "askida" &&
      approval !== "reddedildi" &&
      !isRemoved ? (
        <Button
          type="button"
          variant="soft"
          onClick={() =>
            onAction("suspend")
          }
          disabled={saving}
        >
          ⏸ {tt.suspend}
        </Button>
      ) : null}

      {!isRemoved ? (
        <Button
          type="button"
          variant="dangerSoft"
          onClick={() =>
            onAction("remove")
          }
          disabled={saving}
        >
          ⌫ {tt.removeFromNetwork}
        </Button>
      ) : null}
    </div>
  );
}

/* =========================================================
   ANA SAYFA
========================================================= */

export default function IsAgiPanel() {
  const [
    language,
    setLanguage,
  ] = useState(getLanguage());

  const tt =
    TEXT[language] || TEXT.tr;

  const [
    activeTab,
    setActiveTab,
  ] = useState("dashboard");

  const [
    bootstrap,
    setBootstrap,
  ] = useState(null);

  const [
    bootLoading,
    setBootLoading,
  ] = useState(true);

  const [
    activeLoading,
    setActiveLoading,
  ] = useState(false);

  const [
    globalError,
    setGlobalError,
  ] = useState("");

  const [
    toast,
    setToast,
  ] = useState(null);

  const [
    dashboard,
    setDashboard,
  ] = useState(null);

  const [
    members,
    setMembers,
  ] = useState({
    data: [],

    pagination: {
      page: 1,
      limit: 30,
      total: 0,
    },
  });

  const [
    memberFilters,
    setMemberFilters,
  ] = useState({
    q: "",
    status: "all",
    membership: "all",
    city_id: "",
    sector_id: "",
    page: 1,
    limit: 30,
  });

  const [
    network,
    setNetwork,
  ] = useState({
    data: [],

    pagination: {
      page: 1,
      limit: 24,
      total: 0,
    },
  });

  const [
    networkFilters,
    setNetworkFilters,
  ] = useState({
    q: "",
    scope: "all",
    city_id: "",
    sector_id: "",
    page: 1,
    limit: 24,
  });

  const [
    jobs,
    setJobs,
  ] = useState({
    data: [],

    pagination: {
      page: 1,
      limit: 20,
      total: 0,
    },
  });

  const [
    jobFilters,
    setJobFilters,
  ] = useState({
    q: "",
    scope: "all",
    status: "all",
    sector_id: "",
    city_id: "",
    page: 1,
    limit: 20,
  });

  const [
    settingsForm,
    setSettingsForm,
  ] = useState(null);

  const [
    profileForm,
    setProfileForm,
  ] = useState({
    ...EMPTY_PROFILE,
  });

  const [
    catalog,
    setCatalog,
  ] = useState({
    sectors: [],
    services: [],
  });

  const [
    memberModal,
    setMemberModal,
  ] = useState(null);

  const [
    memberDraft,
    setMemberDraft,
  ] = useState(null);

  const [
    profileDetail,
    setProfileDetail,
  ] = useState(null);

  const [
    jobModal,
    setJobModal,
  ] = useState(null);

  const [
    jobForm,
    setJobForm,
  ] = useState({
    ...EMPTY_JOB,
  });

  const [
    offersModal,
    setOffersModal,
  ] = useState(null);

  const [
    offers,
    setOffers,
  ] = useState([]);

  const [
    catalogModal,
    setCatalogModal,
  ] = useState(null);

  const [
    catalogForm,
    setCatalogForm,
  ] = useState({});

  const [
    saving,
    setSaving,
  ] = useState(false);

  const isManager =
    Boolean(
      bootstrap?.user?.is_manager
    );

  const myProfile =
    bootstrap?.profile || null;

  const cities =
    bootstrap?.cities || [];

  const allSectors =
    bootstrap?.sectors || [];

  const allServices =
    bootstrap?.services || [];

  const mainSectors =
    useMemo(
      () =>
        allSectors.filter(
          (item) =>
            !item.parent_id
        ),
      [allSectors]
    );

  const selectedProfileServices =
    useMemo(() => {
      const selected =
        new Set(
          profileForm.sektor_ids ||
            []
        );

      if (!selected.size) {
        return allServices;
      }

      return allServices.filter(
        (service) =>
          selected.has(
            Number(
              service.sector_id
            )
          )
      );
    }, [
      allServices,
      profileForm.sektor_ids,
    ]);

  const jobServices =
    useMemo(() => {
      if (!jobForm.sektor_id) {
        return allServices;
      }

      return allServices.filter(
        (item) =>
          Number(
            item.sector_id
          ) ===
          Number(
            jobForm.sektor_id
          )
      );
    }, [
      allServices,
      jobForm.sektor_id,
    ]);

  const showToast =
    useCallback(
      (
        message,
        type = "success"
      ) => {
        setToast({
          message,
          type,
        });

        window.clearTimeout(
          window.__miaToastTimer
        );

        window.__miaToastTimer =
          window.setTimeout(
            () => setToast(null),
            3200
          );
      },
      []
    );

  /* =======================================================
     DİL TAKİBİ
  ======================================================= */

  useEffect(() => {
    const sync = () =>
      setLanguage(
        getLanguage()
      );

    window.addEventListener(
      "app_lang_change",
      sync
    );

    window.addEventListener(
      "storage",
      sync
    );

    window.addEventListener(
      "focus",
      sync
    );

    return () => {
      window.removeEventListener(
        "app_lang_change",
        sync
      );

      window.removeEventListener(
        "storage",
        sync
      );

      window.removeEventListener(
        "focus",
        sync
      );
    };
  }, []);

  /* =======================================================
     BAŞLANGIÇ VERİLERİ
  ======================================================= */

  const loadBootstrap =
    useCallback(async () => {
      setBootLoading(true);
      setGlobalError("");

      try {
        const response =
          await apiRequest(
            "/bootstrap",
            language
          );

        setBootstrap(
          response.data || null
        );

        setSettingsForm(
          response.data?.settings ||
            null
        );

        setProfileForm(
          toProfileForm(
            response.data?.profile
          )
        );
      } catch (error) {
        setGlobalError(
          error.message ||
            tt.apiError
        );
      } finally {
        setBootLoading(false);
      }
    }, [
      language,
      tt.apiError,
    ]);

  useEffect(() => {
    loadBootstrap();
  }, [loadBootstrap]);

  /* =======================================================
     DASHBOARD YÜKLE
  ======================================================= */

  const loadDashboard =
    useCallback(async () => {
      if (!isManager) {
        return;
      }

      const response =
        await apiRequest(
          "/dashboard",
          language
        );

      setDashboard(
        response.data || null
      );
    }, [
      isManager,
      language,
    ]);

  /* =======================================================
     ÜYELERİ YÜKLE
  ======================================================= */

  const loadMembers =
    useCallback(async () => {
      if (!isManager) {
        return;
      }

      const response =
        await apiRequest(
          `/admin/members${qs(
            memberFilters
          )}`,
          language
        );

      setMembers({
        data:
          response.data || [],

        pagination:
          response.pagination || {
            page:
              memberFilters.page,

            limit:
              memberFilters.limit,

            total: 0,
          },
      });
    }, [
      isManager,
      language,
      memberFilters,
    ]);

  /* =======================================================
     İŞ AĞINI YÜKLE
  ======================================================= */

  const loadNetwork =
    useCallback(async () => {
      const response =
        await apiRequest(
          `/network${qs(
            networkFilters
          )}`,
          language
        );

      setNetwork({
        data:
          response.data || [],

        pagination:
          response.pagination || {
            page:
              networkFilters.page,

            limit:
              networkFilters.limit,

            total: 0,
          },
      });
    }, [
      language,
      networkFilters,
    ]);

  /* =======================================================
     İŞ TALEPLERİNİ YÜKLE
  ======================================================= */

  const loadJobs =
    useCallback(async () => {
      const response =
        await apiRequest(
          `/jobs${qs(
            jobFilters
          )}`,
          language
        );

      setJobs({
        data:
          response.data || [],

        pagination:
          response.pagination || {
            page:
              jobFilters.page,

            limit:
              jobFilters.limit,

            total: 0,
          },
      });
    }, [
      language,
      jobFilters,
    ]);

  /* =======================================================
     KATALOĞU YÜKLE
  ======================================================= */

  const loadCatalog =
    useCallback(async () => {
      const [
        sectorResponse,
        serviceResponse,
      ] = await Promise.all([
        apiRequest(
          "/sectors?flat=true",
          language
        ),

        apiRequest(
          "/services",
          language
        ),
      ]);

      setCatalog({
        sectors:
          sectorResponse.data ||
          [],

        services:
          serviceResponse.data ||
          [],
      });
    }, [language]);

  /* =======================================================
     PROFİLİ YÜKLE
  ======================================================= */

  const loadProfile =
    useCallback(async () => {
      const response =
        await apiRequest(
          "/profile/me",
          language
        );

      setProfileForm(
        toProfileForm(
          response.data
        )
      );
    }, [language]);

  /* =======================================================
     AKTİF SEKMENİN VERİSİNİ YÜKLE
  ======================================================= */

  const loadActive =
    useCallback(async () => {
      if (!bootstrap) {
        return;
      }

      setActiveLoading(true);
      setGlobalError("");

      try {
        if (
          activeTab === "dashboard"
        ) {
          await loadDashboard();
        }

        if (
          activeTab === "members"
        ) {
          await loadMembers();
        }

        if (
          activeTab === "network"
        ) {
          await loadNetwork();
        }

        if (
          activeTab === "jobs"
        ) {
          await loadJobs();
        }

        if (
          activeTab === "catalogs"
        ) {
          await loadCatalog();
        }

        if (
          activeTab === "profile"
        ) {
          await loadProfile();
        }

        if (
          activeTab === "settings"
        ) {
          setSettingsForm(
            bootstrap.settings ||
              null
          );
        }
      } catch (error) {
        setGlobalError(
          error.message ||
            tt.apiError
        );
      } finally {
        setActiveLoading(false);
      }
    }, [
      activeTab,
      bootstrap,
      loadCatalog,
      loadDashboard,
      loadJobs,
      loadMembers,
      loadNetwork,
      loadProfile,
      tt.apiError,
    ]);

  useEffect(() => {
    loadActive();
  }, [loadActive]);

  const refreshAll =
    async () => {
      await loadBootstrap();

      showToast(
        tt.refresh
      );
    };

  /* =======================================================
     SEKMELER
  ======================================================= */

  const tabs = [
    {
      id: "dashboard",
      label: tt.dashboard,
      icon: "◫",
      manager: true,
    },

    {
      id: "members",
      label: tt.members,
      icon: "♙",
      manager: true,
    },

    {
      id: "network",
      label: tt.network,
      icon: "⌘",
    },

    {
      id: "jobs",
      label: tt.jobs,
      icon: "▣",
    },

    {
      id: "catalogs",
      label: tt.catalogs,
      icon: "▦",
      manager: true,
    },

    {
      id: "settings",
      label: tt.settings,
      icon: "⚙",
      manager: true,
    },

    {
      id: "profile",
      label: tt.myProfile,
      icon: "◎",
    },
  ].filter(
    (item) =>
      !item.manager ||
      isManager
  );

  useEffect(() => {
    const exists =
      tabs.some(
        (item) =>
          item.id === activeTab
      );

    if (!exists) {
      setActiveTab("network");
    }
  }, [
    activeTab,
    isManager,
  ]);

  /* =======================================================
     ÜYE DETAYI AÇ
  ======================================================= */

  const openMember =
    async (member) => {
      setSaving(true);

      try {
        const response =
          await apiRequest(
            `/admin/members/${member.id}`,
            language
          );

        setMemberModal(
          response.data
        );

        setMemberDraft({
          onay_durumu:
            response.data
              .onay_durumu,

          uyelik_durumu:
            response.data
              .uyelik_durumu,

          red_nedeni:
            response.data
              .red_nedeni || "",

          one_cikan:
            Boolean(
              response.data
                .one_cikan
            ),

          dogrulanmis:
            Boolean(
              response.data
                .dogrulanmis
            ),

          profil_gorunur:
            Boolean(
              response.data
                .profil_gorunur
            ),

          platformda_gorunur:
            Boolean(
              response.data
                .platformda_gorunur
            ),

          aktif:
            Boolean(
              response.data.aktif
            ),
        });
      } catch (error) {
        showToast(
          error.message ||
            tt.apiError,
          "error"
        );
      } finally {
        setSaving(false);
      }
    };

  /* =======================================================
     ÜYE DURUMUNU KAYDET
  ======================================================= */

  const saveMember =
    async () => {
      if (
        !memberModal ||
        !memberDraft
      ) {
        return;
      }

      setSaving(true);

      try {
        await apiRequest(
          `/admin/members/${memberModal.id}/status`,
          language,
          {
            method: "PUT",

            body:
              JSON.stringify(
                memberDraft
              ),
          }
        );

        showToast(
          tt.memberUpdated
        );

        setMemberModal(null);
        setMemberDraft(null);

        await loadMembers();

        if (dashboard) {
          await loadDashboard();
        }
      } catch (error) {
        showToast(
          error.message ||
            tt.apiError,
          "error"
        );
      } finally {
        setSaving(false);
      }
    };

   /* =======================================================
     ÜYE / KENDİ PROFİLİ HIZLI DURUM YÖNETİMİ
  ======================================================= */

  const manageProfileStatus =
    async (
      profile,
      action
    ) => {
      if (
        !isManager ||
        !profile?.id
      ) {
        showToast(
          tt.unauthorized,
          "error"
        );

        return;
      }

      let reason = "";

      if (
        action === "reject" ||
        action === "suspend"
      ) {
        const answer =
          window.prompt(
            tt.actionReason,
            profile.red_nedeni ||
              ""
          );

        if (answer === null) {
          return;
        }

        reason =
          answer.trim() ||
          (
            action === "reject"
              ? tt.reject
              : tt.suspend
          );
      }

      if (action === "remove") {
        const confirmed =
          window.confirm(
            tt.confirmRemoveFromNetwork
          );

        if (!confirmed) {
          return;
        }

        reason =
          tt.removeFromNetwork;
      }

      const payload = {
        onay_durumu:
          normalizeProfileStatus(
            profile.onay_durumu
          ),

        uyelik_durumu:
          profile.uyelik_durumu ||
          "aktif",

        red_nedeni:
          profile.red_nedeni ||
          "",

        one_cikan:
          Boolean(
            profile.one_cikan
          ),

        dogrulanmis:
          Boolean(
            profile.dogrulanmis
          ),

        profil_gorunur:
          profile.profil_gorunur !==
          false,

        platformda_gorunur:
          Boolean(
            profile
              .platformda_gorunur
          ),

        aktif:
          profile.aktif !== false,
      };

      if (
        action === "approve" ||
        action === "reactivate"
      ) {
        Object.assign(
          payload,
          {
            onay_durumu:
              "onaylandi",

            uyelik_durumu:
              "aktif",

            red_nedeni: "",

            aktif: true,

            profil_gorunur:
              true,
          }
        );
      }

      if (action === "reject") {
        Object.assign(
          payload,
          {
            onay_durumu:
              "reddedildi",

            uyelik_durumu:
              "pasif",

            red_nedeni:
              reason,

            aktif: false,

            profil_gorunur:
              false,

            platformda_gorunur:
              false,
          }
        );
      }

      if (action === "suspend") {
        Object.assign(
          payload,
          {
            onay_durumu:
              "askida",

            uyelik_durumu:
              "dondurulmus",

            red_nedeni:
              reason,

            aktif: false,

            profil_gorunur:
              false,

            platformda_gorunur:
              false,
          }
        );
      }

      if (action === "remove") {
        Object.assign(
          payload,
          {
            onay_durumu:
              "askida",

            uyelik_durumu:
              "ayrilmis",

            red_nedeni:
              reason,

            aktif: false,

            profil_gorunur:
              false,

            platformda_gorunur:
              false,
          }
        );
      }

      setSaving(true);

      try {
        const response =
          await apiRequest(
            `/admin/members/${profile.id}/status`,
            language,
            {
              method: "PUT",

              body:
                JSON.stringify(
                  payload
                ),
            }
          );

        const result =
          response.data || {};

        const statusPatch = {
          onay_durumu:
            result.onay_durumu ??
            payload.onay_durumu,

          uyelik_durumu:
            result.uyelik_durumu ??
            payload.uyelik_durumu,

          red_nedeni:
            result.red_nedeni ??
            payload.red_nedeni,

          one_cikan:
            result.one_cikan ??
            payload.one_cikan,

          dogrulanmis:
            result.dogrulanmis ??
            payload.dogrulanmis,

          profil_gorunur:
            result.profil_gorunur ??
            payload.profil_gorunur,

          platformda_gorunur:
            result
              .platformda_gorunur ??
            payload
              .platformda_gorunur,

          aktif:
            result.aktif ??
            payload.aktif,
        };

        if (
          Number(profileForm?.id) ===
          Number(profile.id)
        ) {
          setProfileForm(
            (current) => ({
              ...current,
              ...statusPatch,
            })
          );

          setBootstrap(
            (current) =>
              current
                ? {
                    ...current,

                    profile: {
                      ...(
                        current.profile ||
                        {}
                      ),

                      ...statusPatch,
                    },
                  }
                : current
          );
        }

        if (
          Number(memberModal?.id) ===
          Number(profile.id)
        ) {
          setMemberModal(
            (current) =>
              current
                ? {
                    ...current,
                    ...statusPatch,
                  }
                : current
          );

          setMemberDraft(
            (current) =>
              current
                ? {
                    ...current,
                    ...statusPatch,

                    red_nedeni:
                      statusPatch
                        .red_nedeni ||
                      "",
                  }
                : current
          );
        }

        showToast(
          tt.networkStatusUpdated
        );

        await Promise.allSettled([
          loadMembers(),
          loadNetwork(),
          loadDashboard(),
        ]);
      } catch (error) {
        showToast(
          error.message ||
            tt.apiError,
          "error"
        );
      } finally {
        setSaving(false);
      }
    };

  /* =======================================================
     AĞ PROFİL DETAYI
  ======================================================= */

  const openNetworkProfile =
    async (member) => {
      setSaving(true);

      try {
        const response =
          await apiRequest(
            `/network/${member.id}`,
            language
          );

        setProfileDetail(
          response.data || null
        );
      } catch (error) {
        showToast(
          error.message ||
            tt.apiError,
          "error"
        );
      } finally {
        setSaving(false);
      }
    };

  /* =======================================================
     FAVORİ
  ======================================================= */

  const toggleFavorite =
    async (member) => {
      try {
        await apiRequest(
          `/network/${member.id}/favorite`,
          language,
          {
            method:
              member.favoride
                ? "DELETE"
                : "POST",
          }
        );

        showToast(
          member.favoride
            ? tt.favoriteRemoved
            : tt.favoriteAdded
        );

        setNetwork(
          (current) => ({
            ...current,

            data:
              current.data.map(
                (item) =>
                  item.id ===
                  member.id
                    ? {
                        ...item,

                        favoride:
                          !item.favoride,
                      }
                    : item
              ),
          })
        );

        setProfileDetail(
          (current) =>
            current?.id ===
            member.id
              ? {
                  ...current,

                  favoride:
                    !current.favoride,
                }
              : current
        );
      } catch (error) {
        showToast(
          error.message ||
            tt.apiError,
          "error"
        );
      }
    };

  /* =======================================================
     İŞ FORMU
  ======================================================= */

  const openJobEditor =
    (job = null) => {
      setJobForm(
        toJobForm(job)
      );

      setJobModal(
        job || {
          id: null,
        }
      );
    };

  const saveJob =
    async () => {
      if (
        !jobForm.baslik.trim() ||
        !jobForm.aciklama.trim()
      ) {
        showToast(
          tt.requiredFields,
          "error"
        );

        return;
      }

      setSaving(true);

      try {
        const editing =
          Boolean(jobModal?.id);

        await apiRequest(
          editing
            ? `/jobs/${jobModal.id}`
            : "/jobs",
          language,
          {
            method:
              editing
                ? "PUT"
                : "POST",

            body:
              JSON.stringify(
                jobForm
              ),
          }
        );

        showToast(
          editing
            ? tt.jobUpdated
            : tt.jobCreated
        );

        setJobModal(null);

        setJobForm({
          ...EMPTY_JOB,
        });

        await loadJobs();
      } catch (error) {
        showToast(
          error.message ||
            tt.apiError,
          "error"
        );
      } finally {
        setSaving(false);
      }
    };

  const cancelJob =
    async (job) => {
      if (
        !window.confirm(
          tt.confirmCancelJob
        )
      ) {
        return;
      }

      try {
        await apiRequest(
          `/jobs/${job.id}`,
          language,
          {
            method: "DELETE",

            body:
              JSON.stringify({
                reason:
                  tt.cancel,
              }),
          }
        );

        showToast(
          tt.jobCancelled
        );

        await loadJobs();
      } catch (error) {
        showToast(
          error.message ||
            tt.apiError,
          "error"
        );
      }
    };

  /* =======================================================
     TEKLİFLER
  ======================================================= */

  const openOffers =
    async (job) => {
      setSaving(true);

      try {
        const [
          jobResponse,
          offerResponse,
        ] = await Promise.all([
          apiRequest(
            `/jobs/${job.id}`,
            language
          ),

          apiRequest(
            `/jobs/${job.id}/offers`,
            language
          ),
        ]);

        setOffersModal(
          jobResponse.data || job
        );

        setOffers(
          offerResponse.data || []
        );
      } catch (error) {
        showToast(
          error.message ||
            tt.apiError,
          "error"
        );
      } finally {
        setSaving(false);
      }
    };

  const setOfferStatus =
    async (
      offer,
      status
    ) => {
      setSaving(true);

      try {
        await apiRequest(
          `/offers/${offer.id}/status`,
          language,
          {
            method: "PUT",

            body:
              JSON.stringify({
                status,
              }),
          }
        );

        const response =
          await apiRequest(
            `/jobs/${offersModal.id}/offers`,
            language
          );

        setOffers(
          response.data || []
        );

        await loadJobs();

        showToast(
          tt.memberUpdated
        );
      } catch (error) {
        showToast(
          error.message ||
            tt.apiError,
          "error"
        );
      } finally {
        setSaving(false);
      }
    };

  const completeJob =
    async (job) => {
      if (
        !window.confirm(
          tt.confirmCompleteJob
        )
      ) {
        return;
      }

      setSaving(true);

      try {
        await apiRequest(
          `/jobs/${job.id}/complete`,
          language,
          {
            method: "POST",
          }
        );

        showToast(
          tt.jobCompleted
        );

        setOffersModal(null);

        await loadJobs();
      } catch (error) {
        showToast(
          error.message ||
            tt.apiError,
          "error"
        );
      } finally {
        setSaving(false);
      }
    };

  /* =======================================================
     AYARLARI KAYDET
  ======================================================= */

  const saveSettings =
    async () => {
      if (!settingsForm) {
        return;
      }

      setSaving(true);

      try {
        const response =
          await apiRequest(
            "/settings",
            language,
            {
              method: "PUT",

              body:
                JSON.stringify(
                  settingsForm
                ),
            }
          );

        setSettingsForm(
          response.data ||
            settingsForm
        );

        setBootstrap(
          (current) =>
            current
              ? {
                  ...current,

                  settings:
                    response.data ||
                    settingsForm,
                }
              : current
        );

        showToast(
          tt.settingsSaved
        );
      } catch (error) {
        showToast(
          error.message ||
            tt.apiError,
          "error"
        );
      } finally {
        setSaving(false);
      }
    };

  /* =======================================================
     PROFİLİ KAYDET
  ======================================================= */

  const saveProfile =
    async () => {
      if (
        !profileForm.ad.trim() ||
        !profileForm.soyad.trim()
      ) {
        showToast(
          tt.requiredFields,
          "error"
        );

        return;
      }

      setSaving(true);

      try {
        const payload = {
          ...profileForm,

          anahtar_kelimeler:
            String(
              profileForm
                .anahtar_kelimeler ||
                ""
            )
              .split(",")
              .map((item) =>
                item.trim()
              )
              .filter(Boolean),

          sektor_ids:
            profileForm
              .sektor_ids || [],

          hizmet_ids:
            profileForm
              .hizmet_ids || [],
        };

        const response =
          await apiRequest(
            "/profile/me",
            language,
            {
              method: "PUT",

              body:
                JSON.stringify(
                  payload
                ),
            }
          );

        setProfileForm(
          toProfileForm(
            response.data
          )
        );

        setBootstrap(
          (current) =>
            current
              ? {
                  ...current,

                  profile:
                    response.data,
                }
              : current
        );

        showToast(
          tt.profileSaved
        );
      } catch (error) {
        showToast(
          error.message ||
            tt.apiError,
          "error"
        );
      } finally {
        setSaving(false);
      }
    };

  /* =======================================================
     KATALOG
  ======================================================= */

  const openCatalogEditor =
    (
      type,
      item = null
    ) => {
      setCatalogModal({
        type,
        item,
      });

      if (type === "sector") {
        setCatalogForm({
          ad_tr:
            item?.ad_tr ||
            item?.name ||
            "",

          ad_en:
            item?.ad_en || "",

          ad_de:
            item?.ad_de || "",

          ust_sektor_id:
            item?.parent_id || "",

          ikon:
            item?.icon ||
            "business_center",

          renk:
            item?.color ||
            "#0B4D8B",

          sira:
            item?.sira || 0,

          aktif:
            item?.aktif !== false,
        });
      } else {
        setCatalogForm({
          ad_tr:
            item?.ad_tr ||
            item?.name ||
            "",

          ad_en:
            item?.ad_en || "",

          ad_de:
            item?.ad_de || "",

          sektor_id:
            item?.sector_id || "",

          sira:
            item?.sira || 0,

          aktif:
            item?.aktif !== false,
        });
      }
    };

  const saveCatalog =
    async () => {
      if (
        !catalogForm.ad_tr?.trim()
      ) {
        showToast(
          tt.requiredFields,
          "error"
        );

        return;
      }

      const type =
        catalogModal?.type;

      const item =
        catalogModal?.item;

      if (
        type === "service" &&
        !catalogForm.sektor_id
      ) {
        showToast(
          tt.requiredFields,
          "error"
        );

        return;
      }

      setSaving(true);

      try {
        const basePath =
          type === "sector"
            ? "/admin/sectors"
            : "/admin/services";

        await apiRequest(
          item?.id
            ? `${basePath}/${item.id}`
            : basePath,
          language,
          {
            method:
              item?.id
                ? "PUT"
                : "POST",

            body:
              JSON.stringify(
                catalogForm
              ),
          }
        );

        setCatalogModal(null);

        showToast(
          tt.catalogSaved
        );

        await Promise.all([
          loadCatalog(),
          loadBootstrap(),
        ]);
      } catch (error) {
        showToast(
          error.message ||
            tt.apiError,
          "error"
        );
      } finally {
        setSaving(false);
      }
    };

  const deactivateCatalog =
    async (
      type,
      item
    ) => {
      if (
        !window.confirm(
          tt.confirmDeactivate
        )
      ) {
        return;
      }

      try {
        await apiRequest(
          type === "sector"
            ? `/admin/sectors/${item.id}`
            : `/admin/services/${item.id}`,
          language,
          {
            method: "DELETE",
          }
        );

        showToast(
          tt.catalogDisabled
        );

        await Promise.all([
          loadCatalog(),
          loadBootstrap(),
        ]);
      } catch (error) {
        showToast(
          error.message ||
            tt.apiError,
          "error"
        );
      }
    };

  /* =======================================================
     FİLTRELER
  ======================================================= */

  const setMemberFilter =
    (key, value) => {
      setMemberFilters(
        (current) => ({
          ...current,

          [key]: value,

          page:
            key === "page"
              ? value
              : 1,
        })
      );
    };

  const setNetworkFilter =
    (key, value) => {
      setNetworkFilters(
        (current) => ({
          ...current,

          [key]: value,

          page:
            key === "page"
              ? value
              : 1,
        })
      );
    };

  const setJobFilter =
    (key, value) => {
      setJobFilters(
        (current) => ({
          ...current,

          [key]: value,

          page:
            key === "page"
              ? value
              : 1,
        })
      );
    };

  /* =======================================================
     YÜKLENİYOR
  ======================================================= */

  if (bootLoading) {
    return (
      <div className="mia-page">
        <style>{CSS}</style>

        <div className="mia-full-loader">
          <div className="mia-loader-logo">
            M
          </div>

          <strong>
            {tt.loading}
          </strong>

          <span />
        </div>
      </div>
    );
  }

  /* =======================================================
     BAŞLANGIÇ HATASI
  ======================================================= */

  if (!bootstrap) {
    return (
      <div className="mia-page">
        <style>{CSS}</style>

        <Card className="mia-error-card">
          <h2>{tt.apiError}</h2>

          <p>{globalError}</p>

          <Button
            onClick={
              loadBootstrap
            }
          >
            {tt.retry}
          </Button>
        </Card>
      </div>
    );
  }

  /* =======================================================
     SAYFA
  ======================================================= */

  return (
    <div className="mia-page">
      <style>{CSS}</style>

      {toast ? (
        <div
          className={`mia-toast mia-toast-${toast.type}`}
        >
          {toast.type === "error"
            ? "!"
            : "✓"}

          <span>
            {toast.message}
          </span>
        </div>
      ) : null}

      {saving ? (
        <div className="mia-saving">
          <span />
        </div>
      ) : null}

      {/* ================= HEADER ================= */}

      <header className="mia-hero">
        <div className="mia-hero-orb mia-hero-orb-one" />

        <div className="mia-hero-orb mia-hero-orb-two" />

        <div className="mia-hero-main">
          <div className="mia-brand-mark">
            <span>M</span>
          </div>

          <div>
            <div className="mia-eyebrow">
              MESYAT DİJİTAL ·{" "}
              {
                bootstrap
                  .institution?.name
              }
            </div>

            <h1>{tt.title}</h1>

            <p>
              {tt.subtitle}
            </p>
          </div>
        </div>

        <div className="mia-hero-actions">
          <div className="mia-lang-switch">
            {ALLOWED_LANGS.map(
              (item) => (
                <button
                  key={item}
                  className={
                    language === item
                      ? "active"
                      : ""
                  }
                  onClick={() => {
                    localStorage.setItem(
                      "app_lang",
                      item
                    );

                    localStorage.setItem(
                      "panel_dili",
                      item
                    );

                    setLanguage(item);

                    window.dispatchEvent(
                      new Event(
                        "app_lang_change"
                      )
                    );
                  }}
                >
                  {item.toUpperCase()}
                </button>
              )
            )}
          </div>

          <Button
            variant="glass"
            onClick={refreshAll}
          >
            <Icon>↻</Icon>

            {tt.refresh}
          </Button>
        </div>
      </header>

      {/* ================= SEKMELER ================= */}

      <nav
        className="mia-tabs"
        aria-label="Business network sections"
      >
        {tabs.map((tab) => (
          <button
            key={tab.id}
            className={
              activeTab === tab.id
                ? "active"
                : ""
            }
            onClick={() =>
              setActiveTab(tab.id)
            }
          >
            <Icon>{tab.icon}</Icon>

            <span>
              {tab.label}
            </span>
          </button>
        ))}
      </nav>

      {globalError ? (
        <div className="mia-alert mia-alert-danger">
          <b>!</b>

          <span>
            {globalError}
          </span>

          <button
            onClick={loadActive}
          >
            ↻
          </button>
        </div>
      ) : null}

      {/* ================= İÇERİK ================= */}

      <main className="mia-content">
        {activeLoading ? (
          <LoadingBlock />
        ) : null}

        {!activeLoading &&
        activeTab ===
          "dashboard" &&
        isManager ? (
          <DashboardView
            data={dashboard}
            tt={tt}
            language={language}
          />
        ) : null}

        {!activeLoading &&
        activeTab ===
          "members" &&
        isManager ? (
          <MembersView
            tt={tt}
            members={members}
            filters={
              memberFilters
            }
            setFilter={
              setMemberFilter
            }
            cities={cities}
            sectors={
              allSectors
            }
            onOpen={openMember}
          />
        ) : null}

        {!activeLoading &&
        activeTab ===
          "network" ? (
          <NetworkView
            tt={tt}
            network={network}
            filters={
              networkFilters
            }
            setFilter={
              setNetworkFilter
            }
            cities={cities}
            sectors={
              allSectors
            }
            onOpen={
              openNetworkProfile
            }
            onFavorite={
              toggleFavorite
            }
          />
        ) : null}

        {!activeLoading &&
        activeTab === "jobs" ? (
          <JobsView
            tt={tt}
            language={language}
            jobs={jobs}
            filters={jobFilters}
            setFilter={
              setJobFilter
            }
            cities={cities}
            sectors={
              allSectors
            }
            onCreate={() =>
              openJobEditor()
            }
            onEdit={
              openJobEditor
            }
            onCancel={
              cancelJob
            }
            onOffers={
              openOffers
            }
            myProfile={
              myProfile
            }
            isManager={
              isManager
            }
          />
        ) : null}

        {!activeLoading &&
        activeTab ===
          "catalogs" &&
        isManager ? (
          <CatalogView
            tt={tt}
            catalog={catalog}
            mainSectors={catalog.sectors.filter(
              (item) =>
                !item.parent_id
            )}
            onAddSector={() =>
              openCatalogEditor(
                "sector"
              )
            }
            onAddService={() =>
              openCatalogEditor(
                "service"
              )
            }
            onEditSector={(
              item
            ) =>
              openCatalogEditor(
                "sector",
                item
              )
            }
            onEditService={(
              item
            ) =>
              openCatalogEditor(
                "service",
                item
              )
            }
            onDeactivate={
              deactivateCatalog
            }
          />
        ) : null}

        {!activeLoading &&
        activeTab ===
          "settings" &&
        isManager ? (
          <SettingsView
            tt={tt}
            form={
              settingsForm
            }
            setForm={
              setSettingsForm
            }
            onSave={
              saveSettings
            }
            saving={saving}
          />
        ) : null}

        {!activeLoading &&
        activeTab ===
          "profile" ? (


  <ProfileView
  tt={tt}
  form={profileForm}
  setForm={
    setProfileForm
  }
  cities={cities}
  sectors={
    allSectors
  }
  services={
    selectedProfileServices
  }
  onSave={
    saveProfile
  }
  saving={saving}
  isManager={isManager}
  onStatusAction={(
    action
  ) =>
    manageProfileStatus(
      profileForm,
      action
    )
  }
/>




        ) : null}
      </main>

      {/* ================= ÜYE MODAL ================= */}

      <Modal
        open={Boolean(
          memberModal
        )}
        title={
          memberModal
            ? `${memberModal.ad} ${memberModal.soyad}`
            : ""
        }
        subtitle={
          memberModal?.firma_adi
        }
        onClose={() => {
          setMemberModal(null);
          setMemberDraft(null);
        }}
      >
        {memberModal &&
        memberDraft ? (


        <MemberManager
  tt={tt}
  member={
    memberModal
  }
  draft={
    memberDraft
  }
  setDraft={
    setMemberDraft
  }
  onSave={
    saveMember
  }
  onQuickAction={(
    action
  ) =>
    manageProfileStatus(
      memberModal,
      action
    )
  }
  saving={saving}
/>




        ) : null}
      </Modal>

      {/* ================= PROFİL DETAY MODAL ================= */}

      <Modal
        open={Boolean(
          profileDetail
        )}
        title={
          profileDetail
            ? `${profileDetail.ad} ${profileDetail.soyad}`
            : ""
        }
        subtitle={
          profileDetail?.firma_adi
        }
        onClose={() =>
          setProfileDetail(null)
        }
      >
        {profileDetail ? (
          <ProfileDetail
            tt={tt}
            language={language}
            profile={
              profileDetail
            }
            onFavorite={() =>
              toggleFavorite(
                profileDetail
              )
            }
          />
        ) : null}
      </Modal>

      {/* ================= İŞ FORMU ================= */}

      <Modal
        open={Boolean(
          jobModal
        )}
        title={
          jobModal?.id
            ? tt.edit
            : tt.addJob
        }
        subtitle={tt.subtitle}
        onClose={() =>
          setJobModal(null)
        }
      >
        <JobEditor
          tt={tt}
          form={jobForm}
          setForm={
            setJobForm
          }
          cities={cities}
          sectors={
            allSectors
          }
          services={
            jobServices
          }
          onSave={saveJob}
          saving={saving}
        />
      </Modal>

      {/* ================= TEKLİFLER ================= */}

      <Modal
        open={Boolean(
          offersModal
        )}
        title={
          offersModal?.baslik ||
          tt.offers
        }
        subtitle={`${tt.offers}: ${offers.length}`}
        onClose={() =>
          setOffersModal(null)
        }
      >
        {offersModal ? (
          <OffersView
            tt={tt}
            language={language}
            job={offersModal}
            offers={offers}
            onStatus={
              setOfferStatus
            }
            onComplete={
              completeJob
            }
            saving={saving}
          />
        ) : null}
      </Modal>

      {/* ================= KATALOG MODAL ================= */}

      <Modal
        open={Boolean(
          catalogModal
        )}
        title={
          catalogModal?.type ===
          "sector"
            ? tt.addSector
            : tt.addService
        }
        onClose={() =>
          setCatalogModal(null)
        }
        size="medium"
      >
        {catalogModal ? (
          <CatalogEditor
            tt={tt}
            type={
              catalogModal.type
            }
            form={
              catalogForm
            }
            setForm={
              setCatalogForm
            }
            mainSectors={catalog.sectors.filter(
              (item) =>
                !item.parent_id
            )}
            sectors={
              catalog.sectors
            }
            onSave={
              saveCatalog
            }
            saving={saving}
          />
        ) : null}
      </Modal>
    </div>
  );
}

/* =========================================================
   DASHBOARD
========================================================= */

function DashboardView({
  data,
  tt,
  language,
}) {
  if (!data) {
    return (
      <EmptyState
        title={tt.noData}
      />
    );
  }

  const members =
    data.members || {};

  const jobs =
    data.jobs || {};

  const offers =
    data.offers || {};

  return (
    <div className="mia-section-stack mia-animate-in">
      <div className="mia-stats-grid">
        <StatCard
          icon="♙"
          label={
            tt.totalMembers
          }
          value={
            members.total_members
          }
          tone="blue"
        />

        <StatCard
          icon="✓"
          label={
            tt.activeMembers
          }
          value={
            members.active_members
          }
          tone="green"
        />

        <StatCard
          icon="◷"
          label={
            tt.pendingMembers
          }
          value={
            members.pending_members
          }
          tone="orange"
        />

        <StatCard
          icon="▣"
          label={
            tt.openJobs
          }
          value={
            jobs.open_jobs
          }
          tone="purple"
        />

        <StatCard
          icon="★"
          label={
            tt.completedJobs
          }
          value={
            jobs.completed_jobs
          }
          tone="green"
        />

        <StatCard
          icon="↗"
          label={
            tt.pendingOffers
          }
          value={
            offers.pending_offers
          }
          tone="orange"
        />

        <StatCard
          icon="◉"
          label={
            tt.profileViews
          }
          value={
            members
              .total_profile_views
          }
          tone="cyan"
        />

        <StatCard
          icon="%"
          label={
            tt.profileCompletion
          }
          value={`${
            members
              .average_completion ||
            0
          }%`}
          tone="blue"
        />
      </div>

      <div className="mia-two-column">
        <Card>
          <div className="mia-card-head">
            <div>
              <span className="mia-card-kicker">
                SMART CRM
              </span>

              <h2>
                {tt.assistant}
              </h2>
            </div>

            <div className="mia-live-dot">
              <i />
              LIVE
            </div>
          </div>

          <div className="mia-assistant-list">
            {(data.assistant || [])
              .length ? (
              data.assistant.map(
                (
                  item,
                  index
                ) => (
                  <div
                    className={`mia-assistant-item mia-assistant-${item.type}`}
                    key={`${item.code}-${index}`}
                  >
                    <span>
                      {item.type ===
                      "warning"
                        ? "!"
                        : item.type ===
                          "birthday"
                        ? "✦"
                        : "i"}
                    </span>

                    <div>
                      <strong>
                        {
                          item.title
                        }
                      </strong>

                      <p>
                        {
                          item.message
                        }
                      </p>
                    </div>
                  </div>
                )
              )
            ) : (
              <EmptyState
                title={
                  tt.noSuggestion
                }
              />
            )}
          </div>
        </Card>

        <Card>
          <div className="mia-card-head">
            <div>
              <span className="mia-card-kicker">
                MEMBERS
              </span>

              <h2>
                {tt.topMembers}
              </h2>
            </div>
          </div>

          <div className="mia-compact-list">
            {(data.top_members || [])
              .slice(0, 8)
              .map(
                (
                  member,
                  index
                ) => (
                  <div
                    className="mia-compact-item"
                    key={member.id}
                  >
                    <span className="mia-rank">
                      {String(
                        index + 1
                      ).padStart(
                        2,
                        "0"
                      )}
                    </span>

                    <Avatar
                      item={member}
                      size="small"
                    />

                    <div className="mia-grow">
                      <strong>
                        {member.ad}{" "}
                        {
                          member.soyad
                        }
                      </strong>

                      <small>
                        {member.firma_adi ||
                          "-"}
                      </small>
                    </div>

                    <div className="mia-score">
                      <b>
                        ★{" "}
                        {Number(
                          member.rating ||
                            0
                        ).toFixed(1)}
                      </b>

                      <small>
                        {member.completed_jobs ||
                          0}{" "}
                        {
                          tt.completedWork
                        }
                      </small>
                    </div>
                  </div>
                )
              )}

            {!(
              data.top_members || []
            ).length ? (
              <EmptyState
                title={tt.noData}
              />
            ) : null}
          </div>
        </Card>
      </div>

      <div className="mia-three-column">
        <DistributionCard
          title={
            tt.cityDistribution
          }
          rows={
            data.city_distribution ||
            []
          }
        />

        <DistributionCard
          title={
            tt.sectorDistribution
          }
          rows={
            data.sector_distribution ||
            []
          }
        />

        <Card>
          <div className="mia-card-head">
            <div>
              <span className="mia-card-kicker">
                CALENDAR
              </span>

              <h2>
                {
                  tt.upcomingBirthdays
                }
              </h2>
            </div>
          </div>

          <div className="mia-compact-list">
            {(data.birthdays || []).map(
              (member) => (
                <div
                  className="mia-compact-item"
                  key={member.id}
                >
                  <div className="mia-date-box">
                    <b>
                      {new Date(
                        member.dogum_tarihi
                      ).getDate()}
                    </b>

                    <span>
                      {new Date(
                        member.dogum_tarihi
                      ).toLocaleDateString(
                        language,
                        {
                          month:
                            "short",
                        }
                      )}
                    </span>
                  </div>

                  <Avatar
                    item={member}
                    size="small"
                  />

                  <div className="mia-grow">
                    <strong>
                      {member.ad}{" "}
                      {
                        member.soyad
                      }
                    </strong>

                    <small>
                      {member.firma_adi ||
                        "-"}
                    </small>
                  </div>
                </div>
              )
            )}

            {!(
              data.birthdays || []
            ).length ? (
              <EmptyState
                title={tt.noData}
              />
            ) : null}
          </div>
        </Card>
      </div>
    </div>
  );
}

function DistributionCard({
  title,
  rows,
}) {
  const max = Math.max(
    ...rows.map((item) =>
      Number(item.count || 0)
    ),
    1
  );

  return (
    <Card>
      <div className="mia-card-head">
        <div>
          <span className="mia-card-kicker">
            ANALYTICS
          </span>

          <h2>{title}</h2>
        </div>
      </div>

      <div className="mia-bars">
        {rows
          .slice(0, 8)
          .map((row) => (
            <div
              className="mia-bar-row"
              key={`${
                row.id || "x"
              }-${row.name}`}
            >
              <div>
                <span>
                  {row.name}
                </span>

                <b>
                  {row.count}
                </b>
              </div>

              <i>
                <em
                  style={{
                    width: `${Math.max(
                      (Number(
                        row.count ||
                          0
                      ) /
                        max) *
                        100,
                      4
                    )}%`,
                  }}
                />
              </i>
            </div>
          ))}

        {!rows.length ? (
          <EmptyState title="-" />
        ) : null}
      </div>
    </Card>
  );
}

/* =========================================================
   ÜYE LİSTESİ
========================================================= */

function MembersView({
  tt,
  members,
  filters,
  setFilter,
  cities,
  sectors,
  onOpen,
}) {
  return (
    <div className="mia-section-stack mia-animate-in">
      <div className="mia-section-title">
        <div>
          <span>
            CRM DIRECTORY
          </span>

          <h2>{tt.members}</h2>

          <p>
            {
              members.pagination
                .total
            }{" "}
            {tt.record}
          </p>
        </div>
      </div>

      <Card className="mia-filter-card">
        <div className="mia-filter-grid">
          <Field label={tt.search}>
            <input
              value={filters.q}
              onChange={(event) =>
                setFilter(
                  "q",
                  event.target.value
                )
              }
              placeholder={
                tt.memberSearch
              }
            />
          </Field>

          <Field label={tt.status}>
            <select
              value={filters.status}
              onChange={(event) =>
                setFilter(
                  "status",
                  event.target.value
                )
              }
            >
              <option value="all">
                {tt.all}
              </option>

              <option value="beklemede">
                {tt.pending}
              </option>

              <option value="onaylandi">
                {tt.approved}
              </option>

              <option value="reddedildi">
                {tt.rejected}
              </option>

              <option value="askida">
                {tt.suspended}
              </option>
            </select>
          </Field>

          <Field
            label={tt.membership}
          >
            <select
              value={
                filters.membership
              }
              onChange={(event) =>
                setFilter(
                  "membership",
                  event.target.value
                )
              }
            >
              <option value="all">
                {tt.all}
              </option>

              <option value="aktif">
                {tt.active}
              </option>

              <option value="pasif">
                {tt.passive}
              </option>

              <option value="ayrilmis">
                {tt.left}
              </option>

              <option value="dondurulmus">
                {tt.frozen}
              </option>
            </select>
          </Field>

          <Field label={tt.city}>
            <select
              value={
                filters.city_id
              }
              onChange={(event) =>
                setFilter(
                  "city_id",
                  event.target.value
                )
              }
            >
              <option value="">
                {tt.all}
              </option>

              {cities.map(
                (city) => (
                  <option
                    key={city.id}
                    value={city.id}
                  >
                    {city.name}
                  </option>
                )
              )}
            </select>
          </Field>

          <Field label={tt.sector}>
            <select
              value={
                filters.sector_id
              }
              onChange={(event) =>
                setFilter(
                  "sector_id",
                  event.target.value
                )
              }
            >
              <option value="">
                {tt.all}
              </option>

              {sectors.map(
                (sector) => (
                  <option
                    key={sector.id}
                    value={sector.id}
                  >
                    {sector.name}
                  </option>
                )
              )}
            </select>
          </Field>

          <div className="mia-filter-actions">
            <Button
              variant="soft"
            onClick={() => {
  setFilter("q", "");
  setFilter("status", "all");
  setFilter("membership", "all");
  setFilter("city_id", "");
  setFilter("sector_id", "");
}}
            >
              {tt.clear}


            </Button>
          </div>
        </div>
      </Card>

      <div className="mia-member-grid">
        {members.data.map(
          (member) => (
            <MemberCard
              key={member.id}
              member={member}
              tt={tt}
              onOpen={() =>
                onOpen(member)
              }
            />
          )
        )}
      </div>

      {!members.data.length ? (
        <EmptyState
          title={tt.noData}
        />
      ) : null}

      <Pagination
        {...members.pagination}
        onChange={(page) =>
          setFilter("page", page)
        }
        tt={tt}
      />
    </div>
  );
}

function MemberCard({
  member,
  tt,
  onOpen,
}) {
  return (
    <Card className="mia-member-card">
      <div className="mia-member-cover">
        <span />

        <div className="mia-member-flags">
          {member.one_cikan ? (
            <Badge value="onaylandi">
              ★ {tt.featured}
            </Badge>
          ) : null}

          {member.dogrulanmis ? (
            <Badge value="onaylandi">
              ✓ {tt.verified}
            </Badge>
          ) : null}
        </div>
      </div>

      <div className="mia-member-body">
        <Avatar
          item={member}
          size="large"
        />

        <div className="mia-member-heading">
          <h3>
            {member.ad}{" "}
            {member.soyad}
          </h3>

          <p>
            {member.firma_adi ||
              member.meslek ||
              "-"}
          </p>

          <div className="mia-badge-row">
            <Badge
              value={
                member.onay_durumu
              }
            >
              {statusLabel(
                member.onay_durumu,
                tt
              )}
            </Badge>

            <Badge
              value={
                member.uyelik_durumu
              }
            >
              {statusLabel(
                member.uyelik_durumu,
                tt
              )}
            </Badge>
          </div>
        </div>

        <div className="mia-progress">
          <div>
            <span>
              {tt.completion}
            </span>

            <b>
              {member
                .profil_tamamlanma_orani ||
                0}
              %
            </b>
          </div>

          <i>
            <em
              style={{
                width: `${
                  member
                    .profil_tamamlanma_orani ||
                  0
                }%`,
              }}
            />
          </i>
        </div>

        <div className="mia-member-meta">
          <span>
            ⌖{" "}
            {member.il_adi ||
              member.il_adi_serbest ||
              "-"}
          </span>

          <span>
            ◉{" "}
            {member.meslek || "-"}
          </span>

          <span>
            ✉{" "}
            {member.email || "-"}
          </span>
        </div>

        <div className="mia-chip-list">
          {(member.sektorler || [])
            .slice(0, 4)
            .map((sector) => (
              <span
                key={sector.id}
              >
                {sector.name}
              </span>
            ))}
        </div>

        <Button
          onClick={onOpen}
          className="mia-full"
        >
          <Icon>⚙</Icon>

          {tt.manageMember}
        </Button>
      </div>
    </Card>
  );
}

/* =========================================================
   ÜYE YÖNETİM MODALI
========================================================= */

function MemberManager({
  tt,
  member,
  draft,
  setDraft,
  onSave,
  onQuickAction,
  saving,
}) {

  return (
    <div className="mia-modal-grid">
      <div className="mia-detail-panel">
        <div className="mia-profile-hero">
          <Avatar
            item={member}
            size="xlarge"
          />

          <div>
            <h3>
              {member.ad}{" "}
              {member.soyad}
            </h3>

            <p>
              {member.firma_adi ||
                member.meslek ||
                "-"}
            </p>

            <div className="mia-badge-row">
              <Badge
                value={
                  member.onay_durumu
                }
              >
                {statusLabel(
                  member.onay_durumu,
                  tt
                )}
              </Badge>

              <Badge
                value={
                  member.uyelik_durumu
                }
              >
                {statusLabel(
                  member.uyelik_durumu,
                  tt
                )}
              </Badge>
            </div>
          </div>
        </div>

        <div className="mia-info-grid">
          <Info
            label={tt.memberCode}
            value={
              member.uye_kodu
            }
          />

          <Info
            label={
              tt.membershipNo
            }
            value={
              member
                .dernek_uyelik_no
            }
          />

          <Info
            label={tt.phone}
            value={member.telefon}
          />

          <Info
            label={tt.email}
            value={member.email}
          />

          <Info
            label={tt.city}
            value={
              member.il_adi ||
              member.il_adi_serbest
            }
          />

          <Info
            label={tt.profession}
            value={member.meslek}
          />
        </div>

        {member.hakkinda ? (
          <div className="mia-text-box">
            <strong>
              {tt.about}
            </strong>

            <p>
              {member.hakkinda}
            </p>
          </div>
        ) : null}

        <div className="mia-chip-list">
          {(member.sektorler || []).map(
            (sector) => (
              <span
                key={sector.id}
              >
                {sector.name}
              </span>
            )
          )}
        </div>
      </div>

     <Card className="mia-control-panel">
  <h3>
    {tt.manageMember}
  </h3>

  <NetworkStatusActions
    tt={tt}
    profile={{
      ...member,
      ...draft,
    }}
    onAction={
      onQuickAction
    }
    saving={saving}
  />

  <Field label={tt.status}>

          <select
            value={
              draft.onay_durumu
            }
            onChange={(event) =>
              setDraft(
                (current) => ({
                  ...current,

                  onay_durumu:
                    event.target
                      .value,
                })
              )
            }
          >
            <option value="beklemede">
              {tt.pending}
            </option>

            <option value="onaylandi">
              {tt.approved}
            </option>

            <option value="reddedildi">
              {tt.rejected}
            </option>

            <option value="askida">
              {tt.suspended}
            </option>
          </select>
        </Field>

        <Field
          label={tt.membership}
        >
          <select
            value={
              draft.uyelik_durumu
            }
            onChange={(event) =>
              setDraft(
                (current) => ({
                  ...current,

                  uyelik_durumu:
                    event.target
                      .value,
                })
              )
            }
          >
            <option value="aktif">
              {tt.active}
            </option>

            <option value="pasif">
              {tt.passive}
            </option>

            <option value="ayrilmis">
              {tt.left}
            </option>

            <option value="dondurulmus">
              {tt.frozen}
            </option>
          </select>
        </Field>

        <Field
          label={
            tt.rejectionReason
          }
        >
          <textarea
            rows="4"
            value={
              draft.red_nedeni
            }
            onChange={(event) =>
              setDraft(
                (current) => ({
                  ...current,

                  red_nedeni:
                    event.target
                      .value,
                })
              )
            }
          />
        </Field>

        <Toggle
          label={
            tt.profileVisible
          }
          checked={
            draft.profil_gorunur
          }
          onChange={(value) =>
            setDraft(
              (current) => ({
                ...current,

                profil_gorunur:
                  value,
              })
            )
          }
        />

        <Toggle
          label={
            tt.platformVisible
          }
          checked={
            draft
              .platformda_gorunur
          }
          onChange={(value) =>
            setDraft(
              (current) => ({
                ...current,

                platformda_gorunur:
                  value,
              })
            )
          }
        />

        <Toggle
          label={
            tt.makeFeatured
          }
          checked={
            draft.one_cikan
          }
          onChange={(value) =>
            setDraft(
              (current) => ({
                ...current,

                one_cikan:
                  value,
              })
            )
          }
        />

        <Toggle
          label={
            tt.makeVerified
          }
          checked={
            draft.dogrulanmis
          }
          onChange={(value) =>
            setDraft(
              (current) => ({
                ...current,

                dogrulanmis:
                  value,
              })
            )
          }
        />

        <Toggle
          label={tt.active}
          checked={draft.aktif}
          onChange={(value) =>
            setDraft(
              (current) => ({
                ...current,

                aktif: value,
              })
            )
          }
        />

        <Button
          onClick={onSave}
          disabled={saving}
          className="mia-full"
        >
          {saving
            ? tt.loading
            : tt.save}
        </Button>
      </Card>
    </div>
  );
}

/* =========================================================
   İŞ AĞI
========================================================= */

function NetworkView({
  tt,
  network,
  filters,
  setFilter,
  cities,
  sectors,
  onOpen,
  onFavorite,
}) {
  return (
    <div className="mia-section-stack mia-animate-in">
      <div className="mia-section-title">
        <div>
          <span>
            BUSINESS DIRECTORY
          </span>

          <h2>{tt.network}</h2>

          <p>
            {
              network.pagination
                .total
            }{" "}
            {tt.record}
          </p>
        </div>
      </div>

      <Card className="mia-filter-card">
        <div className="mia-filter-grid mia-filter-grid-network">
          <Field label={tt.search}>
            <input
              value={filters.q}
              onChange={(event) =>
                setFilter(
                  "q",
                  event.target.value
                )
              }
              placeholder={
                tt.networkSearch
              }
            />
          </Field>

          <Field
            label={tt.visibility}
          >
            <select
              value={filters.scope}
              onChange={(event) =>
                setFilter(
                  "scope",
                  event.target.value
                )
              }
            >
              <option value="all">
                {tt.all}
              </option>

              <option value="institution">
                {
                  tt.institutionNetwork
                }
              </option>

              <option value="platform">
                {
                  tt.platformNetwork
                }
              </option>
            </select>
          </Field>

          <Field label={tt.city}>
            <select
              value={
                filters.city_id
              }
              onChange={(event) =>
                setFilter(
                  "city_id",
                  event.target.value
                )
              }
            >
              <option value="">
                {tt.all}
              </option>

              {cities.map(
                (city) => (
                  <option
                    key={city.id}
                    value={city.id}
                  >
                    {city.name}
                  </option>
                )
              )}
            </select>
          </Field>

          <Field label={tt.sector}>
            <select
              value={
                filters.sector_id
              }
              onChange={(event) =>
                setFilter(
                  "sector_id",
                  event.target.value
                )
              }
            >
              <option value="">
                {tt.all}
              </option>

              {sectors.map(
                (sector) => (
                  <option
                    key={sector.id}
                    value={sector.id}
                  >
                    {sector.name}
                  </option>
                )
              )}
            </select>
          </Field>
        </div>
      </Card>

      <div className="mia-network-grid">
        {network.data.map(
          (member) => (
            <Card
              className="mia-network-card"
              key={member.id}
            >
              <div className="mia-network-top">
                <Avatar
                  item={member}
                  size="large"
                />

                <button
                  className={`mia-heart ${
                    member.favoride
                      ? "active"
                      : ""
                  }`}
                  onClick={() =>
                    onFavorite(
                      member
                    )
                  }
                >
                  ♥
                </button>
              </div>

              <h3>
                {member.ad}{" "}
                {member.soyad}
              </h3>

              <p className="mia-company-line">
                {member.firma_adi ||
                  member.meslek ||
                  "-"}
              </p>

              <div className="mia-rating">
                <span>
                  ★{" "}
                  {Number(
                    member
                      .puan_ortalamasi ||
                      0
                  ).toFixed(1)}
                </span>

                <small>
                  {member
                    .degerlendirme_sayisi ||
                    0}{" "}
                  {tt.ratings}
                </small>
              </div>

              <div className="mia-member-meta">
                <span>
                  ⌖{" "}
                  {member.il_adi ||
                    member
                      .il_adi_serbest ||
                    "-"}
                </span>

                <span>
                  ◉{" "}
                  {member.meslek ||
                    "-"}
                </span>
              </div>

              <div className="mia-chip-list">
                {(member.sektorler ||
                  [])
                  .slice(0, 3)
                  .map(
                    (sector) => (
                      <span
                        key={
                          sector.id
                        }
                      >
                        {
                          sector.name
                        }
                      </span>
                    )
                  )}
              </div>

              <div className="mia-card-actions">
                <Button
                  variant="soft"
                  onClick={() =>
                    onFavorite(
                      member
                    )
                  }
                >
                  {member.favoride
                    ? tt.unfavorite
                    : tt.favorite}
                </Button>

                <Button
                  onClick={() =>
                    onOpen(member)
                  }
                >
                  {tt.viewProfile}
                </Button>
              </div>
            </Card>
          )
        )}
      </div>

      {!network.data.length ? (
        <EmptyState
          title={tt.noData}
          text={
            tt.networkSearch
          }
        />
      ) : null}

      <Pagination
        {...network.pagination}
        onChange={(page) =>
          setFilter("page", page)
        }
        tt={tt}
      />
    </div>
  );
}

/* =========================================================
   PROFİL DETAYI
========================================================= */

function ProfileDetail({
  tt,
  language,
  profile,
  onFavorite,
}) {
  return (
    <div className="mia-detail-panel">
      <div
        className="mia-profile-cover"
        style={
          profile.kapak_fotografi
            ? {
                backgroundImage: `url(${profile.kapak_fotografi})`,
              }
            : undefined
        }
      />

      <div className="mia-profile-hero mia-profile-hero-overlap">
        <Avatar
          item={profile}
          size="xlarge"
        />

        <div className="mia-grow">
          <h3>
            {profile.ad}{" "}
            {profile.soyad}
          </h3>

          <p>
            {profile.firma_adi ||
              profile.meslek ||
              "-"}
          </p>

          <div className="mia-badge-row">
            {profile.dogrulanmis ? (
              <Badge value="onaylandi">
                ✓ {tt.verified}
              </Badge>
            ) : null}

            {profile.one_cikan ? (
              <Badge value="onaylandi">
                ★ {tt.featured}
              </Badge>
            ) : null}
          </div>
        </div>

        <Button
          variant={
            profile.favoride
              ? "dangerSoft"
              : "soft"
          }
          onClick={onFavorite}
        >
          ♥{" "}
          {profile.favoride
            ? tt.unfavorite
            : tt.favorite}
        </Button>
      </div>

      <div className="mia-info-grid">
        <Info
          label={tt.city}
          value={[
            profile.ilce_adi ||
              profile
                .ilce_adi_serbest,

            profile.il_adi ||
              profile.il_adi_serbest,
          ]
            .filter(Boolean)
            .join(" / ")}
        />

        <Info
          label={tt.profession}
          value={profile.meslek}
        />

        <Info
          label={tt.phone}
          value={profile.telefon}
        />

        <Info
          label={tt.whatsapp}
          value={profile.whatsapp}
        />

        <Info
          label={tt.email}
          value={profile.email}
        />

        <Info
          label={tt.completedWork}
          value={
            profile
              .tamamlanan_is_sayisi ||
            0
          }
        />
      </div>

      <div className="mia-detail-sections">
        {profile.hakkinda ? (
          <div className="mia-text-box">
            <strong>
              {tt.about}
            </strong>

            <p>
              {profile.hakkinda}
            </p>
          </div>
        ) : null}

        {profile.sundugu_urunler ? (
          <div className="mia-text-box">
            <strong>
              {tt.products}
            </strong>

            <p>
              {
                profile
                  .sundugu_urunler
              }
            </p>
          </div>
        ) : null}

        {profile.aradigi_hizmetler ? (
          <div className="mia-text-box">
            <strong>
              {tt.needs}
            </strong>

            <p>
              {
                profile
                  .aradigi_hizmetler
              }
            </p>
          </div>
        ) : null}

        {profile.is_ortakligi_aciklama ? (
          <div className="mia-text-box">
            <strong>
              {tt.partnership}
            </strong>

            <p>
              {
                profile
                  .is_ortakligi_aciklama
              }
            </p>
          </div>
        ) : null}
      </div>

      <div className="mia-chip-list">
        {(profile.sektorler || []).map(
          (sector) => (
            <span key={sector.id}>
              {sector.name}
            </span>
          )
        )}
      </div>

      <h3 className="mia-subtitle">
        {tt.services}
      </h3>

      <div className="mia-chip-list">
        {(profile.hizmetler || []).map(
          (
            service,
            index
          ) => (
            <span
              key={`${service.id}-${index}`}
            >
              {service.name}
            </span>
          )
        )}
      </div>

      <h3 className="mia-subtitle">
        {tt.ratings}
      </h3>

      <div className="mia-review-list">
        {(profile.degerlendirmeler ||
          []).map((review) => (
          <div
            className="mia-review"
            key={review.id}
          >
            <div>
              <strong>
                {
                  review
                    .degerlendiren_ad
                }{" "}
                {
                  review
                    .degerlendiren_soyad
                }
              </strong>

              <span>
                ★{" "}
                {Number(
                  review.genel_puan ||
                    0
                ).toFixed(1)}
              </span>
            </div>

            <p>
              {review.yorum || "-"}
            </p>

            <small>
              {dateText(
                review.created_at,
                language
              )}
            </small>
          </div>
        ))}
      </div>

      {!(
        profile.degerlendirmeler ||
        []
      ).length ? (
        <EmptyState
          title={tt.noData}
        />
      ) : null}
    </div>
  );
}

/* =========================================================
   İŞ TALEPLERİ
========================================================= */

function JobsView({
  tt,
  language,
  jobs,
  filters,
  setFilter,
  cities,
  sectors,
  onCreate,
  onEdit,
  onCancel,
  onOffers,
  myProfile,
  isManager,
}) {
  const canCreate =
    myProfile?.onay_durumu ===
      "onaylandi" &&
    myProfile?.aktif;

  return (
    <div className="mia-section-stack mia-animate-in">
      <div className="mia-section-title mia-section-title-actions">
        <div>
          <span>
            OPPORTUNITY CENTER
          </span>

          <h2>{tt.jobs}</h2>

          <p>
            {
              jobs.pagination.total
            }{" "}
            {tt.record}
          </p>
        </div>

        <Button
          onClick={onCreate}
          disabled={!canCreate}
        >
          <Icon>＋</Icon>

          {tt.addJob}
        </Button>
      </div>

      {!canCreate ? (
        <div className="mia-alert mia-alert-warning">
          <b>i</b>

          <span>
            {tt.profileRequired}
          </span>
        </div>
      ) : null}

      <Card className="mia-filter-card">
        <div className="mia-filter-grid">
          <Field label={tt.search}>
            <input
              value={filters.q}
              onChange={(event) =>
                setFilter(
                  "q",
                  event.target.value
                )
              }
              placeholder={
                tt.jobSearch
              }
            />
          </Field>

          <Field
            label={tt.visibility}
          >
            <select
              value={filters.scope}
              onChange={(event) =>
                setFilter(
                  "scope",
                  event.target.value
                )
              }
            >
              <option value="all">
                {tt.all}
              </option>

              <option value="mine">
                {tt.myProfile}
              </option>

              <option value="institution">
                {
                  tt.institutionNetwork
                }
              </option>

              <option value="platform">
                {
                  tt.platformNetwork
                }
              </option>
            </select>
          </Field>

          <Field label={tt.status}>
            <select
              value={filters.status}
              onChange={(event) =>
                setFilter(
                  "status",
                  event.target.value
                )
              }
            >
              <option value="all">
                {tt.all}
              </option>

              <option value="acik">
                {tt.openJobs}
              </option>

              <option value="teklif_secildi">
                {tt.accept}
              </option>

              <option value="tamamlandi">
                {tt.completedJobs}
              </option>

              <option value="iptal">
                {tt.cancel}
              </option>
            </select>
          </Field>

          <Field label={tt.city}>
            <select
              value={
                filters.city_id
              }
              onChange={(event) =>
                setFilter(
                  "city_id",
                  event.target.value
                )
              }
            >
              <option value="">
                {tt.all}
              </option>

              {cities.map(
                (city) => (
                  <option
                    value={city.id}
                    key={city.id}
                  >
                    {city.name}
                  </option>
                )
              )}
            </select>
          </Field>

          <Field label={tt.sector}>
            <select
              value={
                filters.sector_id
              }
              onChange={(event) =>
                setFilter(
                  "sector_id",
                  event.target.value
                )
              }
            >
              <option value="">
                {tt.all}
              </option>

              {sectors.map(
                (sector) => (
                  <option
                    value={sector.id}
                    key={sector.id}
                  >
                    {sector.name}
                  </option>
                )
              )}
            </select>
          </Field>
        </div>
      </Card>

      <div className="mia-job-list">
        {jobs.data.map((job) => {
          const owner =
            myProfile &&
            Number(
              job.olusturan_uye_id
            ) ===
              Number(
                myProfile.id
              );

          return (
            <Card
              className="mia-job-card"
              key={job.id}
            >
              <div className="mia-job-accent" />

              <div className="mia-job-main">
                <div className="mia-job-head">
                  <div>
                    <div className="mia-badge-row">
                      <Badge
                        value={
                          job.durum
                        }
                      >
                        {statusLabel(
                          job.durum,
                          tt
                        )}
                      </Badge>

                      <Badge
                        value={
                          job.gorunurluk ===
                          "platform"
                            ? "onaylandi"
                            : "neutral"
                        }
                      >
                        {job.gorunurluk ===
                        "platform"
                          ? tt.wholePlatform
                          : tt.institutionOnly}
                      </Badge>
                    </div>

                    <h3>
                      {job.baslik}
                    </h3>

                    <p>
                      {job.aciklama}
                    </p>
                  </div>

                  <div className="mia-budget">
                    <small>
                      {tt.maxBudget}
                    </small>

                    <strong>
                      {job.butce_max
                        ? money(
                            job.butce_max,
                            job.para_birimi,
                            language
                          )
                        : "-"}
                    </strong>
                  </div>
                </div>

                <div className="mia-job-meta">
                  <span>
                    ◉{" "}
                    {job.sektor_adi ||
                      job
                        .ozel_sektor_adi ||
                      "-"}
                  </span>

                  <span>
                    ⌖{" "}
                    {job.il_adi ||
                      job
                        .il_adi_serbest ||
                      "-"}
                  </span>

                  <span>
                    ◷{" "}
                    {dateText(
                      job.son_teklif_tarihi,
                      language
                    )}
                  </span>

                  <span>
                    ↗{" "}
                    {job.teklif_sayisi ||
                      0}{" "}
                    {tt.offers}
                  </span>
                </div>

                <div className="mia-job-owner">
                  <Avatar
                    item={{
                      ad:
                        job.olusturan_ad,

                      soyad:
                        job
                          .olusturan_soyad,

                      profil_fotografi:
                        job
                          .olusturan_profil_fotografi,
                    }}
                    size="small"
                  />

                  <div>
                    <strong>
                      {
                        job.olusturan_ad
                      }{" "}
                      {
                        job
                          .olusturan_soyad
                      }
                    </strong>

                    <small>
                      {job
                        .olusturan_firma_adi ||
                        "-"}
                    </small>
                  </div>
                </div>

                <div className="mia-card-actions">
                  <Button
                    variant="soft"
                    onClick={() =>
                      onOffers(job)
                    }
                  >
                    {tt.offers} (
                    {job.teklif_sayisi ||
                      0}
                    )
                  </Button>

                  {(owner ||
                    isManager) &&
                  ![
                    "tamamlandi",
                    "iptal",
                    "kapali",
                  ].includes(
                    job.durum
                  ) ? (
                    <>
                      <Button
                        variant="soft"
                        onClick={() =>
                          onEdit(job)
                        }
                      >
                        {tt.edit}
                      </Button>

                      <Button
                        variant="dangerSoft"
                        onClick={() =>
                          onCancel(job)
                        }
                      >
                        {tt.cancel}
                      </Button>
                    </>
                  ) : null}
                </div>
              </div>
            </Card>
          );
        })}
      </div>

      {!jobs.data.length ? (
        <EmptyState
          title={tt.noData}
        />
      ) : null}

      <Pagination
        {...jobs.pagination}
        onChange={(page) =>
          setFilter("page", page)
        }
        tt={tt}
      />
    </div>
  );
}

/* =========================================================
   İŞ FORMU
========================================================= */

function JobEditor({
  tt,
  form,
  setForm,
  cities,
  sectors,
  services,
  onSave,
  saving,
}) {
  const update =
    (key, value) => {
      setForm(
        (current) => ({
          ...current,
          [key]: value,
        })
      );
    };

  return (
    <div className="mia-form-stack">
      <div className="mia-form-grid">
        <Field
          label={tt.jobTitle}
          required
        >
          <input
            value={form.baslik}
            onChange={(event) =>
              update(
                "baslik",
                event.target.value
              )
            }
          />
        </Field>

        <Field
          label={tt.visibility}
        >
          <select
            value={
              form.gorunurluk
            }
            onChange={(event) =>
              update(
                "gorunurluk",
                event.target.value
              )
            }
          >
            <option value="kurum">
              {tt.institutionOnly}
            </option>

            <option value="platform">
              {tt.wholePlatform}
            </option>
          </select>
        </Field>

        <Field
          label={tt.description}
          className="mia-span-2"
          required
        >
          <textarea
            rows="5"
            value={
              form.aciklama
            }
            onChange={(event) =>
              update(
                "aciklama",
                event.target.value
              )
            }
          />
        </Field>

        <Field label={tt.sector}>
          <select
            value={
              form.sektor_id
            }
            onChange={(event) => {
              update(
                "sektor_id",
                event.target.value
              );

              update(
                "hizmet_id",
                ""
              );
            }}
          >
            <option value="">
              {tt.all}
            </option>

            {sectors.map(
              (sector) => (
                <option
                  value={sector.id}
                  key={sector.id}
                >
                  {sector.name}
                </option>
              )
            )}
          </select>
        </Field>

        <Field label={tt.service}>
          <select
            value={
              form.hizmet_id
            }
            onChange={(event) =>
              update(
                "hizmet_id",
                event.target.value
              )
            }
          >
            <option value="">
              {tt.all}
            </option>

            {services.map(
              (service) => (
                <option
                  value={service.id}
                  key={service.id}
                >
                  {service.name}
                </option>
              )
            )}
          </select>
        </Field>

        <Field label={tt.city}>
          <select
            value={form.il_id}
            onChange={(event) =>
              update(
                "il_id",
                event.target.value
              )
            }
          >
            <option value="">
              {tt.all}
            </option>

            {cities.map(
              (city) => (
                <option
                  value={city.id}
                  key={city.id}
                >
                  {city.name}
                </option>
              )
            )}
          </select>
        </Field>

        <Field
          label={tt.freeDistrict}
        >
          <input
            value={
              form
                .ilce_adi_serbest
            }
            onChange={(event) =>
              update(
                "ilce_adi_serbest",
                event.target.value
              )
            }
          />
        </Field>

        <Field
          label={tt.minBudget}
        >
          <input
            type="number"
            min="0"
            value={
              form.butce_min
            }
            onChange={(event) =>
              update(
                "butce_min",
                event.target.value
              )
            }
          />
        </Field>

        <Field
          label={tt.maxBudget}
        >
          <input
            type="number"
            min="0"
            value={
              form.butce_max
            }
            onChange={(event) =>
              update(
                "butce_max",
                event.target.value
              )
            }
          />
        </Field>

        <Field
          label={tt.currency}
        >
          <select
            value={
              form.para_birimi
            }
            onChange={(event) =>
              update(
                "para_birimi",
                event.target.value
              )
            }
          >
            <option>TRY</option>
            <option>EUR</option>
            <option>USD</option>
            <option>CHF</option>
          </select>
        </Field>

        <Field
          label={
            tt.offerDeadline
          }
        >
          <input
            type="date"
            value={
              form
                .son_teklif_tarihi
            }
            onChange={(event) =>
              update(
                "son_teklif_tarihi",
                event.target.value
              )
            }
          />
        </Field>

        <Field
          label={tt.startDate}
        >
          <input
            type="date"
            value={
              form
                .is_baslangic_tarihi
            }
            onChange={(event) =>
              update(
                "is_baslangic_tarihi",
                event.target.value
              )
            }
          />
        </Field>

        <Field label={tt.endDate}>
          <input
            type="date"
            value={
              form
                .is_bitis_tarihi
            }
            onChange={(event) =>
              update(
                "is_bitis_tarihi",
                event.target.value
              )
            }
          />
        </Field>
      </div>

      <div className="mia-toggle-grid">
        <Toggle
          label={
            tt.phoneContact
          }
          checked={
            form.telefonla_iletisim
          }
          onChange={(value) =>
            update(
              "telefonla_iletisim",
              value
            )
          }
        />

        <Toggle
          label={
            tt.whatsappContact
          }
          checked={
            form.whatsapp_iletisim
          }
          onChange={(value) =>
            update(
              "whatsapp_iletisim",
              value
            )
          }
        />

        <Toggle
          label={
            tt.inAppContact
          }
          checked={
            form
              .uygulama_ici_iletisim
          }
          onChange={(value) =>
            update(
              "uygulama_ici_iletisim",
              value
            )
          }
        />
      </div>

      <div className="mia-form-actions">
        <Button
          onClick={onSave}
          disabled={saving}
        >
          {saving
            ? tt.loading
            : tt.createJob}
        </Button>
      </div>
    </div>
  );
}

/* =========================================================
   TEKLİFLER
========================================================= */

function OffersView({
  tt,
  language,
  job,
  offers,
  onStatus,
  onComplete,
  saving,
}) {
  return (
    <div className="mia-form-stack">
      <Card className="mia-job-summary">
        <div>
          <Badge
            value={job.durum}
          >
            {statusLabel(
              job.durum,
              tt
            )}
          </Badge>

          <h3>{job.baslik}</h3>

          <p>{job.aciklama}</p>
        </div>

        <div className="mia-budget">
          <strong>
            {job.butce_max
              ? money(
                  job.butce_max,
                  job.para_birimi,
                  language
                )
              : "-"}
          </strong>

          <small>
            {job.teklif_sayisi ||
              0}{" "}
            {tt.offers}
          </small>
        </div>
      </Card>

      <div className="mia-offer-list">
        {offers.map(
          (offer) => (
            <Card
              className="mia-offer-card"
              key={offer.id}
            >
              <div className="mia-offer-head">
                <div className="mia-job-owner">
                  <Avatar
                    item={offer}
                    size="small"
                  />

                  <div>
                    <strong>
                      {offer.ad}{" "}
                      {
                        offer.soyad
                      }
                    </strong>

                    <small>
                      {offer.firma_adi ||
                        offer.meslek ||
                        "-"}
                    </small>
                  </div>
                </div>

                <Badge
                  value={
                    offer.durum
                  }
                >
                  {statusLabel(
                    offer.durum,
                    tt
                  )}
                </Badge>
              </div>

              <p>{offer.mesaj}</p>

              <div className="mia-info-grid">
                <Info
                  label={
                    tt.offerAmount
                  }
                  value={
                    offer.teklif_tutari
                      ? money(
                          offer.teklif_tutari,
                          offer.para_birimi,
                          language
                        )
                      : "-"
                  }
                />

                <Info
                  label={
                    tt.estimatedDays
                  }
                  value={
                    offer.tahmini_sure_gun ||
                    "-"
                  }
                />

                <Info
                  label={tt.phone}
                  value={
                    offer.telefon
                  }
                />

                <Info
                  label={tt.whatsapp}
                  value={
                    offer.whatsapp
                  }
                />
              </div>

              {[
                "beklemede",
                "inceleniyor",
              ].includes(
                offer.durum
              ) ? (
                <div className="mia-card-actions">
                  <Button
                    variant="soft"
                    disabled={saving}
                    onClick={() =>
                      onStatus(
                        offer,
                        "inceleniyor"
                      )
                    }
                  >
                    {tt.review}
                  </Button>

                  <Button
                    disabled={saving}
                    onClick={() =>
                      onStatus(
                        offer,
                        "kabul_edildi"
                      )
                    }
                  >
                    {tt.accept}
                  </Button>

                  <Button
                    variant="dangerSoft"
                    disabled={saving}
                    onClick={() =>
                      onStatus(
                        offer,
                        "reddedildi"
                      )
                    }
                  >
                    {tt.decline}
                  </Button>
                </div>
              ) : null}
            </Card>
          )
        )}

        {!offers.length ? (
          <EmptyState
            title={tt.noOffer}
          />
        ) : null}
      </div>

      {job.secilen_teklif_id &&
      job.durum !==
        "tamamlandi" ? (
        <div className="mia-form-actions">
          <Button
            onClick={() =>
              onComplete(job)
            }
            disabled={saving}
          >
            ✓ {tt.completeJob}
          </Button>
        </div>
      ) : null}
    </div>
  );
}

/* =========================================================
   KATALOG
========================================================= */

function CatalogView({
  tt,
  catalog,
  mainSectors,
  onAddSector,
  onAddService,
  onEditSector,
  onEditService,
  onDeactivate,
}) {
  return (
    <div className="mia-section-stack mia-animate-in">
      <div className="mia-section-title mia-section-title-actions">
        <div>
          <span>MASTER DATA</span>

          <h2>{tt.catalogs}</h2>

          <p>
            {tt.catalogInfo}
          </p>
        </div>

        <div className="mia-inline-actions">
          <Button
            variant="soft"
            onClick={onAddSector}
          >
            ＋ {tt.addSector}
          </Button>

          <Button
            onClick={onAddService}
          >
            ＋ {tt.addService}
          </Button>
        </div>
      </div>

      <div className="mia-catalog-layout">
        <Card>
          <div className="mia-card-head">
            <div>
              <span className="mia-card-kicker">
                SECTORS
              </span>

              <h2>
                {tt.mainSectors}
              </h2>
            </div>
          </div>

          <div className="mia-catalog-list">
            {mainSectors.map(
              (sector) => (
                <div
                  className="mia-catalog-item"
                  key={sector.id}
                >
                  <span
                    className="mia-catalog-icon"
                    style={{
                      background:
                        sector.color ||
                        "#0B4D8B",
                    }}
                  >
                    {sector.icon
                      ?.slice(0, 1)
                      ?.toUpperCase() ||
                      "S"}
                  </span>

                  <div className="mia-grow">
                    <strong>
                      {sector.name}
                    </strong>

                    <small>
                      {
                        catalog.sectors.filter(
                          (item) =>
                            Number(
                              item.parent_id
                            ) ===
                            Number(
                              sector.id
                            )
                        ).length
                      }{" "}
                      {tt.subSectors}
                    </small>
                  </div>

                  <button
                    onClick={() =>
                      onEditSector(
                        sector
                      )
                    }
                  >
                    ✎
                  </button>

                  <button
                    className="danger"
                    onClick={() =>
                      onDeactivate(
                        "sector",
                        sector
                      )
                    }
                  >
                    ×
                  </button>
                </div>
              )
            )}
          </div>
        </Card>

        <Card>
          <div className="mia-card-head">
            <div>
              <span className="mia-card-kicker">
                SUB SECTORS
              </span>

              <h2>
                {tt.subSectors}
              </h2>
            </div>
          </div>

          <div className="mia-catalog-list">
            {catalog.sectors
              .filter(
                (item) =>
                  item.parent_id
              )
              .map((sector) => (
                <div
                  className="mia-catalog-item"
                  key={sector.id}
                >
                  <span className="mia-catalog-icon">
                    S
                  </span>

                  <div className="mia-grow">
                    <strong>
                      {sector.name}
                    </strong>

                    <small>
                      {mainSectors.find(
                        (item) =>
                          Number(
                            item.id
                          ) ===
                          Number(
                            sector.parent_id
                          )
                      )?.name || "-"}
                    </small>
                  </div>

                  <button
                    onClick={() =>
                      onEditSector(
                        sector
                      )
                    }
                  >
                    ✎
                  </button>

                  <button
                    className="danger"
                    onClick={() =>
                      onDeactivate(
                        "sector",
                        sector
                      )
                    }
                  >
                    ×
                  </button>
                </div>
              ))}
          </div>
        </Card>

        <Card>
          <div className="mia-card-head">
            <div>
              <span className="mia-card-kicker">
                SERVICES
              </span>

              <h2>
                {tt.services}
              </h2>
            </div>
          </div>

          <div className="mia-catalog-list">
            {catalog.services.map(
              (service) => (
                <div
                  className="mia-catalog-item"
                  key={service.id}
                >
                  <span className="mia-catalog-icon mia-catalog-orange">
                    H
                  </span>

                  <div className="mia-grow">
                    <strong>
                      {service.name}
                    </strong>

                    <small>
                      {service.sector_name ||
                        catalog.sectors.find(
                          (item) =>
                            Number(
                              item.id
                            ) ===
                            Number(
                              service.sector_id
                            )
                        )?.name ||
                        "-"}
                    </small>
                  </div>

                  <button
                    onClick={() =>
                      onEditService(
                        service
                      )
                    }
                  >
                    ✎
                  </button>

                  <button
                    className="danger"
                    onClick={() =>
                      onDeactivate(
                        "service",
                        service
                      )
                    }
                  >
                    ×
                  </button>
                </div>
              )
            )}
          </div>
        </Card>
      </div>
    </div>
  );
}

function CatalogEditor({
  tt,
  type,
  form,
  setForm,
  mainSectors,
  sectors,
  onSave,
  saving,
}) {
  const update =
    (key, value) => {
      setForm(
        (current) => ({
          ...current,
          [key]: value,
        })
      );
    };

  return (
    <div className="mia-form-stack">
      <div className="mia-form-grid">
        {type === "sector" ? (
          <Field
            label={tt.parentSector}
          >
            <select
              value={
                form.ust_sektor_id ||
                ""
              }
              onChange={(event) =>
                update(
                  "ust_sektor_id",
                  event.target.value
                )
              }
            >
              <option value="">
                {tt.mainSectors}
              </option>

              {mainSectors.map(
                (sector) => (
                  <option
                    value={sector.id}
                    key={sector.id}
                  >
                    {sector.name}
                  </option>
                )
              )}
            </select>
          </Field>
        ) : (
          <Field
            label={tt.sector}
            required
          >
            <select
              value={
                form.sektor_id ||
                ""
              }
              onChange={(event) =>
                update(
                  "sektor_id",
                  event.target.value
                )
              }
            >
              <option value="">
                {tt.all}
              </option>

              {sectors.map(
                (sector) => (
                  <option
                    value={sector.id}
                    key={sector.id}
                  >
                    {sector.name}
                  </option>
                )
              )}
            </select>
          </Field>
        )}

        <Field
          label={
            type === "sector"
              ? tt.sectorNameTr
              : tt.serviceNameTr
          }
          required
        >
          <input
            value={
              form.ad_tr || ""
            }
            onChange={(event) =>
              update(
                "ad_tr",
                event.target.value
              )
            }
          />
        </Field>

        <Field
          label={
            type === "sector"
              ? tt.sectorNameEn
              : tt.serviceNameEn
          }
        >
          <input
            value={
              form.ad_en || ""
            }
            onChange={(event) =>
              update(
                "ad_en",
                event.target.value
              )
            }
          />
        </Field>

        <Field
          label={
            type === "sector"
              ? tt.sectorNameDe
              : tt.serviceNameDe
          }
        >
          <input
            value={
              form.ad_de || ""
            }
            onChange={(event) =>
              update(
                "ad_de",
                event.target.value
              )
            }
          />
        </Field>

        {type === "sector" ? (
          <>
            <Field label={tt.icon}>
              <input
                value={
                  form.ikon || ""
                }
                onChange={(event) =>
                  update(
                    "ikon",
                    event.target.value
                  )
                }
              />
            </Field>

            <Field label={tt.color}>
              <input
                type="color"
                value={
                  form.renk ||
                  "#0B4D8B"
                }
                onChange={(event) =>
                  update(
                    "renk",
                    event.target.value
                  )
                }
              />
            </Field>
          </>
        ) : null}

        <Field label={tt.order}>
          <input
            type="number"
            value={
              form.sira || 0
            }
            onChange={(event) =>
              update(
                "sira",
                Number(
                  event.target.value ||
                    0
                )
              )
            }
          />
        </Field>
      </div>

      <div className="mia-form-actions">
        <Button
          onClick={onSave}
          disabled={saving}
        >
          {saving
            ? tt.loading
            : tt.save}
        </Button>
      </div>
    </div>
  );
}

/* =========================================================
   AYARLAR
========================================================= */

function SettingsView({
  tt,
  form,
  setForm,
  onSave,
  saving,
}) {
  if (!form) {
    return (
      <EmptyState
        title={tt.noData}
      />
    );
  }

  const update =
    (key, value) => {
      setForm(
        (current) => ({
          ...current,
          [key]: value,
        })
      );
    };

  const toggles = [
    [
      "kurum_ici_aktif",
      tt.internalNetworkActive,
    ],

    [
      "kurumlar_arasi_aktif",
      tt.crossInstitutionActive,
    ],

    [
      "yonetici_onayi_zorunlu",
      tt.managerApprovalRequired,
    ],

    [
      "uye_otomatik_yayinlansin",
      tt.autoPublishMember,
    ],

    [
      "telefon_gosterilebilir",
      tt.phoneCanShow,
    ],

    [
      "whatsapp_gosterilebilir",
      tt.whatsappCanShow,
    ],

    [
      "email_gosterilebilir",
      tt.emailCanShow,
    ],

    [
      "is_talebi_aktif",
      tt.jobsActive,
    ],

    [
      "teklif_aktif",
      tt.offersActive,
    ],

    [
      "referans_aktif",
      tt.referencesActive,
    ],

    [
      "favoriler_aktif",
      tt.favoritesActive,
    ],

    [
      "profil_goruntulenme_sayisi_aktif",
      tt.viewsActive,
    ],

    [
      "yonetici_asistani_aktif",
      tt.assistantActive,
    ],
  ];

  return (
    <div className="mia-section-stack mia-animate-in">
      <div className="mia-section-title">
        <div>
          <span>
            PLATFORM CONTROL
          </span>

          <h2>
            {tt.settings}
          </h2>

          <p>
            {tt.settingsInfo}
          </p>
        </div>
      </div>

      <Card>
        <div className="mia-toggle-grid mia-toggle-grid-settings">
          {toggles.map(
            ([key, label]) => (
              <Toggle
                key={key}
                label={label}
                checked={form[key]}
                onChange={(value) =>
                  update(
                    key,
                    value
                  )
                }
              />
            )
          )}
        </div>

        <div className="mia-settings-footer">
          <Field
            label={
              tt.defaultVisibility
            }
          >
            <select
              value={
                form
                  .varsayilan_profil_gorunurlugu ||
                "kurum"
              }
              onChange={(event) =>
                update(
                  "varsayilan_profil_gorunurlugu",
                  event.target.value
                )
              }
            >
              <option value="gizli">
                {tt.hidden}
              </option>

              <option value="kurum">
                {tt.institutionOnly}
              </option>

              <option value="platform">
                {tt.wholePlatform}
              </option>
            </select>
          </Field>

          <Button
            onClick={onSave}
            disabled={saving}
          >
            {saving
              ? tt.loading
              : tt.save}
          </Button>
        </div>
      </Card>
    </div>
  );
}

/* =========================================================
   PROFİL FORMU
========================================================= */

function ProfileView({
  tt,
  form,
  setForm,
  cities,
  sectors,
  services,
  onSave,
  saving,
  isManager,
  onStatusAction,
}) {

  const update =
    (key, value) => {
      setForm(
        (current) => ({
          ...current,
          [key]: value,
        })
      );
    };

  const toggleArray =
    (key, id) => {
      setForm(
        (current) => {
          const list =
            new Set(
              current[key] || []
            );

          const numericId =
            Number(id);

          if (
            list.has(numericId)
          ) {
            list.delete(numericId);
          } else {
            list.add(numericId);
          }

          return {
            ...current,
            [key]: [...list],
          };
        }
      );
    };


  const approvalStatus =
    normalizeProfileStatus(
      form.onay_durumu
    );

  const membershipStatus =
    form.id
      ? (
          form.uyelik_durumu ||
          "aktif"
        )
      : "pasif";


  return (
    <div className="mia-section-stack mia-animate-in">


     <div className="mia-section-title mia-section-title-actions">
  <div>
    <span>
      {tt.businessIdentity}
    </span>

    <h2>
      {tt.myProfile}
    </h2>

    <p>
      {
        tt.profilePageDescription
      }
    </p>
  </div>

  <div className="mia-badge-row">
    <Badge
      value={
        approvalStatus
      }
    >
      {statusLabel(
        approvalStatus,
        tt
      )}
    </Badge>

    <Badge
      value={
        membershipStatus
      }
    >
      {statusLabel(
        membershipStatus,
        tt
      )}
    </Badge>
  </div>
</div>

<div className="mia-profile-purpose">
  <div className="mia-profile-purpose-icon">
    i
  </div>

  <div>
    <strong>
      {tt.optionalProfileTitle}
    </strong>

    <p>
      {tt.optionalProfileText}
    </p>
  </div>
</div>

{approvalStatus ===
"beklemede" &&
form.id ? (
  <div className="mia-alert mia-alert-warning">
    <b>i</b>

    <span>
      {tt.profileWaiting}
    </span>
  </div>
) : null}

{isManager && form.id ? (
  <Card className="mia-profile-manager-card">
    <div className="mia-network-control-head">
      <div>
        <strong>
          {tt.manageMember}
        </strong>

        <p>
          {tt.managerProfileControl}
        </p>
      </div>
    </div>

    <NetworkStatusActions
      tt={tt}
      profile={form}
      onAction={
        onStatusAction
      }
      saving={saving}
    />
  </Card>
) : null}

      <Card className="mia-profile-form-card">
        {/* 01 */}

        <div className="mia-form-section">
          <h3>
            01 · {tt.firstName} /{" "}
            {tt.company}
          </h3>

          <div className="mia-form-grid">
            <Field
              label={tt.firstName}
              required
            >
              <input
                value={form.ad}
                onChange={(event) =>
                  update(
                    "ad",
                    event.target
                      .value
                  )
                }
              />
            </Field>

            <Field
              label={tt.lastName}
              required
            >
              <input
                value={form.soyad}
                onChange={(event) =>
                  update(
                    "soyad",
                    event.target
                      .value
                  )
                }
              />
            </Field>

            <Field
              label={tt.memberCode}
            >
              <input
                value={
                  form.uye_kodu ||
                  ""
                }
                onChange={(event) =>
                  update(
                    "uye_kodu",
                    event.target
                      .value
                  )
                }
              />
            </Field>

            <Field
              label={
                tt.membershipNo
              }
            >
              <input
                value={
                  form
                    .dernek_uyelik_no ||
                  ""
                }
                onChange={(event) =>
                  update(
                    "dernek_uyelik_no",
                    event.target
                      .value
                  )
                }
              />
            </Field>

            <Field
              label={tt.birthDate}
            >
              <input
                type="date"
                value={
                  form.dogum_tarihi ||
                  ""
                }
                onChange={(event) =>
                  update(
                    "dogum_tarihi",
                    event.target
                      .value
                  )
                }
              />
            </Field>

            <Field
              label={tt.profession}
            >
              <input
                value={
                  form.meslek || ""
                }
                onChange={(event) =>
                  update(
                    "meslek",
                    event.target
                      .value
                  )
                }
              />
            </Field>

            <Field
              label={tt.titleField}
            >
              <input
                value={
                  form.unvan || ""
                }
                onChange={(event) =>
                  update(
                    "unvan",
                    event.target
                      .value
                  )
                }
              />
            </Field>

            <Field
              label={tt.company}
            >
              <input
                value={
                  form.firma_adi ||
                  ""
                }
                onChange={(event) =>
                  update(
                    "firma_adi",
                    event.target
                      .value
                  )
                }
              />
            </Field>

            <Field
              label={
                tt.companyTitle
              }
            >
              <input
                value={
                  form.firma_unvani ||
                  ""
                }
                onChange={(event) =>
                  update(
                    "firma_unvani",
                    event.target
                      .value
                  )
                }
              />
            </Field>
          </div>
        </div>

        {/* 02 */}

        <div className="mia-form-section">
          <h3>
            02 · {tt.phone} /{" "}
            {tt.address}
          </h3>

          <div className="mia-form-grid">
            <Field label={tt.phone}>
              <input
                value={
                  form.telefon || ""
                }
                onChange={(event) =>
                  update(
                    "telefon",
                    event.target
                      .value
                  )
                }
              />
            </Field>

            <Field
              label={tt.whatsapp}
            >
              <input
                value={
                  form.whatsapp ||
                  ""
                }
                onChange={(event) =>
                  update(
                    "whatsapp",
                    event.target
                      .value
                  )
                }
              />
            </Field>

            <Field label={tt.email}>
              <input
                type="email"
                value={
                  form.email || ""
                }
                onChange={(event) =>
                  update(
                    "email",
                    event.target
                      .value
                  )
                }
              />
            </Field>

            <Field
              label={
                tt.companyPhone
              }
            >
              <input
                value={
                  form
                    .firma_telefonu ||
                  ""
                }
                onChange={(event) =>
                  update(
                    "firma_telefonu",
                    event.target
                      .value
                  )
                }
              />
            </Field>

            <Field
              label={
                tt.companyEmail
              }
            >
              <input
                type="email"
                value={
                  form.firma_email ||
                  ""
                }
                onChange={(event) =>
                  update(
                    "firma_email",
                    event.target
                      .value
                  )
                }
              />
            </Field>

            <Field label={tt.city}>
              <select
                value={
                  form.il_id || ""
                }
                onChange={(event) =>
                  update(
                    "il_id",
                    event.target
                      .value
                  )
                }
              >
                <option value="">
                  {tt.all}
                </option>

                {cities.map(
                  (city) => (
                    <option
                      key={city.id}
                      value={city.id}
                    >
                      {city.name}
                    </option>
                  )
                )}
              </select>
            </Field>

            <Field
              label={tt.freeCity}
            >
              <input
                value={
                  form
                    .il_adi_serbest ||
                  ""
                }
                onChange={(event) =>
                  update(
                    "il_adi_serbest",
                    event.target
                      .value
                  )
                }
              />
            </Field>

            <Field
              label={
                tt.freeDistrict
              }
            >
              <input
                value={
                  form
                    .ilce_adi_serbest ||
                  ""
                }
                onChange={(event) =>
                  update(
                    "ilce_adi_serbest",
                    event.target
                      .value
                  )
                }
              />
            </Field>

            <Field
              label={tt.address}
              className="mia-span-2"
            >
              <textarea
                rows="3"
                value={
                  form.firma_adresi ||
                  ""
                }
                onChange={(event) =>
                  update(
                    "firma_adresi",
                    event.target
                      .value
                  )
                }
              />
            </Field>
          </div>
        </div>

        {/* 03 */}

        <div className="mia-form-section">
          <h3>
            03 · {tt.about}
          </h3>

          <div className="mia-form-grid">
            <Field
              label={tt.about}
              className="mia-span-2"
            >
              <textarea
                rows="5"
                value={
                  form.hakkinda || ""
                }
                onChange={(event) =>
                  update(
                    "hakkinda",
                    event.target
                      .value
                  )
                }
              />
            </Field>

            <Field
              label={tt.products}
              className="mia-span-2"
            >
              <textarea
                rows="4"
                value={
                  form
                    .sundugu_urunler ||
                  ""
                }
                onChange={(event) =>
                  update(
                    "sundugu_urunler",
                    event.target
                      .value
                  )
                }
              />
            </Field>

            <Field
              label={tt.needs}
            >
              <textarea
                rows="4"
                value={
                  form
                    .aradigi_hizmetler ||
                  ""
                }
                onChange={(event) =>
                  update(
                    "aradigi_hizmetler",
                    event.target
                      .value
                  )
                }
              />
            </Field>

            <Field
              label={
                tt.partnership
              }
            >
              <textarea
                rows="4"
                value={
                  form
                    .is_ortakligi_aciklama ||
                  ""
                }
                onChange={(event) =>
                  update(
                    "is_ortakligi_aciklama",
                    event.target
                      .value
                  )
                }
              />
            </Field>

            <Field
              label={tt.serviceArea}
            >
              <textarea
                rows="3"
                value={
                  form
                    .hizmet_bolgesi_aciklama ||
                  ""
                }
                onChange={(event) =>
                  update(
                    "hizmet_bolgesi_aciklama",
                    event.target
                      .value
                  )
                }
              />
            </Field>

            <Field
              label={tt.keywords}
            >
              <textarea
                rows="3"
                value={
                  form
                    .anahtar_kelimeler ||
                  ""
                }
                onChange={(event) =>
                  update(
                    "anahtar_kelimeler",
                    event.target
                      .value
                  )
                }
              />
            </Field>
          </div>
        </div>

        {/* 04 */}

        <div className="mia-form-section">
          <h3>
            04 ·{" "}
            {tt.selectedSectors}
          </h3>

          <div className="mia-select-chips">
            {sectors.map(
              (sector) => (
                <button
                  type="button"
                  key={sector.id}
                  className={
                    (
                      form.sektor_ids ||
                      []
                    ).includes(
                      Number(
                        sector.id
                      )
                    )
                      ? "active"
                      : ""
                  }
                  onClick={() =>
                    toggleArray(
                      "sektor_ids",
                      sector.id
                    )
                  }
                >
                  {sector.name}
                </button>
              )
            )}
          </div>

          <h3 className="mia-subtitle">
            {
              tt.selectedServices
            }
          </h3>

          <div className="mia-select-chips">
            {services.map(
              (service) => (
                <button
                  type="button"
                  key={service.id}
                  className={
                    (
                      form.hizmet_ids ||
                      []
                    ).includes(
                      Number(
                        service.id
                      )
                    )
                      ? "active"
                      : ""
                  }
                  onClick={() =>
                    toggleArray(
                      "hizmet_ids",
                      service.id
                    )
                  }
                >
                  {service.name}
                </button>
              )
            )}
          </div>
        </div>

        {/* 05 */}

        <div className="mia-form-section">
          <h3>05 · Media</h3>

          <div className="mia-form-grid">
            <Field
              label={tt.profilePhoto}
            >
              <input
                value={
                  form
                    .profil_fotografi ||
                  ""
                }
                onChange={(event) =>
                  update(
                    "profil_fotografi",
                    event.target
                      .value
                  )
                }
              />
            </Field>

            <Field
              label={tt.coverPhoto}
            >
              <input
                value={
                  form
                    .kapak_fotografi ||
                  ""
                }
                onChange={(event) =>
                  update(
                    "kapak_fotografi",
                    event.target
                      .value
                  )
                }
              />
            </Field>

            <Field
              label={tt.companyLogo}
            >
              <input
                value={
                  form.firma_logosu ||
                  ""
                }
                onChange={(event) =>
                  update(
                    "firma_logosu",
                    event.target
                      .value
                  )
                }
              />
            </Field>

            <Field
              label={tt.website}
            >
              <input
                value={
                  form.web_sitesi ||
                  ""
                }
                onChange={(event) =>
                  update(
                    "web_sitesi",
                    event.target
                      .value
                  )
                }
              />
            </Field>

            <Field
              label={tt.instagram}
            >
              <input
                value={
                  form.instagram ||
                  ""
                }
                onChange={(event) =>
                  update(
                    "instagram",
                    event.target
                      .value
                  )
                }
              />
            </Field>

            <Field
              label={tt.facebook}
            >
              <input
                value={
                  form.facebook ||
                  ""
                }
                onChange={(event) =>
                  update(
                    "facebook",
                    event.target
                      .value
                  )
                }
              />
            </Field>

            <Field
              label={tt.linkedin}
            >
              <input
                value={
                  form.linkedin ||
                  ""
                }
                onChange={(event) =>
                  update(
                    "linkedin",
                    event.target
                      .value
                  )
                }
              />
            </Field>

            <Field
              label={tt.youtube}
            >
              <input
                value={
                  form.youtube || ""
                }
                onChange={(event) =>
                  update(
                    "youtube",
                    event.target
                      .value
                  )
                }
              />
            </Field>
          </div>
        </div>

        {/* GÖRÜNÜRLÜK */}

        <div className="mia-toggle-grid">
          <Toggle
            label={tt.nationwide}
            checked={
              form.turkiye_geneli
            }
            onChange={(value) =>
              update(
                "turkiye_geneli",
                value
              )
            }
          />

          <Toggle
            label={
              tt.profileVisible
            }
            checked={
              form.profil_gorunur
            }
            onChange={(value) =>
              update(
                "profil_gorunur",
                value
              )
            }
          />

          <Toggle
            label={
              tt.platformVisible
            }
            checked={
              form
                .platformda_gorunur
            }
            onChange={(value) =>
              update(
                "platformda_gorunur",
                value
              )
            }
          />

          <Toggle
            label={
              tt.phoneVisible
            }
            checked={
              form.telefon_gorunur
            }
            onChange={(value) =>
              update(
                "telefon_gorunur",
                value
              )
            }
          />

          <Toggle
            label={
              tt.whatsappVisible
            }
            checked={
              form.whatsapp_gorunur
            }
            onChange={(value) =>
              update(
                "whatsapp_gorunur",
                value
              )
            }
          />

          <Toggle
            label={
              tt.emailVisible
            }
            checked={
              form.email_gorunur
            }
            onChange={(value) =>
              update(
                "email_gorunur",
                value
              )
            }
          />

          <Toggle
            label={
              tt.addressVisible
            }
            checked={
              form.adres_gorunur
            }
            onChange={(value) =>
              update(
                "adres_gorunur",
                value
              )
            }
          />
        </div>

        <div className="mia-form-actions">
          <Button
            onClick={onSave}
            disabled={saving}
          >
            {saving
              ? tt.loading
              : tt.save}
          </Button>
        </div>
      </Card>
    </div>
  );
}

/* =========================================================
   CSS
========================================================= */

const CSS = `
  :root {
    --mia-blue: #0B4D8B;
    --mia-blue-2: #1176c9;
    --mia-orange: #F58220;
    --mia-ink: #10233f;
    --mia-muted: #64748b;
    --mia-line: #dbe5f0;
    --mia-bg: #f4f7fb;
    --mia-green: #16a34a;
    --mia-red: #dc2626;
    --mia-purple: #7c3aed;
    --mia-cyan: #0891b2;
  }

  .mia-page,
  .mia-page * {
    box-sizing: border-box;
  }

  .mia-page {
    width: 100%;
    max-width: 100%;
    min-height: 100vh;
    padding: 18px;
    overflow-x: hidden;

    color: var(--mia-ink);

    background:
      linear-gradient(
        180deg,
        #f8fafc 0%,
        #f2f6fb 45%,
        #eef3f9 100%
      );

    font-family:
      Inter,
      ui-sans-serif,
      system-ui,
      -apple-system,
      BlinkMacSystemFont,
      "Segoe UI",
      sans-serif;
  }

  .mia-page button,
  .mia-page input,
  .mia-page select,
  .mia-page textarea {
    font: inherit;
  }

  .mia-content {
    width: 100%;
    max-width: 1500px;

    margin: 0 auto;
    padding: 22px 0 70px;
  }

  /* ================= HEADER ================= */

  .mia-hero {
    width: 100%;
    max-width: 1500px;
    min-height: 190px;

    margin: 0 auto;
    padding: 30px;

    display: flex;
    align-items: center;
    justify-content: space-between;

    gap: 26px;

    color: #ffffff;

    border-radius: 28px;

    background:
      linear-gradient(
        125deg,
        #073866 0%,
        #0B4D8B 48%,
        #1176c9 100%
      );

    box-shadow:
      0 24px 65px
      rgba(11, 77, 139, 0.24);

    position: relative;
    overflow: hidden;
  }

  .mia-hero-main {
    min-width: 0;

    display: flex;
    align-items: center;

    gap: 20px;

    position: relative;
    z-index: 2;
  }

  .mia-brand-mark {
    width: 76px;
    height: 76px;

    flex: 0 0 76px;

    display: grid;
    place-items: center;

    border-radius: 24px;

    background:
      linear-gradient(
        145deg,
        #ffffff,
        #d9ebfb
      );

    box-shadow:
      0 12px 28px
      rgba(0, 0, 0, 0.22);

    transform: rotate(-5deg);
  }

  .mia-brand-mark span {
    color: var(--mia-blue);

    font-size: 38px;
    font-weight: 1000;
  }

  .mia-eyebrow {
    margin-bottom: 8px;

    color: #c7e6ff;

    font-size: 12px;
    font-weight: 900;

    letter-spacing: 0.16em;
  }

  .mia-hero h1 {
    margin: 0;

    font-size:
      clamp(
        28px,
        4vw,
        48px
      );

    font-weight: 1000;
    line-height: 1.05;
    letter-spacing: -0.045em;
  }

  .mia-hero p {
    max-width: 760px;

    margin: 12px 0 0;

    color: #dceeff;

    font-size: 15px;
    line-height: 1.65;
  }

  .mia-hero-actions {
    display: flex;
    flex-direction: column;
    align-items: flex-end;

    gap: 12px;

    position: relative;
    z-index: 2;
  }

  .mia-lang-switch {
    padding: 4px;

    display: flex;

    border:
      1px solid
      rgba(255, 255, 255, 0.2);

    border-radius: 999px;

    background:
      rgba(255, 255, 255, 0.12);

    backdrop-filter:
      blur(12px);
  }

  .mia-lang-switch button {
    padding: 8px 12px;

    border: 0;
    border-radius: 999px;

    background: transparent;
    color: #d9edff;

    font-weight: 900;

    cursor: pointer;
  }

  .mia-lang-switch button.active {
    background: #ffffff;
    color: var(--mia-blue);

    box-shadow:
      0 6px 18px
      rgba(0, 0, 0, 0.14);
  }

  .mia-hero-orb {
    position: absolute;

    border-radius: 999px;

    pointer-events: none;
  }

  .mia-hero-orb-one {
    width: 260px;
    height: 260px;

    right: -55px;
    top: -105px;

    background:
      rgba(245, 130, 32, 0.22);
  }

  .mia-hero-orb-two {
    width: 180px;
    height: 180px;

    left: 40%;
    bottom: -125px;

    background:
      rgba(255, 255, 255, 0.08);
  }

  /* ================= TAB ================= */

  .mia-tabs {
    width: 100%;
    max-width: 1500px;

    margin: -23px auto 0;
    padding: 7px;

    display: flex;
    gap: 6px;

    overflow-x: auto;

    border:
      1px solid
      rgba(219, 229, 240, 0.9);

    border-radius: 20px;

    background:
      rgba(255, 255, 255, 0.94);

    box-shadow:
      0 16px 38px
      rgba(15, 35, 63, 0.11);

    position: relative;
    z-index: 5;

    scrollbar-width: none;
  }

  .mia-tabs::-webkit-scrollbar {
    display: none;
  }

  .mia-tabs button {
    padding: 12px 16px;

    display: flex;
    align-items: center;
    justify-content: center;

    gap: 8px;

    border: 0;
    border-radius: 14px;

    background: transparent;
    color: #52657c;

    font-weight: 900;

    cursor: pointer;
    white-space: nowrap;

    transition:
      transform 0.2s ease,
      background 0.2s ease,
      color 0.2s ease;
  }

  .mia-tabs button:hover {
    background: #eef5fb;
    color: var(--mia-blue);

    transform:
      translateY(-1px);
  }

  .mia-tabs button.active {
    color: #ffffff;

    background:
      linear-gradient(
        135deg,
        var(--mia-blue),
        var(--mia-blue-2)
      );

    box-shadow:
      0 9px 22px
      rgba(11, 77, 139, 0.24);
  }

  /* ================= BUTTON ================= */

  .mia-icon {
    display: inline-grid;
    place-items: center;

    font-weight: 1000;
    line-height: 1;
  }

  .mia-btn {
    padding: 11px 16px;

    display: inline-flex;
    align-items: center;
    justify-content: center;

    gap: 8px;

    border: 0;
    border-radius: 13px;

    color: #ffffff;

    background:
      linear-gradient(
        135deg,
        var(--mia-blue),
        var(--mia-blue-2)
      );

    box-shadow:
      0 9px 20px
      rgba(11, 77, 139, 0.18);

    font-weight: 900;

    cursor: pointer;

    transition:
      transform 0.18s ease,
      box-shadow 0.18s ease,
      opacity 0.18s ease;
  }

  .mia-btn:hover:not(:disabled) {
    transform:
      translateY(-2px);

    box-shadow:
      0 13px 25px
      rgba(11, 77, 139, 0.24);
  }

  .mia-btn:disabled {
    opacity: 0.55;
    cursor: not-allowed;
  }

  .mia-btn-soft {
    color: var(--mia-blue);

    border:
      1px solid #cfe2f3;

    background: #eaf3fb;

    box-shadow: none;
  }

  .mia-btn-dangerSoft {
    color: var(--mia-red);

    border:
      1px solid #fecaca;

    background: #fff0f0;

    box-shadow: none;
  }

  .mia-btn-glass {
    border:
      1px solid
      rgba(255, 255, 255, 0.24);

    background:
      rgba(255, 255, 255, 0.13);

    box-shadow: none;

    backdrop-filter:
      blur(10px);
  }

  .mia-btn-small {
    padding: 8px 11px;

    border-radius: 10px;

    font-size: 13px;
  }

  .mia-full {
    width: 100%;
  }

  /* ================= KART ================= */

  .mia-section-stack {
    display: flex;
    flex-direction: column;

    gap: 18px;
  }

  .mia-card {
    min-width: 0;

    padding: 20px;

    border:
      1px solid
      var(--mia-line);

    border-radius: 22px;

    background: #ffffff;

    box-shadow:
      0 12px 34px
      rgba(15, 35, 63, 0.065);

    position: relative;
    overflow: hidden;
  }

  .mia-card::before {
    content: "";

    height: 4px;

    position: absolute;
    left: 0;
    right: 0;
    top: 0;

    background:
      linear-gradient(
        90deg,
        var(--mia-blue),
        var(--mia-orange)
      );

    opacity: 0.85;
  }

  .mia-card-head {
    margin-bottom: 18px;

    display: flex;
    align-items: flex-start;
    justify-content: space-between;

    gap: 14px;
  }

  .mia-card-head h2,
  .mia-section-title h2 {
    margin: 3px 0 0;

    font-size: 23px;

    letter-spacing: -0.025em;
  }

  .mia-card-kicker,
  .mia-section-title > div > span {
    color: var(--mia-orange);

    font-size: 10px;
    font-weight: 1000;

    letter-spacing: 0.15em;
  }

  .mia-section-title {
    display: flex;
    align-items: center;
    justify-content: space-between;

    gap: 15px;
  }

  .mia-section-title p {
    margin: 6px 0 0;

    color: var(--mia-muted);
  }

  .mia-section-title-actions {
    align-items: flex-end;
  }

  .mia-inline-actions,
  .mia-card-actions,
  .mia-form-actions,
  .mia-filter-actions {
    display: flex;
    align-items: center;

    gap: 10px;

    flex-wrap: wrap;
  }

.mia-form-actions {
  justify-content: flex-end;

  padding-top: 8px;
}

/* ================= İŞ PROFİLİ YÖNETİMİ ================= */

.mia-profile-purpose {
  padding: 17px 18px;

  display: flex;
  align-items: flex-start;

  gap: 14px;

  border: 1px solid #bfdbfe;
  border-radius: 18px;

  background:
    linear-gradient(
      135deg,
      #eff6ff,
      #fff7ed
    );

  box-shadow:
    0 10px 28px
    rgba(15, 35, 63, 0.05);
}

.mia-profile-purpose-icon {
  width: 38px;
  height: 38px;

  flex: 0 0 38px;

  display: grid;
  place-items: center;

  border-radius: 12px;

  color: #ffffff;
  background:
    linear-gradient(
      135deg,
      var(--mia-blue),
      var(--mia-orange)
    );

  font-size: 18px;
  font-weight: 1000;
}

.mia-profile-purpose strong {
  display: block;

  margin-bottom: 5px;

  color: var(--mia-blue);

  font-size: 15px;
  font-weight: 1000;
}

.mia-profile-purpose p {
  margin: 0;

  color: var(--mia-muted);

  font-size: 14px;
  line-height: 1.65;
}

.mia-profile-manager-card {
  display: flex;
  align-items: center;
  justify-content: space-between;

  gap: 18px;
}

.mia-network-control-head {
  min-width: 220px;
}

.mia-network-control-head strong {
  display: block;

  color: var(--mia-ink);

  font-size: 16px;
  font-weight: 1000;
}

.mia-network-control-head p {
  max-width: 520px;

  margin: 5px 0 0;

  color: var(--mia-muted);

  font-size: 13px;
  line-height: 1.55;
}

.mia-network-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;

  gap: 9px;

  flex-wrap: wrap;
}

.mia-control-panel
.mia-network-actions {
  margin-bottom: 18px;

  justify-content: stretch;
}

.mia-control-panel
.mia-network-actions
.mia-btn {
  flex:
    1 1
    calc(50% - 8px);

  justify-content: center;
}

@media (
  max-width: 760px
) {
  .mia-profile-manager-card {
    align-items: stretch;
    flex-direction: column;
  }

  .mia-network-actions {
    width: 100%;
    justify-content: stretch;
  }

  .mia-network-actions
  .mia-btn {
    flex: 1 1 100%;
    justify-content: center;
  }

  .mia-profile-purpose {
    padding: 15px;
  }
}

  /* ================= İSTATİSTİK ================= */

  .mia-stats-grid {
    display: grid;

    grid-template-columns:
      repeat(
        4,
        minmax(0, 1fr)
      );

    gap: 14px;
  }

  .mia-stat {
    min-height: 122px;

    display: flex;
    align-items: center;

    gap: 15px;
  }

  .mia-stat::after {
    content: "";

    width: 115px;
    height: 115px;

    position: absolute;
    right: -42px;
    bottom: -55px;

    border-radius: 999px;

    background: currentColor;

    opacity: 0.055;
  }

  .mia-stat-icon {
    width: 48px;
    height: 48px;

    display: grid;
    place-items: center;

    border-radius: 15px;

    color: var(--mia-blue);
    background: #e9f3fb;

    font-size: 22px;
    font-weight: 1000;
  }

  .mia-stat > div:last-child {
    display: flex;
    flex-direction: column;

    gap: 4px;
  }

  .mia-stat span {
    color: var(--mia-muted);

    font-size: 12px;
    font-weight: 850;
  }

  .mia-stat strong {
    font-size: 28px;
    font-weight: 1000;
    line-height: 1;
  }

  .mia-stat small {
    color: var(--mia-muted);
  }

  .mia-stat-green .mia-stat-icon {
    color: var(--mia-green);
    background: #eafaf0;
  }

  .mia-stat-orange .mia-stat-icon {
    color: var(--mia-orange);
    background: #fff3e7;
  }

  .mia-stat-purple .mia-stat-icon {
    color: var(--mia-purple);
    background: #f2ecff;
  }

  .mia-stat-cyan .mia-stat-icon {
    color: var(--mia-cyan);
    background: #e8f8fb;
  }

  /* ================= GRID ================= */

  .mia-two-column {
    display: grid;

    grid-template-columns:
      1.2fr 0.8fr;

    gap: 18px;
  }

  .mia-three-column {
    display: grid;

    grid-template-columns:
      repeat(
        3,
        minmax(0, 1fr)
      );

    gap: 18px;
  }

  /* ================= ASİSTAN ================= */

  .mia-live-dot {
    display: flex;
    align-items: center;

    gap: 6px;

    color: var(--mia-green);

    font-size: 10px;
    font-weight: 1000;
  }

  .mia-live-dot i {
    width: 8px;
    height: 8px;

    border-radius: 50%;

    background: var(--mia-green);

    box-shadow:
      0 0 0 5px
      rgba(22, 163, 74, 0.12);

    animation:
      miaPulse 1.8s infinite;
  }

  .mia-assistant-list,
  .mia-compact-list,
  .mia-catalog-list,
  .mia-offer-list,
  .mia-review-list {
    display: flex;
    flex-direction: column;

    gap: 10px;
  }

  .mia-assistant-item {
    padding: 14px;

    display: flex;

    gap: 12px;

    border:
      1px solid
      var(--mia-line);

    border-radius: 16px;

    background: #f8fbfe;
  }

  .mia-assistant-item > span {
    width: 34px;
    height: 34px;

    flex: 0 0 34px;

    display: grid;
    place-items: center;

    border-radius: 11px;

    color: var(--mia-blue);
    background: #e8f2fb;

    font-weight: 1000;
  }

  .mia-assistant-item strong {
    display: block;

    font-size: 14px;
  }

  .mia-assistant-item p {
    margin: 4px 0 0;

    color: var(--mia-muted);

    font-size: 13px;
    line-height: 1.45;
  }

  .mia-assistant-warning > span {
    color: var(--mia-orange);
    background: #fff3e5;
  }

  .mia-assistant-birthday > span {
    color: var(--mia-purple);
    background: #f2eaff;
  }

  /* ================= KISA LİSTE ================= */

  .mia-compact-item {
    padding: 10px;

    display: flex;
    align-items: center;

    gap: 10px;

    border:
      1px solid #edf1f6;

    border-radius: 14px;

    background:
      linear-gradient(
        180deg,
        #ffffff,
        #fbfdff
      );
  }

  .mia-rank {
    color: var(--mia-muted);

    font-size: 11px;
    font-weight: 1000;
  }

  .mia-grow {
    min-width: 0;
    flex: 1;
  }

  .mia-compact-item strong,
  .mia-job-owner strong {
    display: block;

    overflow: hidden;

    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .mia-compact-item small,
  .mia-job-owner small {
    display: block;

    margin-top: 2px;

    color: var(--mia-muted);
  }

  .mia-score {
    text-align: right;
  }

  .mia-score b {
    display: block;

    color: var(--mia-orange);
  }

  .mia-score small {
    font-size: 9px;
  }

  .mia-date-box {
    width: 44px;
    height: 48px;

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    border-radius: 12px;

    color: var(--mia-blue);
    background: #edf5fc;
  }

  .mia-date-box b {
    font-size: 17px;
  }

  .mia-date-box span {
    font-size: 9px;
    font-weight: 900;

    text-transform: uppercase;
  }

  /* ================= GRAFİK ================= */

  .mia-bars {
    display: flex;
    flex-direction: column;

    gap: 13px;
  }

  .mia-bar-row > div {
    display: flex;
    justify-content: space-between;

    gap: 12px;

    font-size: 12px;
    font-weight: 850;
  }

  .mia-bar-row i {
    height: 7px;

    display: block;

    margin-top: 6px;

    border-radius: 999px;

    background: #edf2f7;

    overflow: hidden;
  }

  .mia-bar-row em {
    height: 100%;

    display: block;

    border-radius: 999px;

    background:
      linear-gradient(
        90deg,
        var(--mia-blue),
        var(--mia-orange)
      );

    animation:
      miaGrow 0.5s ease;
  }

  /* ================= FORM ================= */

  .mia-filter-card {
    padding: 16px;
  }

  .mia-filter-grid {
    display: grid;

    grid-template-columns:
      2fr
      repeat(
        4,
        minmax(130px, 1fr)
      )
      auto;

    align-items: end;

    gap: 12px;
  }

  .mia-filter-grid-network {
    grid-template-columns:
      2fr
      repeat(
        3,
        minmax(150px, 1fr)
      );
  }

  .mia-field {
    min-width: 0;

    display: flex;
    flex-direction: column;

    gap: 7px;
  }

  .mia-label {
    color: #506176;

    font-size: 11px;
    font-weight: 900;

    letter-spacing: 0.045em;
    text-transform: uppercase;
  }

  .mia-label b {
    color: var(--mia-orange);
  }

  .mia-field input,
  .mia-field select,
  .mia-field textarea {
    width: 100%;
    max-width: 100%;
    min-height: 43px;

    padding: 11px 12px;

    border:
      1px solid #d5e0eb;

    border-radius: 12px;

    outline: none;

    color: var(--mia-ink);
    background: #fbfdff;

    transition:
      border-color 0.18s ease,
      box-shadow 0.18s ease,
      background 0.18s ease;
  }

  .mia-field textarea {
    resize: vertical;

    line-height: 1.55;
  }

  .mia-field input:focus,
  .mia-field select:focus,
  .mia-field textarea:focus {
    border-color:
      var(--mia-blue);

    background: #ffffff;

    box-shadow:
      0 0 0 4px
      rgba(11, 77, 139, 0.1);
  }

  .mia-field small {
    color: var(--mia-muted);
  }

  /* ================= ÜYE KARTI ================= */

  .mia-member-grid {
    display: grid;

    grid-template-columns:
      repeat(
        3,
        minmax(0, 1fr)
      );

    gap: 18px;
  }

  .mia-member-card {
    padding: 0;
  }

  .mia-member-card::before {
    display: none;
  }

  .mia-member-cover {
    height: 82px;

    position: relative;

    background:
      linear-gradient(
        125deg,
        var(--mia-blue),
        var(--mia-blue-2)
      );

    overflow: hidden;
  }

  .mia-member-cover span {
    width: 145px;
    height: 145px;

    position: absolute;
    right: -38px;
    top: -70px;

    border-radius: 50%;

    background:
      rgba(245, 130, 32, 0.28);
  }

  .mia-member-flags {
    position: absolute;
    right: 10px;
    top: 10px;

    display: flex;
    justify-content: flex-end;

    gap: 6px;

    flex-wrap: wrap;
  }

  .mia-member-body {
    padding:
      0 18px 18px;

    position: relative;
  }

  .mia-member-body >
  .mia-avatar {
    margin-top: -34px;

    border:
      4px solid #ffffff;

    box-shadow:
      0 8px 22px
      rgba(15, 35, 63, 0.15);
  }

  .mia-member-heading {
    padding-top: 8px;
  }

  .mia-member-heading h3,
  .mia-network-card h3 {
    margin: 0;

    font-size: 19px;

    letter-spacing: -0.02em;
  }

  .mia-member-heading p,
  .mia-company-line {
    margin: 4px 0;

    color: var(--mia-muted);
  }

  /* ================= BADGE ================= */

  .mia-badge-row {
    margin-top: 9px;

    display: flex;

    gap: 6px;

    flex-wrap: wrap;
  }

  .mia-badge {
    padding: 5px 8px;

    display: inline-flex;
    align-items: center;

    border:
      1px solid transparent;

    border-radius: 999px;

    font-size: 10px;
    font-weight: 1000;
  }

  .mia-badge-success {
    color: #147a38;

    border-color: #ccefd8;
    background: #eaf9ef;
  }

  .mia-badge-warning {
    color: #a95407;

    border-color: #ffddb2;
    background: #fff4e6;
  }

  .mia-badge-danger {
    color: #b91c1c;

    border-color: #fecaca;
    background: #fff0f0;
  }

  .mia-badge-neutral {
    color: #526174;

    border-color: #dce3ea;
    background: #eef2f6;
  }

  .mia-badge-info {
    color: var(--mia-blue);

    border-color: #cee2f3;
    background: #eaf4fb;
  }

  /* ================= PROGRESS ================= */

  .mia-progress {
    margin: 15px 0;
  }

  .mia-progress > div {
    display: flex;
    justify-content: space-between;

    color: var(--mia-muted);

    font-size: 11px;
    font-weight: 900;
  }

  .mia-progress i {
    height: 7px;

    display: block;

    margin-top: 6px;

    border-radius: 999px;

    background: #edf1f5;

    overflow: hidden;
  }

  .mia-progress em {
    height: 100%;

    display: block;

    border-radius: 999px;

    background:
      linear-gradient(
        90deg,
        var(--mia-blue),
        var(--mia-orange)
      );
  }

  .mia-member-meta {
    margin: 12px 0;

    display: flex;
    flex-direction: column;

    gap: 7px;

    color: #56687d;

    font-size: 12px;
  }

  .mia-member-meta span {
    overflow: hidden;

    white-space: nowrap;
    text-overflow: ellipsis;
  }

  /* ================= CHIP ================= */

  .mia-chip-list,
  .mia-select-chips {
    margin: 12px 0;

    display: flex;

    gap: 7px;

    flex-wrap: wrap;
  }

  .mia-chip-list span,
  .mia-select-chips button {
    padding: 6px 9px;

    border:
      1px solid #d8e4ef;

    border-radius: 999px;

    color: #3d5871;
    background: #f5f9fc;

    font-size: 10px;
    font-weight: 850;
  }

  .mia-select-chips button {
    cursor: pointer;
  }

  .mia-select-chips button.active {
    color: #ffffff;

    border-color:
      var(--mia-blue);

    background:
      var(--mia-blue);

    box-shadow:
      0 5px 12px
      rgba(11, 77, 139, 0.18);
  }

  /* ================= AVATAR ================= */

  .mia-avatar {
    display: grid;
    place-items: center;

    flex: 0 0 auto;

    border-radius: 50%;

    object-fit: cover;

    background: #eef4fa;
  }

  .mia-avatar-small {
    width: 38px;
    height: 38px;

    font-size: 12px;
  }

  .mia-avatar-normal {
    width: 48px;
    height: 48px;
  }

  .mia-avatar-large {
    width: 72px;
    height: 72px;

    font-size: 22px;
  }

  .mia-avatar-xlarge {
    width: 96px;
    height: 96px;

    font-size: 30px;
  }

  .mia-avatar-fallback {
    color: var(--mia-blue);

    border:
      1px solid #cfe0ef;

    background:
      linear-gradient(
        135deg,
        #dceefe,
        #fff1e2
      );

    font-weight: 1000;
  }

  /* ================= NETWORK ================= */

  .mia-network-grid {
    display: grid;

    grid-template-columns:
      repeat(
        4,
        minmax(0, 1fr)
      );

    gap: 16px;
  }

  .mia-network-card {
    padding: 20px;

    text-align: center;
  }

  .mia-network-top {
    margin-bottom: 10px;

    display: flex;
    align-items: flex-start;
    justify-content: center;

    position: relative;
  }

  .mia-heart {
    width: 36px;
    height: 36px;

    position: absolute;
    right: 0;
    top: 0;

    border:
      1px solid #e2e8f0;

    border-radius: 12px;

    color: #94a3b8;
    background: #ffffff;

    font-size: 18px;

    cursor: pointer;
  }

  .mia-heart.active {
    color: #e11d48;

    border-color: #fecdd3;
    background: #fff0f0;
  }

  .mia-rating {
    margin: 11px 0;

    display: flex;
    align-items: center;
    justify-content: center;

    gap: 8px;
  }

  .mia-rating span {
    color: var(--mia-orange);

    font-weight: 1000;
  }

  .mia-rating small {
    color: var(--mia-muted);
  }

  .mia-network-card
  .mia-member-meta {
    align-items: center;
  }

  /* ================= İŞ TALEBİ ================= */

  .mia-job-list {
    display: flex;
    flex-direction: column;

    gap: 14px;
  }

  .mia-job-card {
    padding: 0;

    display: flex;
  }

  .mia-job-card::before {
    display: none;
  }

  .mia-job-accent {
    width: 7px;

    flex: 0 0 7px;

    background:
      linear-gradient(
        180deg,
        var(--mia-blue),
        var(--mia-orange)
      );
  }

  .mia-job-main {
    min-width: 0;

    padding: 20px;

    flex: 1;
  }

  .mia-job-head {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;

    gap: 18px;
  }

  .mia-job-head h3 {
    margin: 10px 0 7px;

    font-size: 20px;
  }

  .mia-job-head p {
    margin: 0;

    color: #52657a;

    line-height: 1.55;

    display: -webkit-box;

    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;

    overflow: hidden;
  }

  .mia-budget {
    padding: 12px;

    border:
      1px solid #e3eaf1;

    border-radius: 14px;

    background: #f8fbfe;

    text-align: right;
    white-space: nowrap;
  }

  .mia-budget small {
    display: block;

    color: var(--mia-muted);

    font-size: 10px;
    font-weight: 900;

    text-transform: uppercase;
  }

  .mia-budget strong {
    display: block;

    margin-top: 4px;

    color: var(--mia-blue);

    font-size: 17px;
  }

  .mia-job-meta {
    margin: 15px 0;

    display: flex;

    gap: 15px;

    flex-wrap: wrap;

    color: #64748b;

    font-size: 12px;
  }

  .mia-job-owner {
    display: flex;
    align-items: center;

    gap: 9px;
  }

  .mia-job-card
  .mia-card-actions {
    margin-top: -38px;

    justify-content: flex-end;
  }

  /* ================= MODAL ================= */

  .mia-modal-backdrop {
    padding: 20px;

    position: fixed;
    inset: 0;
    z-index: 10000;

    display: grid;
    place-items: center;

    background:
      rgba(8, 20, 36, 0.63);

    backdrop-filter:
      blur(7px);

    animation:
      miaFade 0.18s ease;
  }

  .mia-modal {
    width:
      min(1100px, 100%);

    max-height: 92vh;

    border-radius: 24px;

    background: #f7faff;

    box-shadow:
      0 35px 100px
      rgba(0, 0, 0, 0.34);

    overflow: hidden;

    animation:
      miaModal 0.24s ease;
  }

  .mia-modal-medium {
    width:
      min(680px, 100%);
  }

  .mia-modal-head {
    padding: 20px 22px;

    display: flex;
    align-items: flex-start;
    justify-content: space-between;

    gap: 15px;

    color: #ffffff;

    background:
      linear-gradient(
        125deg,
        #073866,
        var(--mia-blue)
      );
  }

  .mia-modal-head h2 {
    margin: 0;

    font-size: 23px;
  }

  .mia-modal-head p {
    margin: 5px 0 0;

    color: #cfe8fb;
  }

  .mia-modal-close {
    width: 38px;
    height: 38px;

    border:
      1px solid
      rgba(255, 255, 255, 0.25);

    border-radius: 12px;

    color: #ffffff;

    background:
      rgba(255, 255, 255, 0.12);

    font-size: 24px;

    cursor: pointer;
  }

  .mia-modal-body {
    max-height:
      calc(92vh - 86px);

    padding: 20px;

    overflow: auto;
  }

  .mia-modal-grid {
    display: grid;

    grid-template-columns:
      1.35fr 0.65fr;

    gap: 16px;
  }

  .mia-detail-panel {
    min-width: 0;
  }

  .mia-profile-hero {
    display: flex;
    align-items: center;

    gap: 15px;
  }

  .mia-profile-hero h3 {
    margin: 0;

    font-size: 25px;
  }

  .mia-profile-hero p {
    margin: 5px 0;

    color: var(--mia-muted);
  }

  .mia-control-panel {
    display: flex;
    flex-direction: column;

    gap: 12px;
  }

  .mia-control-panel h3 {
    margin: 0 0 4px;
  }

  .mia-info-grid {
    margin: 16px 0;

    display: grid;

    grid-template-columns:
      repeat(
        3,
        minmax(0, 1fr)
      );

    gap: 10px;
  }

  .mia-info {
    padding: 11px;

    border:
      1px solid #e2e9f0;

    border-radius: 13px;

    background: #ffffff;
  }

  .mia-info span {
    display: block;

    color: var(--mia-muted);

    font-size: 10px;
    font-weight: 900;

    text-transform: uppercase;
  }

  .mia-info strong {
    display: block;

    margin-top: 5px;

    font-size: 13px;

    overflow-wrap: anywhere;
  }

  .mia-text-box {
    margin: 10px 0;
    padding: 14px;

    border:
      1px solid #e2e9f0;

    border-radius: 15px;

    background: #ffffff;
  }

  .mia-text-box strong {
    color: var(--mia-blue);
  }

  .mia-text-box p {
    margin: 7px 0 0;

    color: #52657a;

    line-height: 1.65;
    white-space: pre-wrap;
  }

  .mia-profile-cover {
    height: 160px;

    border-radius: 18px;

    background:
      linear-gradient(
        125deg,
        var(--mia-blue),
        var(--mia-blue-2)
      );

    background-size: cover;
    background-position: center;
  }

  .mia-profile-hero-overlap {
    margin: -48px 16px 0;
    padding: 14px;

    position: relative;

    border-radius: 18px;

    background: #ffffff;

    box-shadow:
      0 13px 30px
      rgba(15, 35, 63, 0.13);
  }

  .mia-subtitle {
    margin: 18px 0 8px;

    font-size: 16px;
  }

  .mia-review {
    padding: 13px;

    border:
      1px solid #e1e8ef;

    border-radius: 14px;

    background: #ffffff;
  }

  .mia-review > div {
    display: flex;
    justify-content: space-between;

    gap: 12px;
  }

  .mia-review span {
    color: var(--mia-orange);

    font-weight: 1000;
  }

  .mia-review p {
    margin: 7px 0;

    color: #52657a;
  }

  .mia-review small {
    color: var(--mia-muted);
  }

  /* ================= FORM GRID ================= */

  .mia-form-stack {
    display: flex;
    flex-direction: column;

    gap: 16px;
  }

  .mia-form-grid {
    display: grid;

    grid-template-columns:
      repeat(
        2,
        minmax(0, 1fr)
      );

    gap: 13px;
  }

  .mia-span-2 {
    grid-column: span 2;
  }

  .mia-toggle-grid {
    display: grid;

    grid-template-columns:
      repeat(
        3,
        minmax(0, 1fr)
      );

    gap: 10px;
  }

  .mia-toggle-grid-settings {
    grid-template-columns:
      repeat(
        2,
        minmax(0, 1fr)
      );
  }

  .mia-toggle-row {
    padding: 12px;

    display: flex;
    align-items: center;
    justify-content: space-between;

    gap: 12px;

    border:
      1px solid #dfe7ef;

    border-radius: 14px;

    background: #fbfdff;

    position: relative;

    cursor: pointer;
  }

  .mia-toggle-row >
  span:first-child {
    display: flex;
    flex-direction: column;

    gap: 3px;
  }

  .mia-toggle-row strong {
    font-size: 13px;
  }

  .mia-toggle-row small {
    color: var(--mia-muted);
  }

  .mia-toggle-row input {
    position: absolute;

    opacity: 0;

    pointer-events: none;
  }

  .mia-switch {
    width: 42px;
    height: 24px;

    flex: 0 0 42px;

    border-radius: 999px;

    background: #cbd5e1;

    position: relative;

    transition:
      background 0.2s ease;
  }

  .mia-switch::after {
    content: "";

    width: 18px;
    height: 18px;

    position: absolute;
    left: 3px;
    top: 3px;

    border-radius: 50%;

    background: #ffffff;

    box-shadow:
      0 2px 5px
      rgba(0, 0, 0, 0.18);

    transition:
      transform 0.2s ease;
  }

  .mia-toggle-row
  input:checked +
  .mia-switch {
    background:
      linear-gradient(
        90deg,
        var(--mia-blue),
        var(--mia-blue-2)
      );
  }

  .mia-toggle-row
  input:checked +
  .mia-switch::after {
    transform:
      translateX(18px);
  }

  .mia-settings-footer {
    margin-top: 18px;
    padding-top: 16px;

    display: flex;
    align-items: flex-end;
    justify-content: space-between;

    gap: 15px;

    border-top:
      1px solid
      var(--mia-line);
  }

  .mia-settings-footer
  .mia-field {
    width:
      min(400px, 100%);
  }

  .mia-profile-form-card {
    display: flex;
    flex-direction: column;

    gap: 20px;
  }

  .mia-form-section {
    padding-bottom: 20px;

    border-bottom:
      1px solid #e6edf4;
  }

  .mia-form-section:last-of-type {
    border-bottom: 0;
  }

  .mia-form-section h3 {
    margin: 0 0 14px;

    color: var(--mia-blue);

    font-size: 15px;

    letter-spacing: 0.02em;
  }

  /* ================= KATALOG ================= */

  .mia-catalog-layout {
    display: grid;

    grid-template-columns:
      repeat(
        3,
        minmax(0, 1fr)
      );

    gap: 16px;
  }

  .mia-catalog-list {
    max-height: 620px;

    padding-right: 4px;

    overflow: auto;
  }

  .mia-catalog-item {
    padding: 10px;

    display: flex;
    align-items: center;

    gap: 10px;

    border:
      1px solid #e4ebf2;

    border-radius: 14px;

    background: #fbfdff;
  }

  .mia-catalog-item >
  button {
    width: 32px;
    height: 32px;

    border: 0;
    border-radius: 10px;

    color: var(--mia-blue);
    background: #eaf3fb;

    font-weight: 1000;

    cursor: pointer;
  }

  .mia-catalog-item >
  button.danger {
    color: var(--mia-red);
    background: #fff0f0;
  }

  .mia-catalog-icon {
    width: 38px;
    height: 38px;

    display: grid;
    place-items: center;

    border-radius: 12px;

    color: #ffffff;
    background: var(--mia-blue);

    font-weight: 1000;
  }

  .mia-catalog-orange {
    background:
      var(--mia-orange);
  }

  /* ================= TEKLİF ================= */

  .mia-job-summary {
    display: flex;
    justify-content: space-between;

    gap: 15px;
  }

  .mia-job-summary h3 {
    margin: 10px 0 6px;
  }

  .mia-job-summary p {
    margin: 0;

    color: var(--mia-muted);
  }

  .mia-offer-card p {
    color: #52657a;

    line-height: 1.6;
  }

  .mia-offer-head {
    display: flex;
    align-items: center;
    justify-content: space-between;

    gap: 12px;
  }

  /* ================= PAGINATION ================= */

  .mia-pagination {
    display: flex;
    align-items: center;
    justify-content: center;

    gap: 15px;

    flex-wrap: wrap;

    color: var(--mia-muted);

    font-size: 13px;
  }

  /* ================= EMPTY ================= */

  .mia-empty {
    padding: 24px;

    color: var(--mia-muted);

    text-align: center;
  }

  .mia-empty-icon {
    width: 52px;
    height: 52px;

    margin: 0 auto 10px;

    display: grid;
    place-items: center;

    border-radius: 18px;

    color: var(--mia-blue);
    background: #edf4fa;

    font-size: 27px;
  }

  .mia-empty h3 {
    margin: 0;

    color: var(--mia-ink);
  }

  .mia-empty p {
    margin: 7px 0 0;
  }

  /* ================= ALERT ================= */

  .mia-alert {
    width: 100%;
    max-width: 1500px;

    margin: 14px auto 0;
    padding: 13px 15px;

    display: flex;
    align-items: center;

    gap: 10px;

    border: 1px solid;
    border-radius: 15px;
  }

  .mia-alert b {
    width: 28px;
    height: 28px;

    display: grid;
    place-items: center;

    border-radius: 9px;
  }

  .mia-alert button {
    margin-left: auto;

    border: 0;

    background: transparent;

    font-size: 18px;

    cursor: pointer;
  }

  .mia-alert-danger {
    color: #a91c1c;

    border-color: #fecaca;
    background: #fff4f4;
  }

  .mia-alert-danger b {
    background: #fee2e2;
  }

  .mia-alert-warning {
    color: #92500c;

    border-color: #fed7aa;
    background: #fff8ee;
  }

  .mia-alert-warning b {
    background: #ffedd5;
  }

  /* ================= TOAST ================= */

  .mia-toast {
    max-width:
      min(
        420px,
        calc(100vw - 32px)
      );

    padding: 13px 16px;

    position: fixed;
    right: 22px;
    top: 22px;
    z-index: 12000;

    display: flex;
    align-items: center;

    gap: 10px;

    border-radius: 14px;

    color: #ffffff;

    font-weight: 850;

    box-shadow:
      0 18px 45px
      rgba(0, 0, 0, 0.25);

    animation:
      miaToast 0.25s ease;
  }

  .mia-toast-success {
    background:
      linear-gradient(
        135deg,
        #15803d,
        #22c55e
      );
  }

  .mia-toast-error {
    background:
      linear-gradient(
        135deg,
        #991b1b,
        #ef4444
      );
  }

  /* ================= LOADING ================= */

  .mia-saving {
    position: fixed;
    inset: 0;
    z-index: 11900;

    background:
      rgba(255, 255, 255, 0.2);

    pointer-events: none;
  }

  .mia-saving span {
    width: 35%;
    height: 4px;

    position: absolute;
    left: 0;
    top: 0;

    background:
      linear-gradient(
        90deg,
        var(--mia-blue),
        var(--mia-orange)
      );

    animation:
      miaLoadingBar 1.1s infinite;
  }

  .mia-full-loader {
    min-height: 70vh;

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    gap: 14px;

    color: var(--mia-blue);
  }

  .mia-loader-logo {
    width: 74px;
    height: 74px;

    display: grid;
    place-items: center;

    border-radius: 24px;

    color: #ffffff;

    background:
      linear-gradient(
        145deg,
        var(--mia-blue),
        var(--mia-blue-2)
      );

    box-shadow:
      0 18px 45px
      rgba(11, 77, 139, 0.25);

    font-size: 34px;
    font-weight: 1000;

    animation:
      miaFloat 1.8s
      ease-in-out infinite;
  }

  .mia-full-loader > span {
    width: 150px;
    height: 7px;

    border-radius: 999px;

    background: #dbe7f1;

    position: relative;

    overflow: hidden;
  }

  .mia-full-loader >
  span::after {
    content: "";

    width: 45%;

    position: absolute;
    inset: 0;

    background:
      linear-gradient(
        90deg,
        var(--mia-blue),
        var(--mia-orange)
      );

    animation:
      miaLoadingBar 1.1s infinite;
  }

  .mia-loading-grid {
    display: grid;

    grid-template-columns:
      repeat(
        3,
        minmax(0, 1fr)
      );

    gap: 16px;
  }

  .mia-skeleton {
    height: 180px;

    border-radius: 22px;

    background:
      linear-gradient(
        90deg,
        #edf2f7 25%,
        #f8fafc 40%,
        #edf2f7 60%
      );

    background-size:
      300% 100%;

    animation:
      miaShimmer 1.3s infinite;
  }

  .mia-error-card {
    max-width: 700px;

    margin: 10vh auto;

    text-align: center;
  }

  .mia-animate-in {
    animation:
      miaFadeUp 0.28s ease;
  }

  /* ================= ANİMASYON ================= */

  @keyframes miaPulse {
    50% {
      box-shadow:
        0 0 0 9px
        rgba(22, 163, 74, 0);
    }
  }

  @keyframes miaGrow {
    from {
      width: 0;
    }
  }

  @keyframes miaFade {
    from {
      opacity: 0;
    }
  }

  @keyframes miaModal {
    from {
      opacity: 0;

      transform:
        translateY(12px)
        scale(0.985);
    }
  }

  @keyframes miaFadeUp {
    from {
      opacity: 0;

      transform:
        translateY(10px);
    }
  }

  @keyframes miaToast {
    from {
      opacity: 0;

      transform:
        translateX(15px);
    }
  }

  @keyframes miaLoadingBar {
    from {
      transform:
        translateX(-120%);
    }

    to {
      transform:
        translateX(390%);
    }
  }

  @keyframes miaFloat {
    50% {
      transform:
        translateY(-7px);
    }
  }

  @keyframes miaShimmer {
    0% {
      background-position:
        100% 0;
    }

    100% {
      background-position:
        -100% 0;
    }
  }

  /* ================= RESPONSIVE 1200 ================= */

  @media (max-width: 1200px) {
    .mia-stats-grid {
      grid-template-columns:
        repeat(
          2,
          minmax(0, 1fr)
        );
    }

    .mia-member-grid {
      grid-template-columns:
        repeat(
          2,
          minmax(0, 1fr)
        );
    }

    .mia-network-grid {
      grid-template-columns:
        repeat(
          3,
          minmax(0, 1fr)
        );
    }

    .mia-catalog-layout {
      grid-template-columns:
        1fr 1fr;
    }

    .mia-catalog-layout >
    .mia-card:last-child {
      grid-column: span 2;
    }

    .mia-filter-grid {
      grid-template-columns:
        2fr
        repeat(
          2,
          minmax(140px, 1fr)
        );
    }

    .mia-filter-actions {
      grid-column: span 3;
    }

    .mia-three-column {
      grid-template-columns:
        1fr 1fr;
    }

    .mia-three-column >
    .mia-card:last-child {
      grid-column: span 2;
    }
  }

  /* ================= RESPONSIVE 900 ================= */

  @media (max-width: 900px) {
    .mia-page {
      padding: 10px;
    }

    .mia-hero {
      min-height: 220px;

      padding: 24px 20px;

      align-items: flex-start;
    }

    .mia-hero-main {
      align-items: flex-start;
    }

    .mia-brand-mark {
      width: 60px;
      height: 60px;

      flex-basis: 60px;
    }

    .mia-brand-mark span {
      font-size: 30px;
    }

    .mia-hero-actions {
      position: absolute;
      right: 16px;
      bottom: 16px;

      flex-direction: row;
      align-items: center;
    }

    .mia-tabs {
      margin-top: -18px;

      border-radius: 16px;
    }

    .mia-tabs button {
      padding: 11px 13px;
    }

    .mia-two-column,
    .mia-modal-grid {
      grid-template-columns: 1fr;
    }

    .mia-network-grid {
      grid-template-columns:
        repeat(
          2,
          minmax(0, 1fr)
        );
    }

    .mia-catalog-layout {
      grid-template-columns: 1fr;
    }

    .mia-catalog-layout >
    .mia-card:last-child {
      grid-column: auto;
    }

    .mia-form-grid {
      grid-template-columns: 1fr;
    }

    .mia-span-2 {
      grid-column: auto;
    }

    .mia-toggle-grid,
    .mia-toggle-grid-settings {
      grid-template-columns:
        1fr 1fr;
    }

    .mia-info-grid {
      grid-template-columns:
        repeat(
          2,
          minmax(0, 1fr)
        );
    }

    .mia-job-card
    .mia-card-actions {
      margin-top: 15px;

      justify-content: flex-start;
    }

    .mia-job-head {
      flex-direction: column;
    }

    .mia-budget {
      text-align: left;
    }

    .mia-three-column {
      grid-template-columns: 1fr;
    }

    .mia-three-column >
    .mia-card:last-child {
      grid-column: auto;
    }
  }

  /* ================= RESPONSIVE MOBILE ================= */

  @media (max-width: 620px) {
    .mia-page {
      padding: 8px;
    }

    .mia-hero {
      min-height: 270px;

      border-radius: 20px;
    }

    .mia-hero-main {
      gap: 12px;
    }

    .mia-brand-mark {
      width: 48px;
      height: 48px;

      flex-basis: 48px;

      border-radius: 16px;
    }

    .mia-brand-mark span {
      font-size: 25px;
    }

    .mia-hero h1 {
      font-size: 27px;
    }

    .mia-hero p {
      font-size: 13px;
      line-height: 1.5;
    }

    .mia-hero-actions {
      left: 16px;
      right: 16px;

      justify-content:
        space-between;
    }

    .mia-lang-switch button {
      padding: 7px 10px;
    }

    .mia-tabs {
      padding: 5px;

      gap: 3px;
    }

    .mia-tabs button {
      padding: 10px 12px;
    }

    .mia-tabs button span:last-child {
      font-size: 12px;
    }

    .mia-content {
      padding-top: 15px;
    }

    .mia-stats-grid,
    .mia-member-grid,
    .mia-network-grid,
    .mia-loading-grid {
      grid-template-columns: 1fr;
    }

    .mia-filter-grid,
    .mia-filter-grid-network {
      grid-template-columns: 1fr;
    }

    .mia-filter-actions {
      grid-column: auto;
    }

    .mia-card {
      padding: 16px;

      border-radius: 18px;
    }

    .mia-section-title,
    .mia-section-title-actions {
      align-items: flex-start;

      flex-direction: column;
    }

    .mia-section-title-actions >
    .mia-btn,
    .mia-section-title-actions >
    .mia-inline-actions {
      width: 100%;
    }

    .mia-inline-actions
    .mia-btn {
      flex: 1;
    }

    .mia-toggle-grid,
    .mia-toggle-grid-settings,
    .mia-info-grid {
      grid-template-columns: 1fr;
    }

    .mia-settings-footer {
      align-items: stretch;

      flex-direction: column;
    }

    .mia-settings-footer
    .mia-field {
      width: 100%;
    }

    .mia-modal-backdrop {
      padding: 0;
    }

    .mia-modal {
      width: 100%;
      height: 100dvh;
      max-height: 100dvh;

      border-radius: 0;
    }

    .mia-modal-body {
      max-height:
        calc(100dvh - 82px);

      padding: 14px;
    }

    .mia-modal-head {
      padding: 17px;
    }

    .mia-profile-hero {
      align-items: flex-start;

      flex-wrap: wrap;
    }

    .mia-profile-hero-overlap {
      margin: -42px 8px 0;
    }

    .mia-job-main {
      padding: 16px;
    }

    .mia-job-meta {
      flex-direction: column;

      gap: 9px;
    }

    .mia-job-summary {
      flex-direction: column;
    }

    .mia-toast {
      max-width: none;

      left: 12px;
      right: 12px;
      top: 12px;
    }

    .mia-avatar-xlarge {
      width: 78px;
      height: 78px;
    }

    .mia-section-title h2,
    .mia-card-head h2 {
      font-size: 20px;
    }
  }

  /* ======================================================
     KURUMSAL RESPONSIVE DÜZEN
     Yalnızca görünümü düzenler; API ve veri akışını etkilemez.
  ====================================================== */

  .mia-page {
    min-width: 0;
    padding: clamp(12px, 1.35vw, 24px);
  }

  .mia-hero,
  .mia-tabs,
  .mia-content,
  .mia-alert {
    width: 100%;
    max-width: none;
  }

  .mia-content,
  .mia-section-stack,
  .mia-card,
  .mia-card > *,
  .mia-job-main,
  .mia-member-body,
  .mia-detail-panel,
  .mia-control-panel {
    min-width: 0;
  }

  .mia-hero {
    min-height: 176px;
    padding: clamp(24px, 2.2vw, 36px);
    border-radius: 24px;
  }

  .mia-hero-main > div:last-child,
  .mia-section-title > div,
  .mia-card-head > div,
  .mia-job-head > div,
  .mia-job-owner > div,
  .mia-compact-item > div {
    min-width: 0;
  }

  .mia-hero h1,
  .mia-hero p,
  .mia-section-title h2,
  .mia-section-title p,
  .mia-card h2,
  .mia-card h3,
  .mia-card p,
  .mia-info strong,
  .mia-company-line {
    overflow-wrap: anywhere;
  }

  .mia-tabs {
    justify-content: flex-start;
  }

  .mia-tabs button {
    flex: 1 1 auto;
    min-width: max-content;
  }

  .mia-card {
    width: 100%;
    max-width: 100%;
  }

  .mia-member-grid,
  .mia-network-grid,
  .mia-stats-grid,
  .mia-two-column,
  .mia-three-column,
  .mia-catalog-layout,
  .mia-form-grid,
  .mia-filter-grid,
  .mia-filter-grid-network,
  .mia-toggle-grid,
  .mia-toggle-grid-settings,
  .mia-info-grid,
  .mia-modal-grid {
    width: 100%;
    min-width: 0;
  }

  .mia-member-card,
  .mia-network-card,
  .mia-stat,
  .mia-job-card {
    height: 100%;
  }

  .mia-member-body {
    display: flex;
    flex-direction: column;
    height: calc(100% - 82px);
  }

  .mia-member-body > .mia-btn {
    margin-top: auto;
  }

  .mia-network-card {
    display: flex;
    flex-direction: column;
  }

  .mia-network-card > .mia-btn,
  .mia-network-card > .mia-card-actions {
    margin-top: auto;
  }

  .mia-inline-actions,
  .mia-card-actions,
  .mia-form-actions,
  .mia-filter-actions,
  .mia-network-actions {
    max-width: 100%;
  }

  .mia-job-card .mia-card-actions {
    margin-top: 16px;
    justify-content: flex-end;
  }

  .mia-btn {
    max-width: 100%;
    white-space: normal;
    text-align: center;
  }

  .mia-field input,
  .mia-field select,
  .mia-field textarea {
    min-width: 0;
  }

  .mia-catalog-item .mia-grow,
  .mia-compact-item .mia-grow,
  .mia-job-owner .mia-grow {
    min-width: 0;
  }

  @media (min-width: 1680px) {
    .mia-member-grid {
      grid-template-columns: repeat(4, minmax(0, 1fr));
    }

    .mia-content {
      padding-top: 26px;
    }
  }

  @media (min-width: 1201px) and (max-width: 1510px) {
    .mia-filter-grid {
      grid-template-columns: 2fr repeat(4, minmax(118px, 1fr));
    }

    .mia-filter-actions {
      grid-column: 1 / -1;
      justify-content: flex-end;
    }

    .mia-network-grid {
      grid-template-columns: repeat(3, minmax(0, 1fr));
    }
  }

  @media (min-width: 901px) and (max-width: 1200px) {
    .mia-page {
      padding: 14px;
    }

    .mia-hero {
      min-height: 184px;
    }

    .mia-filter-grid,
    .mia-filter-grid-network {
      grid-template-columns: repeat(3, minmax(0, 1fr));
    }

    .mia-filter-grid > .mia-field:first-child,
    .mia-filter-grid-network > .mia-field:first-child {
      grid-column: span 2;
    }

    .mia-filter-actions {
      grid-column: 1 / -1;
      justify-content: flex-end;
    }

    .mia-job-card .mia-card-actions {
      margin-top: 16px;
    }
  }

  @media (max-width: 900px) {
    .mia-page {
      width: 100%;
      max-width: 100%;
      padding: 10px;
      overflow-x: clip;
    }

    .mia-hero {
      min-height: 0;
      padding: 22px 18px 18px;
      display: block;
      border-radius: 20px;
    }

    .mia-hero-main {
      display: grid;
      grid-template-columns: 56px minmax(0, 1fr);
      gap: 14px;
    }

    .mia-brand-mark {
      width: 56px;
      height: 56px;
      flex-basis: 56px;
      border-radius: 17px;
    }

    .mia-hero h1 {
      font-size: clamp(25px, 7vw, 34px);
      line-height: 1.08;
    }

    .mia-hero p {
      max-width: none;
      margin-top: 9px;
    }

    .mia-hero-actions {
      width: 100%;
      margin-top: 18px;
      position: relative;
      inset: auto;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      gap: 10px;
    }

    .mia-hero-actions > .mia-btn {
      min-height: 42px;
    }

    .mia-tabs {
      margin-top: -8px;
      padding: 6px;
      border-radius: 15px;
      scroll-snap-type: x proximity;
    }

    .mia-tabs button {
      flex: 0 0 auto;
      min-height: 44px;
      scroll-snap-align: start;
    }

    .mia-content {
      padding: 16px 0 72px;
    }

    .mia-filter-grid,
    .mia-filter-grid-network {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }

    .mia-filter-grid > .mia-field:first-child,
    .mia-filter-grid-network > .mia-field:first-child,
    .mia-filter-actions {
      grid-column: 1 / -1;
    }

    .mia-filter-actions {
      justify-content: stretch;
    }

    .mia-filter-actions .mia-btn {
      flex: 1 1 0;
    }

    .mia-section-title-actions {
      align-items: flex-start;
    }

    .mia-job-card .mia-card-actions {
      margin-top: 14px;
      justify-content: flex-start;
    }

    .mia-job-head,
    .mia-offer-head,
    .mia-job-summary,
    .mia-settings-footer {
      align-items: stretch;
    }
  }

  @media (max-width: 620px) {
    .mia-page {
      padding: 7px;
    }

    .mia-hero {
      padding: 18px 14px 14px;
      border-radius: 17px;
    }

    .mia-hero-main {
      grid-template-columns: 44px minmax(0, 1fr);
      gap: 11px;
    }

    .mia-brand-mark {
      width: 44px;
      height: 44px;
      flex-basis: 44px;
      border-radius: 14px;
    }

    .mia-brand-mark span {
      font-size: 23px;
    }

    .mia-eyebrow {
      margin-bottom: 5px;
      font-size: 9px;
      line-height: 1.4;
      letter-spacing: 0.11em;
    }

    .mia-hero h1 {
      font-size: clamp(22px, 7.2vw, 29px);
    }

    .mia-hero p {
      font-size: 12.5px;
      line-height: 1.5;
    }

    .mia-hero-actions {
      margin-top: 14px;
      flex-wrap: wrap;
    }

    .mia-lang-switch {
      flex: 0 0 auto;
    }

    .mia-hero-actions > .mia-btn {
      flex: 1 1 125px;
    }

    .mia-tabs {
      width: 100%;
      max-width: 100%;
    }

    .mia-tabs button {
      padding: 9px 11px;
    }

    .mia-filter-grid,
    .mia-filter-grid-network,
    .mia-stats-grid,
    .mia-member-grid,
    .mia-network-grid,
    .mia-loading-grid,
    .mia-form-grid,
    .mia-toggle-grid,
    .mia-toggle-grid-settings,
    .mia-info-grid,
    .mia-catalog-layout {
      grid-template-columns: minmax(0, 1fr);
    }

    .mia-filter-grid > *,
    .mia-filter-grid-network > *,
    .mia-form-grid > *,
    .mia-span-2 {
      grid-column: auto;
    }

    .mia-card {
      padding: 15px;
      border-radius: 17px;
    }

    .mia-member-card,
    .mia-job-card {
      padding: 0;
    }

    .mia-member-body {
      padding: 0 15px 15px;
    }

    .mia-job-main {
      padding: 15px;
    }

    .mia-field input,
    .mia-field select,
    .mia-field textarea {
      min-height: 46px;
      font-size: 16px;
    }

    .mia-section-title,
    .mia-section-title-actions,
    .mia-card-head,
    .mia-job-head,
    .mia-job-summary,
    .mia-offer-head,
    .mia-profile-manager-card,
    .mia-settings-footer {
      width: 100%;
      align-items: stretch;
      flex-direction: column;
    }

    .mia-inline-actions,
    .mia-card-actions,
    .mia-form-actions,
    .mia-filter-actions,
    .mia-network-actions {
      width: 100%;
      display: grid;
      grid-template-columns: minmax(0, 1fr);
      gap: 8px;
    }

    .mia-inline-actions .mia-btn,
    .mia-card-actions .mia-btn,
    .mia-form-actions .mia-btn,
    .mia-filter-actions .mia-btn,
    .mia-network-actions .mia-btn,
    .mia-section-title-actions > .mia-btn {
      width: 100%;
      min-height: 44px;
    }

    .mia-job-card .mia-card-actions {
      margin-top: 14px;
      display: grid;
    }

    .mia-compact-item {
      align-items: flex-start;
      flex-wrap: wrap;
    }

    .mia-compact-item .mia-grow {
      flex: 1 1 calc(100% - 105px);
    }

    .mia-score {
      width: 100%;
      padding-top: 8px;
      border-top: 1px solid var(--mia-line);
      text-align: left;
    }

    .mia-catalog-item {
      align-items: center;
      flex-wrap: wrap;
    }

    .mia-catalog-item .mia-grow {
      flex: 1 1 calc(100% - 55px);
    }

    .mia-modal-head h2 {
      font-size: 20px;
      overflow-wrap: anywhere;
    }

    .mia-modal-body {
      padding: 12px;
    }

    .mia-toast {
      left: 8px;
      right: 8px;
      top: 8px;
    }
  }

  /* ======================================================
     NİHAİ EKRAN GENİŞLİĞİ DÜZELTMESİ
     Parent panel geniş olsa bile mobil içerik viewport dışına çıkamaz.
  ====================================================== */

  @media (min-width: 901px) {
    .mia-page {
      width: 100%;
      max-width: 100%;
      min-width: 0;
      overflow-x: hidden;
    }

    .mia-hero,
    .mia-tabs,
    .mia-content,
    .mia-alert {
      width: 100%;
      max-width: none;
    }

    .mia-hero-main {
      min-width: 0;
      flex: 1 1 auto;
    }

    .mia-hero-actions {
      flex: 0 0 auto;
    }

    .mia-tabs button {
      flex: 1 1 0;
      min-width: 118px;
    }
  }

  @media (max-width: 900px) {
    html,
    body {
      max-width: 100%;
      overflow-x: hidden;
    }

    .mia-page {
      width: 100vw;
      width: 100dvw;
      max-width: 100vw;
      max-width: 100dvw;
      min-width: 0;
      margin: 0;
      padding: 8px;
      overflow-x: hidden;
      contain: inline-size;
    }

    .mia-page > *,
    .mia-content > *,
    .mia-section-stack > *,
    .mia-card > * {
      min-width: 0;
      max-width: 100%;
    }

    .mia-hero,
    .mia-tabs,
    .mia-content,
    .mia-alert,
    .mia-section-stack,
    .mia-card,
    .mia-filter-card {
      width: 100%;
      max-width: 100%;
      min-width: 0;
    }

    .mia-hero {
      min-height: 0;
      padding: 18px 14px 14px;
      display: block;
      overflow: hidden;
      border-radius: 18px;
    }

    .mia-hero-main {
      width: 100%;
      max-width: 100%;
      min-width: 0;
      display: grid;
      grid-template-columns: 48px minmax(0, 1fr);
      align-items: start;
      gap: 11px;
    }

    .mia-hero-main > div:last-child {
      width: 100%;
      max-width: 100%;
      min-width: 0;
      overflow: hidden;
    }

    .mia-brand-mark {
      width: 48px;
      height: 48px;
      min-width: 48px;
      max-width: 48px;
      flex-basis: 48px;
      border-radius: 15px;
    }

    .mia-brand-mark span {
      font-size: 24px;
    }

    .mia-eyebrow {
      max-width: 100%;
      margin-bottom: 5px;
      font-size: 9px;
      line-height: 1.4;
      letter-spacing: 0.1em;
      white-space: normal;
      overflow-wrap: anywhere;
    }

    .mia-hero h1 {
      width: 100%;
      max-width: 100%;
      margin: 0;
      font-size: clamp(23px, 7vw, 30px);
      line-height: 1.08;
      white-space: normal;
      overflow: visible;
      overflow-wrap: anywhere;
    }

    .mia-hero p {
      width: 100%;
      max-width: 100%;
      margin: 9px 0 0;
      font-size: 13px;
      line-height: 1.5;
      white-space: normal;
      overflow: visible;
      overflow-wrap: anywhere;
    }

    .mia-hero-actions {
      width: 100%;
      max-width: 100%;
      min-width: 0;
      margin-top: 14px;
      position: relative;
      inset: auto;
      display: grid;
      grid-template-columns: auto minmax(0, 1fr);
      align-items: center;
      gap: 9px;
    }

    .mia-lang-switch {
      width: max-content;
      max-width: 100%;
      min-width: 0;
    }

    .mia-lang-switch button {
      padding: 7px 9px;
    }

    .mia-hero-actions > .mia-btn {
      width: 100%;
      max-width: 100%;
      min-width: 0;
      min-height: 42px;
      margin: 0;
      padding-left: 10px;
      padding-right: 10px;
    }

    .mia-tabs {
      width: 100%;
      max-width: 100%;
      min-width: 0;
      margin-top: -7px;
      padding: 5px;
      display: flex;
      justify-content: flex-start;
      gap: 4px;
      overflow-x: auto;
      overflow-y: hidden;
      overscroll-behavior-x: contain;
      scroll-snap-type: x proximity;
      border-radius: 15px;
    }

    .mia-tabs button {
      flex: 0 0 auto;
      min-width: max-content;
      min-height: 43px;
      padding: 9px 11px;
      scroll-snap-align: start;
    }

    .mia-content {
      padding: 16px 0 70px;
      overflow: visible;
    }

    .mia-filter-card {
      padding: 14px;
      overflow: hidden;
    }

    .mia-filter-grid,
    .mia-filter-grid-network {
      width: 100%;
      max-width: 100%;
      min-width: 0;
      display: flex;
      flex-direction: column;
      align-items: stretch;
      gap: 12px;
    }

    .mia-filter-grid > *,
    .mia-filter-grid-network > *,
    .mia-field {
      width: 100%;
      max-width: 100%;
      min-width: 0;
      grid-column: auto;
    }

    .mia-field input,
    .mia-field select,
    .mia-field textarea {
      display: block;
      width: 100%;
      max-width: 100%;
      min-width: 0;
      box-sizing: border-box;
      font-size: 16px;
    }

    .mia-filter-actions {
      width: 100%;
      max-width: 100%;
      display: grid;
      grid-template-columns: minmax(0, 1fr);
    }

    .mia-filter-actions .mia-btn {
      width: 100%;
      min-width: 0;
    }

    .mia-stats-grid,
    .mia-member-grid,
    .mia-network-grid,
    .mia-loading-grid,
    .mia-two-column,
    .mia-three-column,
    .mia-catalog-layout,
    .mia-form-grid,
    .mia-toggle-grid,
    .mia-toggle-grid-settings,
    .mia-info-grid,
    .mia-modal-grid {
      width: 100%;
      max-width: 100%;
      min-width: 0;
      grid-template-columns: minmax(0, 1fr);
    }

    .mia-card,
    .mia-member-card,
    .mia-network-card,
    .mia-job-card,
    .mia-catalog-item,
    .mia-compact-item {
      min-width: 0;
      max-width: 100%;
    }

    .mia-section-title,
    .mia-section-title-actions,
    .mia-card-head,
    .mia-job-head,
    .mia-job-summary,
    .mia-offer-head,
    .mia-profile-manager-card,
    .mia-settings-footer {
      width: 100%;
      max-width: 100%;
      min-width: 0;
      align-items: stretch;
      flex-direction: column;
    }

    .mia-inline-actions,
    .mia-card-actions,
    .mia-form-actions,
    .mia-network-actions {
      width: 100%;
      max-width: 100%;
      display: grid;
      grid-template-columns: minmax(0, 1fr);
      gap: 8px;
    }

    .mia-inline-actions .mia-btn,
    .mia-card-actions .mia-btn,
    .mia-form-actions .mia-btn,
    .mia-network-actions .mia-btn,
    .mia-section-title-actions > .mia-btn {
      width: 100%;
      max-width: 100%;
      min-width: 0;
      min-height: 44px;
    }

    .mia-job-card .mia-card-actions {
      margin-top: 14px;
    }
  }

  @media (max-width: 420px) {
    .mia-page {
      padding: 6px;
    }

    .mia-hero {
      padding: 16px 12px 12px;
    }

    .mia-hero-main {
      grid-template-columns: 42px minmax(0, 1fr);
      gap: 9px;
    }

    .mia-brand-mark {
      width: 42px;
      height: 42px;
      min-width: 42px;
      max-width: 42px;
      flex-basis: 42px;
    }

    .mia-hero h1 {
      font-size: clamp(21px, 6.8vw, 27px);
    }

    .mia-hero p {
      font-size: 12px;
    }

    .mia-lang-switch button {
      padding: 6px 8px;
      font-size: 12px;
    }

    .mia-card {
      padding: 14px;
      border-radius: 16px;
    }

    .mia-member-card,
    .mia-job-card {
      padding: 0;
    }
  }
`;
